
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexc12lWWApGWyNXJgXv_n52F4X5sWgpQEQcJAsjxyeEGAMeta } from "/builds/campinginfo/civ2-nuxt-3/app/pages/index.vue?macro=true";
import { default as indexNSC_1hUggbXy8EQ4GGSOzfdUZWH2V4hSygTvx3DD9foMeta } from "/builds/campinginfo/civ2-nuxt-3/app/pages/info/index.vue?macro=true";
import { default as index2KVoxolIfIOiXCvg2u5LIz0B97kqGdeIciLffAVwlZ0Meta } from "/builds/campinginfo/civ2-nuxt-3/app/pages/oauth/index.vue?macro=true";
import { default as indexjL5F8uyVFKB2Es_Z0CaTXuQuJDXwmpASTnvWGUge_84Meta } from "/builds/campinginfo/civ2-nuxt-3/app/pages/topic/index.vue?macro=true";
import { default as page_45is_45goneTrQjfMkJhBLvEQ4WPw0QSu_NgWgyUDUfPSK_J4zSn4cMeta } from "/builds/campinginfo/civ2-nuxt-3/app/pages/page-is-gone.vue?macro=true";
import { default as _91_46_46_46all_93tZquGhHXCTsE1WgLJQo84TsP3Xndou1iTh8naDyr7L0Meta } from "/builds/campinginfo/civ2-nuxt-3/app/pages/sea/[...all].vue?macro=true";
import { default as index_B7UejdnCW_h3id6jA7ey_bHa9dPS1Yd_iEJkiNBYX4Meta } from "/builds/campinginfo/civ2-nuxt-3/app/pages/search/index.vue?macro=true";
import { default as indexc6VkXRnjwsCSnsjS9uEKgV1NO7lGne1wCueU1rDOcrcMeta } from "/builds/campinginfo/civ2-nuxt-3/app/pages/account/index.vue?macro=true";
import { default as indexwsJTx7Lq2klDTAd4IqRgc7L4k04lwYABcoOjsgWElKwMeta } from "/builds/campinginfo/civ2-nuxt-3/app/pages/country/index.vue?macro=true";
import { default as _91_46_46_46all_93LzFrj9i8_v9dpFQKkL6dmvDH2Lo7NboQRNovPYynM3kMeta } from "/builds/campinginfo/civ2-nuxt-3/app/pages/info/[...all].vue?macro=true";
import { default as indexyAptwUOir9aCpZCRAx32AjM3IK7t29jq8dyHcLjjfTgMeta } from "/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/index.vue?macro=true";
import { default as _91_46_46_46all_93eF3a31klc3CxwHNKkjZq1NXnNdHpj2QoLZNqz7_WrOMMeta } from "/builds/campinginfo/civ2-nuxt-3/app/pages/topic/[...all].vue?macro=true";
import { default as indexcC_YwpQW2wza5shY4xyyAiOUCx43F7xc8O9luapV7fcMeta } from "/builds/campinginfo/civ2-nuxt-3/app/pages/searchMap/index.vue?macro=true";
import { default as indexSBCh5PkIAC_SO_RONs92Lw_2MOuoLREniqayUQ3EExAMeta } from "/builds/campinginfo/civ2-nuxt-3/app/pages/account/login/index.vue?macro=true";
import { default as index45hAQ5uQTu_JOOUvqQ89nY38OBI3Ml7_s0xnsFWwCUsMeta } from "/builds/campinginfo/civ2-nuxt-3/app/pages/account/media/index.vue?macro=true";
import { default as indexK45AeWl4ecTqgd8z8PcuOCU2ywwenRwBlqBXjO8cBHQMeta } from "/builds/campinginfo/civ2-nuxt-3/app/pages/popularRegion/index.vue?macro=true";
import { default as indexhlSN1VF0eQAzJDhyl1giArp_g0CQPDsWUoVGXJl13WkMeta } from "/builds/campinginfo/civ2-nuxt-3/app/pages/account/profile/index.vue?macro=true";
import { default as indexljWhkMatVk_QhDSJ_d2N6YcQytqyc1YnJt5svS4g7KQMeta } from "/builds/campinginfo/civ2-nuxt-3/app/pages/account/reviews/index.vue?macro=true";
import { default as index4IUqchCD6RD31oEGayz3Yw8Fg9HItLurOWm5yQP0Ao8Meta } from "/builds/campinginfo/civ2-nuxt-3/app/pages/city/[citySlug]/index.vue?macro=true";
import { default as indexSS_8eDuhxcj1DZk6mIC__3eC1jdCvFwfD5i4M7j2F_gMeta } from "/builds/campinginfo/civ2-nuxt-3/app/pages/account/register/index.vue?macro=true";
import { default as indexZNzV6LD_Tn_C1Bn0m2W05Jh57vqZtUIG1CZUN_1fHUsMeta } from "/builds/campinginfo/civ2-nuxt-3/app/pages/account/favorites/index.vue?macro=true";
import { default as index6WLVai_fq4iQO8JoU5gLoMSeqovN0BADiVfhAwnnsM0Meta } from "/builds/campinginfo/civ2-nuxt-3/app/pages/account/change-mail/index.vue?macro=true";
import { default as index_DXBtsq6QZ6pag4mXND2_wd1HXOakDbS0C0zk1cJu3YMeta } from "/builds/campinginfo/civ2-nuxt-3/app/pages/account/email-optin/index.vue?macro=true";
import { default as indexhUWB5KuZCkhGUZbO0va5vw3R_idd74fOd0lOYuyEAjkMeta } from "/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirmEmail/index.vue?macro=true";
import { default as indext7_QRrt7bfo4yMCAbfPnP_udVYU6f3GxEmDIJHh816YMeta } from "/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/index.vue?macro=true";
import { default as indexvt7EsgevNKYq7CLwuMN5WQxQ6wOB9yAQ9gbotVjwPMwMeta } from "/builds/campinginfo/civ2-nuxt-3/app/pages/country/[countrySlug]/index.vue?macro=true";
import { default as indexGmSdnK0m42VE940yNoOfYHxfQmlWQVf2xnziqt3zYvwMeta } from "/builds/campinginfo/civ2-nuxt-3/app/pages/account/reset-password/index.vue?macro=true";
import { default as indexE_Pm1dsMOdq_7i0fTZRF26yLIodbyqLVtgG1r_NAELQMeta } from "/builds/campinginfo/civ2-nuxt-3/app/pages/account/change-password/index.vue?macro=true";
import { default as indextB1WLRBm7XYsIucRV_s_Ka8Ip23oXZhCN4iQSujmsosMeta } from "/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirm-password/index.vue?macro=true";
import { default as indexv1sUHc7BCBXeHzBpiLqDGCVJZWB6NmFH4wHxLXg1jsYMeta } from "/builds/campinginfo/civ2-nuxt-3/app/pages/account/media/[identifier]/index.vue?macro=true";
import { default as indexHM_AkjSjeXo2qj_NAtLQAN5i8SoF5YAoThBOUTHmoo4Meta } from "/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/index.vue?macro=true";
import { default as indexUxKA0LBXCqZOaptHXPfgjSIoHyiWng63iFE1BZr_1rwMeta } from "/builds/campinginfo/civ2-nuxt-3/app/pages/popularRegion/[regionSlug]/index.vue?macro=true";
import { default as indexp_sjgyuWvL_ST02FWKCmVF_vBng6N4_HEDRC5SrnXhUMeta } from "/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/media/index.vue?macro=true";
import { default as index8Y6yK7cK2EI_Fyvojltskdt6oioV3l4iNS3lrHYw0dkMeta } from "/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirm-email-change/index.vue?macro=true";
import { default as indexw9sg5vp4gQj0Ee4wu_53oCjScnAgJIFkzF7n3KSY85MMeta } from "/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/index.vue?macro=true";
import { default as indexFyyxBkV6Cc6ildN_M_woPkaIMlUHHEsRgOZhXa2SqXIMeta } from "/builds/campinginfo/civ2-nuxt-3/app/pages/account/marketing-preferences/index.vue?macro=true";
import { default as indexiEzWrIZuM9qFVz2euzemkJjGEL4nFCJ7rmVy4vCKTdsMeta } from "/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/inquire/index.vue?macro=true";
import { default as index59eZ49_1yPXOPE2T6wLlMZsa5BjSA55VriH39YVlm2wMeta } from "/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/reviews/index.vue?macro=true";
import { default as indexRl66bNMvC8Lwk6WUGEDfH6_QJ_SQQHaEJyiIjcWtEwAMeta } from "/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/confirm/index.vue?macro=true";
import { default as index43_QEHFhVIoNbpA0FStNhOpSHZu37M31C0BRkkqYYzQMeta } from "/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/reviews/[id]/index.vue?macro=true";
import { default as indexow7ACKeRFOzzCTYnil6hF2SnK7zml44We882jG_jFxQMeta } from "/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rating-widget/index.vue?macro=true";
import { default as indexYlkBHWeblSRRjU_ONHpcs_AF72xBEho6Xlt7YCCNIE0Meta } from "/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/images/index.vue?macro=true";
import { default as indexAULkPrKRLN_27A4KVhklN6gtX0FKtYIkaXErYaQYkKwMeta } from "/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/videos/index.vue?macro=true";
import { default as indexAkqjXIc0vJUF9qWjMGsSC0ggd_pQD3HJEHc3QTiIdi0Meta } from "/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/inquire/confirm/index.vue?macro=true";
import { default as indexcQ9A78RUXw5BP1zmZ6_eRMyEncWBm1NfKR0WHJja_K0Meta } from "/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/confirm/oauth/index.vue?macro=true";
import { default as indexyJ8HlGWn1PMMReseE7aiA36_ER__KVh0D1lfQufjyaoMeta } from "/builds/campinginfo/civ2-nuxt-3/app/pages/country/[countrySlug]/[federalStateSlug]/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/index.vue")
  },
  {
    name: "index___nl",
    path: "/nl",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/index.vue")
  },
  {
    name: "index___it",
    path: "/it",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/index.vue")
  },
  {
    name: "index___bg",
    path: "/bg",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/index.vue")
  },
  {
    name: "index___bs",
    path: "/bs",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/index.vue")
  },
  {
    name: "index___cs",
    path: "/cs",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/index.vue")
  },
  {
    name: "index___da",
    path: "/da",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/index.vue")
  },
  {
    name: "index___el",
    path: "/el",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/index.vue")
  },
  {
    name: "index___et",
    path: "/et",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/index.vue")
  },
  {
    name: "index___fi",
    path: "/fi",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/index.vue")
  },
  {
    name: "index___hr",
    path: "/hr",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/index.vue")
  },
  {
    name: "index___hu",
    path: "/hu",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/index.vue")
  },
  {
    name: "index___lt",
    path: "/lt",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/index.vue")
  },
  {
    name: "index___lv",
    path: "/lv",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/index.vue")
  },
  {
    name: "index___no",
    path: "/no",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/index.vue")
  },
  {
    name: "index___pl",
    path: "/pl",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/index.vue")
  },
  {
    name: "index___pt",
    path: "/pt",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/index.vue")
  },
  {
    name: "index___ro",
    path: "/ro",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/index.vue")
  },
  {
    name: "index___ru",
    path: "/ru",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/index.vue")
  },
  {
    name: "index___sk",
    path: "/sk",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/index.vue")
  },
  {
    name: "index___sl",
    path: "/sl",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/index.vue")
  },
  {
    name: "index___sr",
    path: "/sr",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/index.vue")
  },
  {
    name: "index___sv",
    path: "/sv",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/index.vue")
  },
  {
    name: "index___tr",
    path: "/tr",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/index.vue")
  },
  {
    name: "info___de",
    path: "/de/info",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/info/index.vue")
  },
  {
    name: "info___en",
    path: "/en/info",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/info/index.vue")
  },
  {
    name: "info___nl",
    path: "/nl/info",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/info/index.vue")
  },
  {
    name: "info___fr",
    path: "/fr/info",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/info/index.vue")
  },
  {
    name: "info___it",
    path: "/it/informazioni",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/info/index.vue")
  },
  {
    name: "info___es",
    path: "/es/informaci%C3%B3n",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/info/index.vue")
  },
  {
    name: "info___bg",
    path: "/bg/%D0%B8%D0%BD%D1%84%D0%BE",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/info/index.vue")
  },
  {
    name: "info___bs",
    path: "/bs/info",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/info/index.vue")
  },
  {
    name: "info___cs",
    path: "/cs/informace",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/info/index.vue")
  },
  {
    name: "info___da",
    path: "/da/info",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/info/index.vue")
  },
  {
    name: "info___el",
    path: "/el/%CF%80%CE%BB%CE%B7%CF%81%CE%BF%CF%86%CE%BF%CF%81%CE%AF%CE%B5%CF%82",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/info/index.vue")
  },
  {
    name: "info___et",
    path: "/et/info",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/info/index.vue")
  },
  {
    name: "info___fi",
    path: "/fi/tiedot",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/info/index.vue")
  },
  {
    name: "info___hr",
    path: "/hr/informacije",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/info/index.vue")
  },
  {
    name: "info___hu",
    path: "/hu/info",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/info/index.vue")
  },
  {
    name: "info___lt",
    path: "/lt/informacija",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/info/index.vue")
  },
  {
    name: "info___lv",
    path: "/lv/info",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/info/index.vue")
  },
  {
    name: "info___no",
    path: "/no/info",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/info/index.vue")
  },
  {
    name: "info___pl",
    path: "/pl/informacje",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/info/index.vue")
  },
  {
    name: "info___pt",
    path: "/pt/informa%C3%A7%C3%A3o",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/info/index.vue")
  },
  {
    name: "info___ro",
    path: "/ro/info",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/info/index.vue")
  },
  {
    name: "info___ru",
    path: "/ru/%D0%B8%D0%BD%D1%84%D0%BE%D1%80%D0%BC%D0%B0%D1%86%D0%B8%D1%8F",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/info/index.vue")
  },
  {
    name: "info___sk",
    path: "/sk/info",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/info/index.vue")
  },
  {
    name: "info___sl",
    path: "/sl/info",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/info/index.vue")
  },
  {
    name: "info___sr",
    path: "/sr/%D0%B8%D0%BD%D1%84%D0%BE",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/info/index.vue")
  },
  {
    name: "info___sv",
    path: "/sv/info",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/info/index.vue")
  },
  {
    name: "info___tr",
    path: "/tr/bilgi",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/info/index.vue")
  },
  {
    name: "oauth___de",
    path: "/de/oauth",
    meta: index2KVoxolIfIOiXCvg2u5LIz0B97kqGdeIciLffAVwlZ0Meta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/oauth/index.vue")
  },
  {
    name: "oauth___en",
    path: "/en/oauth",
    meta: index2KVoxolIfIOiXCvg2u5LIz0B97kqGdeIciLffAVwlZ0Meta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/oauth/index.vue")
  },
  {
    name: "oauth___nl",
    path: "/nl/oauth",
    meta: index2KVoxolIfIOiXCvg2u5LIz0B97kqGdeIciLffAVwlZ0Meta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/oauth/index.vue")
  },
  {
    name: "oauth___fr",
    path: "/fr/oauth",
    meta: index2KVoxolIfIOiXCvg2u5LIz0B97kqGdeIciLffAVwlZ0Meta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/oauth/index.vue")
  },
  {
    name: "oauth___it",
    path: "/it/oauth",
    meta: index2KVoxolIfIOiXCvg2u5LIz0B97kqGdeIciLffAVwlZ0Meta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/oauth/index.vue")
  },
  {
    name: "oauth___es",
    path: "/es/oauth",
    meta: index2KVoxolIfIOiXCvg2u5LIz0B97kqGdeIciLffAVwlZ0Meta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/oauth/index.vue")
  },
  {
    name: "oauth___bg",
    path: "/bg/oauth",
    meta: index2KVoxolIfIOiXCvg2u5LIz0B97kqGdeIciLffAVwlZ0Meta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/oauth/index.vue")
  },
  {
    name: "oauth___bs",
    path: "/bs/oauth",
    meta: index2KVoxolIfIOiXCvg2u5LIz0B97kqGdeIciLffAVwlZ0Meta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/oauth/index.vue")
  },
  {
    name: "oauth___cs",
    path: "/cs/oauth",
    meta: index2KVoxolIfIOiXCvg2u5LIz0B97kqGdeIciLffAVwlZ0Meta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/oauth/index.vue")
  },
  {
    name: "oauth___da",
    path: "/da/oauth",
    meta: index2KVoxolIfIOiXCvg2u5LIz0B97kqGdeIciLffAVwlZ0Meta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/oauth/index.vue")
  },
  {
    name: "oauth___el",
    path: "/el/oauth",
    meta: index2KVoxolIfIOiXCvg2u5LIz0B97kqGdeIciLffAVwlZ0Meta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/oauth/index.vue")
  },
  {
    name: "oauth___et",
    path: "/et/oauth",
    meta: index2KVoxolIfIOiXCvg2u5LIz0B97kqGdeIciLffAVwlZ0Meta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/oauth/index.vue")
  },
  {
    name: "oauth___fi",
    path: "/fi/oauth",
    meta: index2KVoxolIfIOiXCvg2u5LIz0B97kqGdeIciLffAVwlZ0Meta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/oauth/index.vue")
  },
  {
    name: "oauth___hr",
    path: "/hr/oauth",
    meta: index2KVoxolIfIOiXCvg2u5LIz0B97kqGdeIciLffAVwlZ0Meta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/oauth/index.vue")
  },
  {
    name: "oauth___hu",
    path: "/hu/oauth",
    meta: index2KVoxolIfIOiXCvg2u5LIz0B97kqGdeIciLffAVwlZ0Meta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/oauth/index.vue")
  },
  {
    name: "oauth___lt",
    path: "/lt/oauth",
    meta: index2KVoxolIfIOiXCvg2u5LIz0B97kqGdeIciLffAVwlZ0Meta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/oauth/index.vue")
  },
  {
    name: "oauth___lv",
    path: "/lv/oauth",
    meta: index2KVoxolIfIOiXCvg2u5LIz0B97kqGdeIciLffAVwlZ0Meta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/oauth/index.vue")
  },
  {
    name: "oauth___no",
    path: "/no/oauth",
    meta: index2KVoxolIfIOiXCvg2u5LIz0B97kqGdeIciLffAVwlZ0Meta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/oauth/index.vue")
  },
  {
    name: "oauth___pl",
    path: "/pl/oauth",
    meta: index2KVoxolIfIOiXCvg2u5LIz0B97kqGdeIciLffAVwlZ0Meta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/oauth/index.vue")
  },
  {
    name: "oauth___pt",
    path: "/pt/oauth",
    meta: index2KVoxolIfIOiXCvg2u5LIz0B97kqGdeIciLffAVwlZ0Meta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/oauth/index.vue")
  },
  {
    name: "oauth___ro",
    path: "/ro/oauth",
    meta: index2KVoxolIfIOiXCvg2u5LIz0B97kqGdeIciLffAVwlZ0Meta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/oauth/index.vue")
  },
  {
    name: "oauth___ru",
    path: "/ru/oauth",
    meta: index2KVoxolIfIOiXCvg2u5LIz0B97kqGdeIciLffAVwlZ0Meta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/oauth/index.vue")
  },
  {
    name: "oauth___sk",
    path: "/sk/oauth",
    meta: index2KVoxolIfIOiXCvg2u5LIz0B97kqGdeIciLffAVwlZ0Meta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/oauth/index.vue")
  },
  {
    name: "oauth___sl",
    path: "/sl/oauth",
    meta: index2KVoxolIfIOiXCvg2u5LIz0B97kqGdeIciLffAVwlZ0Meta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/oauth/index.vue")
  },
  {
    name: "oauth___sr",
    path: "/sr/oauth",
    meta: index2KVoxolIfIOiXCvg2u5LIz0B97kqGdeIciLffAVwlZ0Meta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/oauth/index.vue")
  },
  {
    name: "oauth___sv",
    path: "/sv/oauth",
    meta: index2KVoxolIfIOiXCvg2u5LIz0B97kqGdeIciLffAVwlZ0Meta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/oauth/index.vue")
  },
  {
    name: "oauth___tr",
    path: "/tr/oauth",
    meta: index2KVoxolIfIOiXCvg2u5LIz0B97kqGdeIciLffAVwlZ0Meta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/oauth/index.vue")
  },
  {
    name: "topic___de",
    path: "/de/thema",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/topic/index.vue")
  },
  {
    name: "topic___en",
    path: "/en/topic",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/topic/index.vue")
  },
  {
    name: "topic___nl",
    path: "/nl/onderwerp",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/topic/index.vue")
  },
  {
    name: "topic___fr",
    path: "/fr/sujet",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/topic/index.vue")
  },
  {
    name: "topic___it",
    path: "/it/argomento",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/topic/index.vue")
  },
  {
    name: "topic___es",
    path: "/es/tema",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/topic/index.vue")
  },
  {
    name: "topic___bg",
    path: "/bg/%D1%82%D0%B5%D0%BC%D0%B0",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/topic/index.vue")
  },
  {
    name: "topic___bs",
    path: "/bs/temu",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/topic/index.vue")
  },
  {
    name: "topic___cs",
    path: "/cs/t%C3%A9ma",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/topic/index.vue")
  },
  {
    name: "topic___da",
    path: "/da/emne",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/topic/index.vue")
  },
  {
    name: "topic___el",
    path: "/el/%CE%B8%CE%AD%CE%BC%CE%B1",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/topic/index.vue")
  },
  {
    name: "topic___et",
    path: "/et/teema",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/topic/index.vue")
  },
  {
    name: "topic___fi",
    path: "/fi/aihe",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/topic/index.vue")
  },
  {
    name: "topic___hr",
    path: "/hr/tema",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/topic/index.vue")
  },
  {
    name: "topic___hu",
    path: "/hu/t%C3%A9ma",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/topic/index.vue")
  },
  {
    name: "topic___lt",
    path: "/lt/tema",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/topic/index.vue")
  },
  {
    name: "topic___lv",
    path: "/lv/temats",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/topic/index.vue")
  },
  {
    name: "topic___no",
    path: "/no/emne",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/topic/index.vue")
  },
  {
    name: "topic___pl",
    path: "/pl/temat",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/topic/index.vue")
  },
  {
    name: "topic___pt",
    path: "/pt/tema",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/topic/index.vue")
  },
  {
    name: "topic___ro",
    path: "/ro/subiect",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/topic/index.vue")
  },
  {
    name: "topic___ru",
    path: "/ru/%D1%82%D0%B5%D0%BC%D0%B0",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/topic/index.vue")
  },
  {
    name: "topic___sk",
    path: "/sk/t%C3%A9ma",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/topic/index.vue")
  },
  {
    name: "topic___sl",
    path: "/sl/tema",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/topic/index.vue")
  },
  {
    name: "topic___sr",
    path: "/sr/%D1%82%D0%B5%D0%BC%D0%B0",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/topic/index.vue")
  },
  {
    name: "topic___sv",
    path: "/sv/%C3%A4mne",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/topic/index.vue")
  },
  {
    name: "topic___tr",
    path: "/tr/konu",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/topic/index.vue")
  },
  {
    name: "page-is-gone___de",
    path: "/de/page-is-gone",
    meta: page_45is_45goneTrQjfMkJhBLvEQ4WPw0QSu_NgWgyUDUfPSK_J4zSn4cMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/page-is-gone.vue")
  },
  {
    name: "page-is-gone___en",
    path: "/en/page-is-gone",
    meta: page_45is_45goneTrQjfMkJhBLvEQ4WPw0QSu_NgWgyUDUfPSK_J4zSn4cMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/page-is-gone.vue")
  },
  {
    name: "page-is-gone___nl",
    path: "/nl/page-is-gone",
    meta: page_45is_45goneTrQjfMkJhBLvEQ4WPw0QSu_NgWgyUDUfPSK_J4zSn4cMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/page-is-gone.vue")
  },
  {
    name: "page-is-gone___fr",
    path: "/fr/page-is-gone",
    meta: page_45is_45goneTrQjfMkJhBLvEQ4WPw0QSu_NgWgyUDUfPSK_J4zSn4cMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/page-is-gone.vue")
  },
  {
    name: "page-is-gone___it",
    path: "/it/page-is-gone",
    meta: page_45is_45goneTrQjfMkJhBLvEQ4WPw0QSu_NgWgyUDUfPSK_J4zSn4cMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/page-is-gone.vue")
  },
  {
    name: "page-is-gone___es",
    path: "/es/page-is-gone",
    meta: page_45is_45goneTrQjfMkJhBLvEQ4WPw0QSu_NgWgyUDUfPSK_J4zSn4cMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/page-is-gone.vue")
  },
  {
    name: "page-is-gone___bg",
    path: "/bg/page-is-gone",
    meta: page_45is_45goneTrQjfMkJhBLvEQ4WPw0QSu_NgWgyUDUfPSK_J4zSn4cMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/page-is-gone.vue")
  },
  {
    name: "page-is-gone___bs",
    path: "/bs/page-is-gone",
    meta: page_45is_45goneTrQjfMkJhBLvEQ4WPw0QSu_NgWgyUDUfPSK_J4zSn4cMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/page-is-gone.vue")
  },
  {
    name: "page-is-gone___cs",
    path: "/cs/page-is-gone",
    meta: page_45is_45goneTrQjfMkJhBLvEQ4WPw0QSu_NgWgyUDUfPSK_J4zSn4cMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/page-is-gone.vue")
  },
  {
    name: "page-is-gone___da",
    path: "/da/page-is-gone",
    meta: page_45is_45goneTrQjfMkJhBLvEQ4WPw0QSu_NgWgyUDUfPSK_J4zSn4cMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/page-is-gone.vue")
  },
  {
    name: "page-is-gone___el",
    path: "/el/page-is-gone",
    meta: page_45is_45goneTrQjfMkJhBLvEQ4WPw0QSu_NgWgyUDUfPSK_J4zSn4cMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/page-is-gone.vue")
  },
  {
    name: "page-is-gone___et",
    path: "/et/page-is-gone",
    meta: page_45is_45goneTrQjfMkJhBLvEQ4WPw0QSu_NgWgyUDUfPSK_J4zSn4cMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/page-is-gone.vue")
  },
  {
    name: "page-is-gone___fi",
    path: "/fi/page-is-gone",
    meta: page_45is_45goneTrQjfMkJhBLvEQ4WPw0QSu_NgWgyUDUfPSK_J4zSn4cMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/page-is-gone.vue")
  },
  {
    name: "page-is-gone___hr",
    path: "/hr/page-is-gone",
    meta: page_45is_45goneTrQjfMkJhBLvEQ4WPw0QSu_NgWgyUDUfPSK_J4zSn4cMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/page-is-gone.vue")
  },
  {
    name: "page-is-gone___hu",
    path: "/hu/page-is-gone",
    meta: page_45is_45goneTrQjfMkJhBLvEQ4WPw0QSu_NgWgyUDUfPSK_J4zSn4cMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/page-is-gone.vue")
  },
  {
    name: "page-is-gone___lt",
    path: "/lt/page-is-gone",
    meta: page_45is_45goneTrQjfMkJhBLvEQ4WPw0QSu_NgWgyUDUfPSK_J4zSn4cMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/page-is-gone.vue")
  },
  {
    name: "page-is-gone___lv",
    path: "/lv/page-is-gone",
    meta: page_45is_45goneTrQjfMkJhBLvEQ4WPw0QSu_NgWgyUDUfPSK_J4zSn4cMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/page-is-gone.vue")
  },
  {
    name: "page-is-gone___no",
    path: "/no/page-is-gone",
    meta: page_45is_45goneTrQjfMkJhBLvEQ4WPw0QSu_NgWgyUDUfPSK_J4zSn4cMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/page-is-gone.vue")
  },
  {
    name: "page-is-gone___pl",
    path: "/pl/page-is-gone",
    meta: page_45is_45goneTrQjfMkJhBLvEQ4WPw0QSu_NgWgyUDUfPSK_J4zSn4cMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/page-is-gone.vue")
  },
  {
    name: "page-is-gone___pt",
    path: "/pt/page-is-gone",
    meta: page_45is_45goneTrQjfMkJhBLvEQ4WPw0QSu_NgWgyUDUfPSK_J4zSn4cMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/page-is-gone.vue")
  },
  {
    name: "page-is-gone___ro",
    path: "/ro/page-is-gone",
    meta: page_45is_45goneTrQjfMkJhBLvEQ4WPw0QSu_NgWgyUDUfPSK_J4zSn4cMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/page-is-gone.vue")
  },
  {
    name: "page-is-gone___ru",
    path: "/ru/page-is-gone",
    meta: page_45is_45goneTrQjfMkJhBLvEQ4WPw0QSu_NgWgyUDUfPSK_J4zSn4cMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/page-is-gone.vue")
  },
  {
    name: "page-is-gone___sk",
    path: "/sk/page-is-gone",
    meta: page_45is_45goneTrQjfMkJhBLvEQ4WPw0QSu_NgWgyUDUfPSK_J4zSn4cMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/page-is-gone.vue")
  },
  {
    name: "page-is-gone___sl",
    path: "/sl/page-is-gone",
    meta: page_45is_45goneTrQjfMkJhBLvEQ4WPw0QSu_NgWgyUDUfPSK_J4zSn4cMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/page-is-gone.vue")
  },
  {
    name: "page-is-gone___sr",
    path: "/sr/page-is-gone",
    meta: page_45is_45goneTrQjfMkJhBLvEQ4WPw0QSu_NgWgyUDUfPSK_J4zSn4cMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/page-is-gone.vue")
  },
  {
    name: "page-is-gone___sv",
    path: "/sv/page-is-gone",
    meta: page_45is_45goneTrQjfMkJhBLvEQ4WPw0QSu_NgWgyUDUfPSK_J4zSn4cMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/page-is-gone.vue")
  },
  {
    name: "page-is-gone___tr",
    path: "/tr/page-is-gone",
    meta: page_45is_45goneTrQjfMkJhBLvEQ4WPw0QSu_NgWgyUDUfPSK_J4zSn4cMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/page-is-gone.vue")
  },
  {
    name: "sea-all___de",
    path: "/de/sea/:all(.*)*",
    meta: { ...(_91_46_46_46all_93tZquGhHXCTsE1WgLJQo84TsP3Xndou1iTh8naDyr7L0Meta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/sea/[...all].vue")
  },
  {
    name: "sea-all___en",
    path: "/en/sea/:all(.*)*",
    meta: { ...(_91_46_46_46all_93tZquGhHXCTsE1WgLJQo84TsP3Xndou1iTh8naDyr7L0Meta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/sea/[...all].vue")
  },
  {
    name: "sea-all___nl",
    path: "/nl/sea/:all(.*)*",
    meta: { ...(_91_46_46_46all_93tZquGhHXCTsE1WgLJQo84TsP3Xndou1iTh8naDyr7L0Meta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/sea/[...all].vue")
  },
  {
    name: "sea-all___fr",
    path: "/fr/sea/:all(.*)*",
    meta: { ...(_91_46_46_46all_93tZquGhHXCTsE1WgLJQo84TsP3Xndou1iTh8naDyr7L0Meta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/sea/[...all].vue")
  },
  {
    name: "sea-all___it",
    path: "/it/sea/:all(.*)*",
    meta: { ...(_91_46_46_46all_93tZquGhHXCTsE1WgLJQo84TsP3Xndou1iTh8naDyr7L0Meta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/sea/[...all].vue")
  },
  {
    name: "sea-all___es",
    path: "/es/sea/:all(.*)*",
    meta: { ...(_91_46_46_46all_93tZquGhHXCTsE1WgLJQo84TsP3Xndou1iTh8naDyr7L0Meta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/sea/[...all].vue")
  },
  {
    name: "sea-all___bg",
    path: "/bg/sea/:all(.*)*",
    meta: { ...(_91_46_46_46all_93tZquGhHXCTsE1WgLJQo84TsP3Xndou1iTh8naDyr7L0Meta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/sea/[...all].vue")
  },
  {
    name: "sea-all___bs",
    path: "/bs/sea/:all(.*)*",
    meta: { ...(_91_46_46_46all_93tZquGhHXCTsE1WgLJQo84TsP3Xndou1iTh8naDyr7L0Meta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/sea/[...all].vue")
  },
  {
    name: "sea-all___cs",
    path: "/cs/sea/:all(.*)*",
    meta: { ...(_91_46_46_46all_93tZquGhHXCTsE1WgLJQo84TsP3Xndou1iTh8naDyr7L0Meta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/sea/[...all].vue")
  },
  {
    name: "sea-all___da",
    path: "/da/sea/:all(.*)*",
    meta: { ...(_91_46_46_46all_93tZquGhHXCTsE1WgLJQo84TsP3Xndou1iTh8naDyr7L0Meta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/sea/[...all].vue")
  },
  {
    name: "sea-all___el",
    path: "/el/sea/:all(.*)*",
    meta: { ...(_91_46_46_46all_93tZquGhHXCTsE1WgLJQo84TsP3Xndou1iTh8naDyr7L0Meta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/sea/[...all].vue")
  },
  {
    name: "sea-all___et",
    path: "/et/sea/:all(.*)*",
    meta: { ...(_91_46_46_46all_93tZquGhHXCTsE1WgLJQo84TsP3Xndou1iTh8naDyr7L0Meta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/sea/[...all].vue")
  },
  {
    name: "sea-all___fi",
    path: "/fi/sea/:all(.*)*",
    meta: { ...(_91_46_46_46all_93tZquGhHXCTsE1WgLJQo84TsP3Xndou1iTh8naDyr7L0Meta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/sea/[...all].vue")
  },
  {
    name: "sea-all___hr",
    path: "/hr/sea/:all(.*)*",
    meta: { ...(_91_46_46_46all_93tZquGhHXCTsE1WgLJQo84TsP3Xndou1iTh8naDyr7L0Meta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/sea/[...all].vue")
  },
  {
    name: "sea-all___hu",
    path: "/hu/sea/:all(.*)*",
    meta: { ...(_91_46_46_46all_93tZquGhHXCTsE1WgLJQo84TsP3Xndou1iTh8naDyr7L0Meta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/sea/[...all].vue")
  },
  {
    name: "sea-all___lt",
    path: "/lt/sea/:all(.*)*",
    meta: { ...(_91_46_46_46all_93tZquGhHXCTsE1WgLJQo84TsP3Xndou1iTh8naDyr7L0Meta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/sea/[...all].vue")
  },
  {
    name: "sea-all___lv",
    path: "/lv/sea/:all(.*)*",
    meta: { ...(_91_46_46_46all_93tZquGhHXCTsE1WgLJQo84TsP3Xndou1iTh8naDyr7L0Meta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/sea/[...all].vue")
  },
  {
    name: "sea-all___no",
    path: "/no/sea/:all(.*)*",
    meta: { ...(_91_46_46_46all_93tZquGhHXCTsE1WgLJQo84TsP3Xndou1iTh8naDyr7L0Meta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/sea/[...all].vue")
  },
  {
    name: "sea-all___pl",
    path: "/pl/sea/:all(.*)*",
    meta: { ...(_91_46_46_46all_93tZquGhHXCTsE1WgLJQo84TsP3Xndou1iTh8naDyr7L0Meta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/sea/[...all].vue")
  },
  {
    name: "sea-all___pt",
    path: "/pt/sea/:all(.*)*",
    meta: { ...(_91_46_46_46all_93tZquGhHXCTsE1WgLJQo84TsP3Xndou1iTh8naDyr7L0Meta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/sea/[...all].vue")
  },
  {
    name: "sea-all___ro",
    path: "/ro/sea/:all(.*)*",
    meta: { ...(_91_46_46_46all_93tZquGhHXCTsE1WgLJQo84TsP3Xndou1iTh8naDyr7L0Meta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/sea/[...all].vue")
  },
  {
    name: "sea-all___ru",
    path: "/ru/sea/:all(.*)*",
    meta: { ...(_91_46_46_46all_93tZquGhHXCTsE1WgLJQo84TsP3Xndou1iTh8naDyr7L0Meta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/sea/[...all].vue")
  },
  {
    name: "sea-all___sk",
    path: "/sk/sea/:all(.*)*",
    meta: { ...(_91_46_46_46all_93tZquGhHXCTsE1WgLJQo84TsP3Xndou1iTh8naDyr7L0Meta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/sea/[...all].vue")
  },
  {
    name: "sea-all___sl",
    path: "/sl/sea/:all(.*)*",
    meta: { ...(_91_46_46_46all_93tZquGhHXCTsE1WgLJQo84TsP3Xndou1iTh8naDyr7L0Meta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/sea/[...all].vue")
  },
  {
    name: "sea-all___sr",
    path: "/sr/sea/:all(.*)*",
    meta: { ...(_91_46_46_46all_93tZquGhHXCTsE1WgLJQo84TsP3Xndou1iTh8naDyr7L0Meta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/sea/[...all].vue")
  },
  {
    name: "sea-all___sv",
    path: "/sv/sea/:all(.*)*",
    meta: { ...(_91_46_46_46all_93tZquGhHXCTsE1WgLJQo84TsP3Xndou1iTh8naDyr7L0Meta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/sea/[...all].vue")
  },
  {
    name: "sea-all___tr",
    path: "/tr/sea/:all(.*)*",
    meta: { ...(_91_46_46_46all_93tZquGhHXCTsE1WgLJQo84TsP3Xndou1iTh8naDyr7L0Meta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/sea/[...all].vue")
  },
  {
    name: "search___de",
    path: "/de/suche",
    meta: { ...(index_B7UejdnCW_h3id6jA7ey_bHa9dPS1Yd_iEJkiNBYX4Meta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/search/index.vue")
  },
  {
    name: "search___en",
    path: "/en/search",
    meta: { ...(index_B7UejdnCW_h3id6jA7ey_bHa9dPS1Yd_iEJkiNBYX4Meta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/search/index.vue")
  },
  {
    name: "search___nl",
    path: "/nl/zoeken",
    meta: { ...(index_B7UejdnCW_h3id6jA7ey_bHa9dPS1Yd_iEJkiNBYX4Meta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/search/index.vue")
  },
  {
    name: "search___fr",
    path: "/fr/recherche",
    meta: { ...(index_B7UejdnCW_h3id6jA7ey_bHa9dPS1Yd_iEJkiNBYX4Meta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/search/index.vue")
  },
  {
    name: "search___it",
    path: "/it/cerca",
    meta: { ...(index_B7UejdnCW_h3id6jA7ey_bHa9dPS1Yd_iEJkiNBYX4Meta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/search/index.vue")
  },
  {
    name: "search___es",
    path: "/es/buscar",
    meta: { ...(index_B7UejdnCW_h3id6jA7ey_bHa9dPS1Yd_iEJkiNBYX4Meta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/search/index.vue")
  },
  {
    name: "search___bg",
    path: "/bg/%D1%82%D1%8A%D1%80%D1%81%D0%B5%D0%BD%D0%B5",
    meta: { ...(index_B7UejdnCW_h3id6jA7ey_bHa9dPS1Yd_iEJkiNBYX4Meta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/search/index.vue")
  },
  {
    name: "search___bs",
    path: "/bs/trazi",
    meta: { ...(index_B7UejdnCW_h3id6jA7ey_bHa9dPS1Yd_iEJkiNBYX4Meta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/search/index.vue")
  },
  {
    name: "search___cs",
    path: "/cs/hledat",
    meta: { ...(index_B7UejdnCW_h3id6jA7ey_bHa9dPS1Yd_iEJkiNBYX4Meta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/search/index.vue")
  },
  {
    name: "search___da",
    path: "/da/s%C3%B8g",
    meta: { ...(index_B7UejdnCW_h3id6jA7ey_bHa9dPS1Yd_iEJkiNBYX4Meta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/search/index.vue")
  },
  {
    name: "search___el",
    path: "/el/%CE%B1%CE%BD%CE%B1%CE%B6%CE%B7%CF%84%CE%B7%CF%83%CE%B7",
    meta: { ...(index_B7UejdnCW_h3id6jA7ey_bHa9dPS1Yd_iEJkiNBYX4Meta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/search/index.vue")
  },
  {
    name: "search___et",
    path: "/et/otsing",
    meta: { ...(index_B7UejdnCW_h3id6jA7ey_bHa9dPS1Yd_iEJkiNBYX4Meta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/search/index.vue")
  },
  {
    name: "search___fi",
    path: "/fi/haku",
    meta: { ...(index_B7UejdnCW_h3id6jA7ey_bHa9dPS1Yd_iEJkiNBYX4Meta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/search/index.vue")
  },
  {
    name: "search___hr",
    path: "/hr/trazi",
    meta: { ...(index_B7UejdnCW_h3id6jA7ey_bHa9dPS1Yd_iEJkiNBYX4Meta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/search/index.vue")
  },
  {
    name: "search___hu",
    path: "/hu/kereses",
    meta: { ...(index_B7UejdnCW_h3id6jA7ey_bHa9dPS1Yd_iEJkiNBYX4Meta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/search/index.vue")
  },
  {
    name: "search___lt",
    path: "/lt/paieska",
    meta: { ...(index_B7UejdnCW_h3id6jA7ey_bHa9dPS1Yd_iEJkiNBYX4Meta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/search/index.vue")
  },
  {
    name: "search___lv",
    path: "/lv/meklet",
    meta: { ...(index_B7UejdnCW_h3id6jA7ey_bHa9dPS1Yd_iEJkiNBYX4Meta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/search/index.vue")
  },
  {
    name: "search___no",
    path: "/no/soek",
    meta: { ...(index_B7UejdnCW_h3id6jA7ey_bHa9dPS1Yd_iEJkiNBYX4Meta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/search/index.vue")
  },
  {
    name: "search___pl",
    path: "/pl/szukaj",
    meta: { ...(index_B7UejdnCW_h3id6jA7ey_bHa9dPS1Yd_iEJkiNBYX4Meta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/search/index.vue")
  },
  {
    name: "search___pt",
    path: "/pt/procurar",
    meta: { ...(index_B7UejdnCW_h3id6jA7ey_bHa9dPS1Yd_iEJkiNBYX4Meta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/search/index.vue")
  },
  {
    name: "search___ro",
    path: "/ro/cautare",
    meta: { ...(index_B7UejdnCW_h3id6jA7ey_bHa9dPS1Yd_iEJkiNBYX4Meta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/search/index.vue")
  },
  {
    name: "search___ru",
    path: "/ru/%D0%BF%D0%BE%D0%B8%D1%81%D0%BA",
    meta: { ...(index_B7UejdnCW_h3id6jA7ey_bHa9dPS1Yd_iEJkiNBYX4Meta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/search/index.vue")
  },
  {
    name: "search___sk",
    path: "/sk/vyhladavanie",
    meta: { ...(index_B7UejdnCW_h3id6jA7ey_bHa9dPS1Yd_iEJkiNBYX4Meta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/search/index.vue")
  },
  {
    name: "search___sl",
    path: "/sl/isci",
    meta: { ...(index_B7UejdnCW_h3id6jA7ey_bHa9dPS1Yd_iEJkiNBYX4Meta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/search/index.vue")
  },
  {
    name: "search___sr",
    path: "/sr/pretraga",
    meta: { ...(index_B7UejdnCW_h3id6jA7ey_bHa9dPS1Yd_iEJkiNBYX4Meta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/search/index.vue")
  },
  {
    name: "search___sv",
    path: "/sv/sok",
    meta: { ...(index_B7UejdnCW_h3id6jA7ey_bHa9dPS1Yd_iEJkiNBYX4Meta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/search/index.vue")
  },
  {
    name: "search___tr",
    path: "/tr/ara",
    meta: { ...(index_B7UejdnCW_h3id6jA7ey_bHa9dPS1Yd_iEJkiNBYX4Meta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/search/index.vue")
  },
  {
    name: "account___de",
    path: "/de/account",
    meta: indexc6VkXRnjwsCSnsjS9uEKgV1NO7lGne1wCueU1rDOcrcMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/index.vue")
  },
  {
    name: "account___en",
    path: "/en/account",
    meta: indexc6VkXRnjwsCSnsjS9uEKgV1NO7lGne1wCueU1rDOcrcMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/index.vue")
  },
  {
    name: "account___nl",
    path: "/nl/account",
    meta: indexc6VkXRnjwsCSnsjS9uEKgV1NO7lGne1wCueU1rDOcrcMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/index.vue")
  },
  {
    name: "account___fr",
    path: "/fr/account",
    meta: indexc6VkXRnjwsCSnsjS9uEKgV1NO7lGne1wCueU1rDOcrcMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/index.vue")
  },
  {
    name: "account___it",
    path: "/it/account",
    meta: indexc6VkXRnjwsCSnsjS9uEKgV1NO7lGne1wCueU1rDOcrcMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/index.vue")
  },
  {
    name: "account___es",
    path: "/es/account",
    meta: indexc6VkXRnjwsCSnsjS9uEKgV1NO7lGne1wCueU1rDOcrcMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/index.vue")
  },
  {
    name: "account___bg",
    path: "/bg/account",
    meta: indexc6VkXRnjwsCSnsjS9uEKgV1NO7lGne1wCueU1rDOcrcMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/index.vue")
  },
  {
    name: "account___bs",
    path: "/bs/account",
    meta: indexc6VkXRnjwsCSnsjS9uEKgV1NO7lGne1wCueU1rDOcrcMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/index.vue")
  },
  {
    name: "account___cs",
    path: "/cs/account",
    meta: indexc6VkXRnjwsCSnsjS9uEKgV1NO7lGne1wCueU1rDOcrcMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/index.vue")
  },
  {
    name: "account___da",
    path: "/da/account",
    meta: indexc6VkXRnjwsCSnsjS9uEKgV1NO7lGne1wCueU1rDOcrcMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/index.vue")
  },
  {
    name: "account___el",
    path: "/el/account",
    meta: indexc6VkXRnjwsCSnsjS9uEKgV1NO7lGne1wCueU1rDOcrcMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/index.vue")
  },
  {
    name: "account___et",
    path: "/et/account",
    meta: indexc6VkXRnjwsCSnsjS9uEKgV1NO7lGne1wCueU1rDOcrcMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/index.vue")
  },
  {
    name: "account___fi",
    path: "/fi/account",
    meta: indexc6VkXRnjwsCSnsjS9uEKgV1NO7lGne1wCueU1rDOcrcMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/index.vue")
  },
  {
    name: "account___hr",
    path: "/hr/account",
    meta: indexc6VkXRnjwsCSnsjS9uEKgV1NO7lGne1wCueU1rDOcrcMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/index.vue")
  },
  {
    name: "account___hu",
    path: "/hu/account",
    meta: indexc6VkXRnjwsCSnsjS9uEKgV1NO7lGne1wCueU1rDOcrcMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/index.vue")
  },
  {
    name: "account___lt",
    path: "/lt/account",
    meta: indexc6VkXRnjwsCSnsjS9uEKgV1NO7lGne1wCueU1rDOcrcMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/index.vue")
  },
  {
    name: "account___lv",
    path: "/lv/account",
    meta: indexc6VkXRnjwsCSnsjS9uEKgV1NO7lGne1wCueU1rDOcrcMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/index.vue")
  },
  {
    name: "account___no",
    path: "/no/account",
    meta: indexc6VkXRnjwsCSnsjS9uEKgV1NO7lGne1wCueU1rDOcrcMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/index.vue")
  },
  {
    name: "account___pl",
    path: "/pl/account",
    meta: indexc6VkXRnjwsCSnsjS9uEKgV1NO7lGne1wCueU1rDOcrcMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/index.vue")
  },
  {
    name: "account___pt",
    path: "/pt/account",
    meta: indexc6VkXRnjwsCSnsjS9uEKgV1NO7lGne1wCueU1rDOcrcMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/index.vue")
  },
  {
    name: "account___ro",
    path: "/ro/account",
    meta: indexc6VkXRnjwsCSnsjS9uEKgV1NO7lGne1wCueU1rDOcrcMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/index.vue")
  },
  {
    name: "account___ru",
    path: "/ru/account",
    meta: indexc6VkXRnjwsCSnsjS9uEKgV1NO7lGne1wCueU1rDOcrcMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/index.vue")
  },
  {
    name: "account___sk",
    path: "/sk/account",
    meta: indexc6VkXRnjwsCSnsjS9uEKgV1NO7lGne1wCueU1rDOcrcMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/index.vue")
  },
  {
    name: "account___sl",
    path: "/sl/account",
    meta: indexc6VkXRnjwsCSnsjS9uEKgV1NO7lGne1wCueU1rDOcrcMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/index.vue")
  },
  {
    name: "account___sr",
    path: "/sr/account",
    meta: indexc6VkXRnjwsCSnsjS9uEKgV1NO7lGne1wCueU1rDOcrcMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/index.vue")
  },
  {
    name: "account___sv",
    path: "/sv/account",
    meta: indexc6VkXRnjwsCSnsjS9uEKgV1NO7lGne1wCueU1rDOcrcMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/index.vue")
  },
  {
    name: "account___tr",
    path: "/tr/account",
    meta: indexc6VkXRnjwsCSnsjS9uEKgV1NO7lGne1wCueU1rDOcrcMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/index.vue")
  },
  {
    name: "country___de",
    path: "/de/land",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/index.vue")
  },
  {
    name: "country___en",
    path: "/en/country",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/index.vue")
  },
  {
    name: "country___nl",
    path: "/nl/land",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/index.vue")
  },
  {
    name: "country___fr",
    path: "/fr/pays",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/index.vue")
  },
  {
    name: "country___it",
    path: "/it/paese",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/index.vue")
  },
  {
    name: "country___es",
    path: "/es/pa%C3%ADs",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/index.vue")
  },
  {
    name: "country___bg",
    path: "/bg/%D0%B4%D1%8A%D1%80%D0%B6%D0%B0%D0%B2%D0%B0",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/index.vue")
  },
  {
    name: "country___bs",
    path: "/bs/drzava",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/index.vue")
  },
  {
    name: "country___cs",
    path: "/cs/zeme",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/index.vue")
  },
  {
    name: "country___da",
    path: "/da/land",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/index.vue")
  },
  {
    name: "country___el",
    path: "/el/%CF%87%CF%89%CF%81%CE%B1",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/index.vue")
  },
  {
    name: "country___et",
    path: "/et/riik",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/index.vue")
  },
  {
    name: "country___fi",
    path: "/fi/maa",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/index.vue")
  },
  {
    name: "country___hr",
    path: "/hr/zemlja",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/index.vue")
  },
  {
    name: "country___hu",
    path: "/hu/orszag",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/index.vue")
  },
  {
    name: "country___lt",
    path: "/lt/salis",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/index.vue")
  },
  {
    name: "country___lv",
    path: "/lv/valsts",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/index.vue")
  },
  {
    name: "country___no",
    path: "/no/land",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/index.vue")
  },
  {
    name: "country___pl",
    path: "/pl/kraj",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/index.vue")
  },
  {
    name: "country___pt",
    path: "/pt/pais",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/index.vue")
  },
  {
    name: "country___ro",
    path: "/ro/tara",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/index.vue")
  },
  {
    name: "country___ru",
    path: "/ru/%D1%81%D1%82%D1%80%D0%B0%D0%BD%D0%B0",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/index.vue")
  },
  {
    name: "country___sk",
    path: "/sk/krajina",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/index.vue")
  },
  {
    name: "country___sl",
    path: "/sl/drzava",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/index.vue")
  },
  {
    name: "country___sr",
    path: "/sr/zemlja",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/index.vue")
  },
  {
    name: "country___sv",
    path: "/sv/land",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/index.vue")
  },
  {
    name: "country___tr",
    path: "/tr/ulke",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/index.vue")
  },
  {
    name: "info-all___de",
    path: "/de/info/:all(.*)*",
    meta: { ...(_91_46_46_46all_93LzFrj9i8_v9dpFQKkL6dmvDH2Lo7NboQRNovPYynM3kMeta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/info/[...all].vue")
  },
  {
    name: "info-all___en",
    path: "/en/info/:all(.*)*",
    meta: { ...(_91_46_46_46all_93LzFrj9i8_v9dpFQKkL6dmvDH2Lo7NboQRNovPYynM3kMeta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/info/[...all].vue")
  },
  {
    name: "info-all___nl",
    path: "/nl/info/:all(.*)*",
    meta: { ...(_91_46_46_46all_93LzFrj9i8_v9dpFQKkL6dmvDH2Lo7NboQRNovPYynM3kMeta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/info/[...all].vue")
  },
  {
    name: "info-all___fr",
    path: "/fr/info/:all(.*)*",
    meta: { ...(_91_46_46_46all_93LzFrj9i8_v9dpFQKkL6dmvDH2Lo7NboQRNovPYynM3kMeta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/info/[...all].vue")
  },
  {
    name: "info-all___it",
    path: "/it/informazioni/:all(.*)*",
    meta: { ...(_91_46_46_46all_93LzFrj9i8_v9dpFQKkL6dmvDH2Lo7NboQRNovPYynM3kMeta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/info/[...all].vue")
  },
  {
    name: "info-all___es",
    path: "/es/informaci%C3%B3n/:all(.*)*",
    meta: { ...(_91_46_46_46all_93LzFrj9i8_v9dpFQKkL6dmvDH2Lo7NboQRNovPYynM3kMeta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/info/[...all].vue")
  },
  {
    name: "info-all___bg",
    path: "/bg/%D0%B8%D0%BD%D1%84%D0%BE/:all(.*)*",
    meta: { ...(_91_46_46_46all_93LzFrj9i8_v9dpFQKkL6dmvDH2Lo7NboQRNovPYynM3kMeta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/info/[...all].vue")
  },
  {
    name: "info-all___bs",
    path: "/bs/info/:all(.*)*",
    meta: { ...(_91_46_46_46all_93LzFrj9i8_v9dpFQKkL6dmvDH2Lo7NboQRNovPYynM3kMeta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/info/[...all].vue")
  },
  {
    name: "info-all___cs",
    path: "/cs/informace/:all(.*)*",
    meta: { ...(_91_46_46_46all_93LzFrj9i8_v9dpFQKkL6dmvDH2Lo7NboQRNovPYynM3kMeta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/info/[...all].vue")
  },
  {
    name: "info-all___da",
    path: "/da/info/:all(.*)*",
    meta: { ...(_91_46_46_46all_93LzFrj9i8_v9dpFQKkL6dmvDH2Lo7NboQRNovPYynM3kMeta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/info/[...all].vue")
  },
  {
    name: "info-all___el",
    path: "/el/%CF%80%CE%BB%CE%B7%CF%81%CE%BF%CF%86%CE%BF%CF%81%CE%AF%CE%B5%CF%82/:all(.*)*",
    meta: { ...(_91_46_46_46all_93LzFrj9i8_v9dpFQKkL6dmvDH2Lo7NboQRNovPYynM3kMeta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/info/[...all].vue")
  },
  {
    name: "info-all___et",
    path: "/et/info/:all(.*)*",
    meta: { ...(_91_46_46_46all_93LzFrj9i8_v9dpFQKkL6dmvDH2Lo7NboQRNovPYynM3kMeta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/info/[...all].vue")
  },
  {
    name: "info-all___fi",
    path: "/fi/tiedot/:all(.*)*",
    meta: { ...(_91_46_46_46all_93LzFrj9i8_v9dpFQKkL6dmvDH2Lo7NboQRNovPYynM3kMeta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/info/[...all].vue")
  },
  {
    name: "info-all___hr",
    path: "/hr/informacije/:all(.*)*",
    meta: { ...(_91_46_46_46all_93LzFrj9i8_v9dpFQKkL6dmvDH2Lo7NboQRNovPYynM3kMeta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/info/[...all].vue")
  },
  {
    name: "info-all___hu",
    path: "/hu/info/:all(.*)*",
    meta: { ...(_91_46_46_46all_93LzFrj9i8_v9dpFQKkL6dmvDH2Lo7NboQRNovPYynM3kMeta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/info/[...all].vue")
  },
  {
    name: "info-all___lt",
    path: "/lt/informacija/:all(.*)*",
    meta: { ...(_91_46_46_46all_93LzFrj9i8_v9dpFQKkL6dmvDH2Lo7NboQRNovPYynM3kMeta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/info/[...all].vue")
  },
  {
    name: "info-all___lv",
    path: "/lv/info/:all(.*)*",
    meta: { ...(_91_46_46_46all_93LzFrj9i8_v9dpFQKkL6dmvDH2Lo7NboQRNovPYynM3kMeta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/info/[...all].vue")
  },
  {
    name: "info-all___no",
    path: "/no/info/:all(.*)*",
    meta: { ...(_91_46_46_46all_93LzFrj9i8_v9dpFQKkL6dmvDH2Lo7NboQRNovPYynM3kMeta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/info/[...all].vue")
  },
  {
    name: "info-all___pl",
    path: "/pl/informacje/:all(.*)*",
    meta: { ...(_91_46_46_46all_93LzFrj9i8_v9dpFQKkL6dmvDH2Lo7NboQRNovPYynM3kMeta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/info/[...all].vue")
  },
  {
    name: "info-all___pt",
    path: "/pt/informa%C3%A7%C3%A3o/:all(.*)*",
    meta: { ...(_91_46_46_46all_93LzFrj9i8_v9dpFQKkL6dmvDH2Lo7NboQRNovPYynM3kMeta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/info/[...all].vue")
  },
  {
    name: "info-all___ro",
    path: "/ro/info/:all(.*)*",
    meta: { ...(_91_46_46_46all_93LzFrj9i8_v9dpFQKkL6dmvDH2Lo7NboQRNovPYynM3kMeta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/info/[...all].vue")
  },
  {
    name: "info-all___ru",
    path: "/ru/%D0%B8%D0%BD%D1%84%D0%BE%D1%80%D0%BC%D0%B0%D1%86%D0%B8%D1%8F/:all(.*)*",
    meta: { ...(_91_46_46_46all_93LzFrj9i8_v9dpFQKkL6dmvDH2Lo7NboQRNovPYynM3kMeta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/info/[...all].vue")
  },
  {
    name: "info-all___sk",
    path: "/sk/info/:all(.*)*",
    meta: { ...(_91_46_46_46all_93LzFrj9i8_v9dpFQKkL6dmvDH2Lo7NboQRNovPYynM3kMeta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/info/[...all].vue")
  },
  {
    name: "info-all___sl",
    path: "/sl/info/:all(.*)*",
    meta: { ...(_91_46_46_46all_93LzFrj9i8_v9dpFQKkL6dmvDH2Lo7NboQRNovPYynM3kMeta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/info/[...all].vue")
  },
  {
    name: "info-all___sr",
    path: "/sr/%D0%B8%D0%BD%D1%84%D0%BE/:all(.*)*",
    meta: { ...(_91_46_46_46all_93LzFrj9i8_v9dpFQKkL6dmvDH2Lo7NboQRNovPYynM3kMeta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/info/[...all].vue")
  },
  {
    name: "info-all___sv",
    path: "/sv/info/:all(.*)*",
    meta: { ...(_91_46_46_46all_93LzFrj9i8_v9dpFQKkL6dmvDH2Lo7NboQRNovPYynM3kMeta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/info/[...all].vue")
  },
  {
    name: "info-all___tr",
    path: "/tr/bilgi/:all(.*)*",
    meta: { ...(_91_46_46_46all_93LzFrj9i8_v9dpFQKkL6dmvDH2Lo7NboQRNovPYynM3kMeta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/info/[...all].vue")
  },
  {
    name: "campsite___de",
    path: "/de/campingplatz",
    meta: { ...(indexyAptwUOir9aCpZCRAx32AjM3IK7t29jq8dyHcLjjfTgMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/index.vue")
  },
  {
    name: "campsite___en",
    path: "/en/campsite",
    meta: { ...(indexyAptwUOir9aCpZCRAx32AjM3IK7t29jq8dyHcLjjfTgMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/index.vue")
  },
  {
    name: "campsite___nl",
    path: "/nl/kampeerplek",
    meta: { ...(indexyAptwUOir9aCpZCRAx32AjM3IK7t29jq8dyHcLjjfTgMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/index.vue")
  },
  {
    name: "campsite___fr",
    path: "/fr/emplacement-de-camping",
    meta: { ...(indexyAptwUOir9aCpZCRAx32AjM3IK7t29jq8dyHcLjjfTgMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/index.vue")
  },
  {
    name: "campsite___it",
    path: "/it/campeggio",
    meta: { ...(indexyAptwUOir9aCpZCRAx32AjM3IK7t29jq8dyHcLjjfTgMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/index.vue")
  },
  {
    name: "campsite___es",
    path: "/es/camping",
    meta: { ...(indexyAptwUOir9aCpZCRAx32AjM3IK7t29jq8dyHcLjjfTgMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/index.vue")
  },
  {
    name: "campsite___bg",
    path: "/bg/%D0%BB%D0%B0%D0%B3%D0%B5%D1%80",
    meta: { ...(indexyAptwUOir9aCpZCRAx32AjM3IK7t29jq8dyHcLjjfTgMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/index.vue")
  },
  {
    name: "campsite___bs",
    path: "/bs/kamp-mjesto",
    meta: { ...(indexyAptwUOir9aCpZCRAx32AjM3IK7t29jq8dyHcLjjfTgMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/index.vue")
  },
  {
    name: "campsite___cs",
    path: "/cs/kemp",
    meta: { ...(indexyAptwUOir9aCpZCRAx32AjM3IK7t29jq8dyHcLjjfTgMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/index.vue")
  },
  {
    name: "campsite___da",
    path: "/da/campinggrund",
    meta: { ...(indexyAptwUOir9aCpZCRAx32AjM3IK7t29jq8dyHcLjjfTgMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/index.vue")
  },
  {
    name: "campsite___el",
    path: "/el/%CE%B8%CE%B5%CF%83%CE%B7-%CE%BA%CE%B1%CE%BC%CF%80%CE%B9%CE%BD%CE%B3%CE%BA",
    meta: { ...(indexyAptwUOir9aCpZCRAx32AjM3IK7t29jq8dyHcLjjfTgMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/index.vue")
  },
  {
    name: "campsite___et",
    path: "/et/kamping",
    meta: { ...(indexyAptwUOir9aCpZCRAx32AjM3IK7t29jq8dyHcLjjfTgMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/index.vue")
  },
  {
    name: "campsite___fi",
    path: "/fi/leirintaalue",
    meta: { ...(indexyAptwUOir9aCpZCRAx32AjM3IK7t29jq8dyHcLjjfTgMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/index.vue")
  },
  {
    name: "campsite___hr",
    path: "/hr/mjesto-za-kampiranje",
    meta: { ...(indexyAptwUOir9aCpZCRAx32AjM3IK7t29jq8dyHcLjjfTgMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/index.vue")
  },
  {
    name: "campsite___hu",
    path: "/hu/taborhely",
    meta: { ...(indexyAptwUOir9aCpZCRAx32AjM3IK7t29jq8dyHcLjjfTgMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/index.vue")
  },
  {
    name: "campsite___lt",
    path: "/lt/stovyklaviete",
    meta: { ...(indexyAptwUOir9aCpZCRAx32AjM3IK7t29jq8dyHcLjjfTgMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/index.vue")
  },
  {
    name: "campsite___lv",
    path: "/lv/karavanu-vieta",
    meta: { ...(indexyAptwUOir9aCpZCRAx32AjM3IK7t29jq8dyHcLjjfTgMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/index.vue")
  },
  {
    name: "campsite___no",
    path: "/no/campingplass",
    meta: { ...(indexyAptwUOir9aCpZCRAx32AjM3IK7t29jq8dyHcLjjfTgMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/index.vue")
  },
  {
    name: "campsite___pl",
    path: "/pl/miejsce-kempingowe",
    meta: { ...(indexyAptwUOir9aCpZCRAx32AjM3IK7t29jq8dyHcLjjfTgMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/index.vue")
  },
  {
    name: "campsite___pt",
    path: "/pt/acampamento",
    meta: { ...(indexyAptwUOir9aCpZCRAx32AjM3IK7t29jq8dyHcLjjfTgMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/index.vue")
  },
  {
    name: "campsite___ro",
    path: "/ro/loc-de-campare",
    meta: { ...(indexyAptwUOir9aCpZCRAx32AjM3IK7t29jq8dyHcLjjfTgMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/index.vue")
  },
  {
    name: "campsite___ru",
    path: "/ru/%D0%BA%D0%B5%D0%BC%D0%BF%D0%B8%D0%BD%D0%B3-%D0%BB%D0%B0%D0%B3%D0%B5%D1%80%D1%8C",
    meta: { ...(indexyAptwUOir9aCpZCRAx32AjM3IK7t29jq8dyHcLjjfTgMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/index.vue")
  },
  {
    name: "campsite___sk",
    path: "/sk/miesto-na-kempovanie",
    meta: { ...(indexyAptwUOir9aCpZCRAx32AjM3IK7t29jq8dyHcLjjfTgMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/index.vue")
  },
  {
    name: "campsite___sl",
    path: "/sl/kamp",
    meta: { ...(indexyAptwUOir9aCpZCRAx32AjM3IK7t29jq8dyHcLjjfTgMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/index.vue")
  },
  {
    name: "campsite___sr",
    path: "/sr/kamp-lokacija",
    meta: { ...(indexyAptwUOir9aCpZCRAx32AjM3IK7t29jq8dyHcLjjfTgMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/index.vue")
  },
  {
    name: "campsite___sv",
    path: "/sv/taltplats",
    meta: { ...(indexyAptwUOir9aCpZCRAx32AjM3IK7t29jq8dyHcLjjfTgMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/index.vue")
  },
  {
    name: "campsite___tr",
    path: "/tr/kamp-alani",
    meta: { ...(indexyAptwUOir9aCpZCRAx32AjM3IK7t29jq8dyHcLjjfTgMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/index.vue")
  },
  {
    name: "topic-all___de",
    path: "/de/thema/:all(.*)*",
    meta: { ...(_91_46_46_46all_93eF3a31klc3CxwHNKkjZq1NXnNdHpj2QoLZNqz7_WrOMMeta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/topic/[...all].vue")
  },
  {
    name: "topic-all___en",
    path: "/en/topic/:all(.*)*",
    meta: { ...(_91_46_46_46all_93eF3a31klc3CxwHNKkjZq1NXnNdHpj2QoLZNqz7_WrOMMeta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/topic/[...all].vue")
  },
  {
    name: "topic-all___nl",
    path: "/nl/onderwerp/:all(.*)*",
    meta: { ...(_91_46_46_46all_93eF3a31klc3CxwHNKkjZq1NXnNdHpj2QoLZNqz7_WrOMMeta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/topic/[...all].vue")
  },
  {
    name: "topic-all___fr",
    path: "/fr/sujet/:all(.*)*",
    meta: { ...(_91_46_46_46all_93eF3a31klc3CxwHNKkjZq1NXnNdHpj2QoLZNqz7_WrOMMeta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/topic/[...all].vue")
  },
  {
    name: "topic-all___it",
    path: "/it/argomento/:all(.*)*",
    meta: { ...(_91_46_46_46all_93eF3a31klc3CxwHNKkjZq1NXnNdHpj2QoLZNqz7_WrOMMeta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/topic/[...all].vue")
  },
  {
    name: "topic-all___es",
    path: "/es/tema/:all(.*)*",
    meta: { ...(_91_46_46_46all_93eF3a31klc3CxwHNKkjZq1NXnNdHpj2QoLZNqz7_WrOMMeta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/topic/[...all].vue")
  },
  {
    name: "topic-all___bg",
    path: "/bg/%D1%82%D0%B5%D0%BC%D0%B0/:all(.*)*",
    meta: { ...(_91_46_46_46all_93eF3a31klc3CxwHNKkjZq1NXnNdHpj2QoLZNqz7_WrOMMeta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/topic/[...all].vue")
  },
  {
    name: "topic-all___bs",
    path: "/bs/temu/:all(.*)*",
    meta: { ...(_91_46_46_46all_93eF3a31klc3CxwHNKkjZq1NXnNdHpj2QoLZNqz7_WrOMMeta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/topic/[...all].vue")
  },
  {
    name: "topic-all___cs",
    path: "/cs/t%C3%A9ma/:all(.*)*",
    meta: { ...(_91_46_46_46all_93eF3a31klc3CxwHNKkjZq1NXnNdHpj2QoLZNqz7_WrOMMeta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/topic/[...all].vue")
  },
  {
    name: "topic-all___da",
    path: "/da/emne/:all(.*)*",
    meta: { ...(_91_46_46_46all_93eF3a31klc3CxwHNKkjZq1NXnNdHpj2QoLZNqz7_WrOMMeta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/topic/[...all].vue")
  },
  {
    name: "topic-all___el",
    path: "/el/%CE%B8%CE%AD%CE%BC%CE%B1/:all(.*)*",
    meta: { ...(_91_46_46_46all_93eF3a31klc3CxwHNKkjZq1NXnNdHpj2QoLZNqz7_WrOMMeta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/topic/[...all].vue")
  },
  {
    name: "topic-all___et",
    path: "/et/teema/:all(.*)*",
    meta: { ...(_91_46_46_46all_93eF3a31klc3CxwHNKkjZq1NXnNdHpj2QoLZNqz7_WrOMMeta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/topic/[...all].vue")
  },
  {
    name: "topic-all___fi",
    path: "/fi/aihe/:all(.*)*",
    meta: { ...(_91_46_46_46all_93eF3a31klc3CxwHNKkjZq1NXnNdHpj2QoLZNqz7_WrOMMeta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/topic/[...all].vue")
  },
  {
    name: "topic-all___hr",
    path: "/hr/tema/:all(.*)*",
    meta: { ...(_91_46_46_46all_93eF3a31klc3CxwHNKkjZq1NXnNdHpj2QoLZNqz7_WrOMMeta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/topic/[...all].vue")
  },
  {
    name: "topic-all___hu",
    path: "/hu/t%C3%A9ma/:all(.*)*",
    meta: { ...(_91_46_46_46all_93eF3a31klc3CxwHNKkjZq1NXnNdHpj2QoLZNqz7_WrOMMeta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/topic/[...all].vue")
  },
  {
    name: "topic-all___lt",
    path: "/lt/tema/:all(.*)*",
    meta: { ...(_91_46_46_46all_93eF3a31klc3CxwHNKkjZq1NXnNdHpj2QoLZNqz7_WrOMMeta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/topic/[...all].vue")
  },
  {
    name: "topic-all___lv",
    path: "/lv/temats/:all(.*)*",
    meta: { ...(_91_46_46_46all_93eF3a31klc3CxwHNKkjZq1NXnNdHpj2QoLZNqz7_WrOMMeta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/topic/[...all].vue")
  },
  {
    name: "topic-all___no",
    path: "/no/emne/:all(.*)*",
    meta: { ...(_91_46_46_46all_93eF3a31klc3CxwHNKkjZq1NXnNdHpj2QoLZNqz7_WrOMMeta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/topic/[...all].vue")
  },
  {
    name: "topic-all___pl",
    path: "/pl/temat/:all(.*)*",
    meta: { ...(_91_46_46_46all_93eF3a31klc3CxwHNKkjZq1NXnNdHpj2QoLZNqz7_WrOMMeta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/topic/[...all].vue")
  },
  {
    name: "topic-all___pt",
    path: "/pt/tema/:all(.*)*",
    meta: { ...(_91_46_46_46all_93eF3a31klc3CxwHNKkjZq1NXnNdHpj2QoLZNqz7_WrOMMeta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/topic/[...all].vue")
  },
  {
    name: "topic-all___ro",
    path: "/ro/subiect/:all(.*)*",
    meta: { ...(_91_46_46_46all_93eF3a31klc3CxwHNKkjZq1NXnNdHpj2QoLZNqz7_WrOMMeta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/topic/[...all].vue")
  },
  {
    name: "topic-all___ru",
    path: "/ru/%D1%82%D0%B5%D0%BC%D0%B0/:all(.*)*",
    meta: { ...(_91_46_46_46all_93eF3a31klc3CxwHNKkjZq1NXnNdHpj2QoLZNqz7_WrOMMeta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/topic/[...all].vue")
  },
  {
    name: "topic-all___sk",
    path: "/sk/t%C3%A9ma/:all(.*)*",
    meta: { ...(_91_46_46_46all_93eF3a31klc3CxwHNKkjZq1NXnNdHpj2QoLZNqz7_WrOMMeta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/topic/[...all].vue")
  },
  {
    name: "topic-all___sl",
    path: "/sl/tema/:all(.*)*",
    meta: { ...(_91_46_46_46all_93eF3a31klc3CxwHNKkjZq1NXnNdHpj2QoLZNqz7_WrOMMeta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/topic/[...all].vue")
  },
  {
    name: "topic-all___sr",
    path: "/sr/%D1%82%D0%B5%D0%BC%D0%B0/:all(.*)*",
    meta: { ...(_91_46_46_46all_93eF3a31klc3CxwHNKkjZq1NXnNdHpj2QoLZNqz7_WrOMMeta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/topic/[...all].vue")
  },
  {
    name: "topic-all___sv",
    path: "/sv/%C3%A4mne/:all(.*)*",
    meta: { ...(_91_46_46_46all_93eF3a31klc3CxwHNKkjZq1NXnNdHpj2QoLZNqz7_WrOMMeta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/topic/[...all].vue")
  },
  {
    name: "topic-all___tr",
    path: "/tr/konu/:all(.*)*",
    meta: { ...(_91_46_46_46all_93eF3a31klc3CxwHNKkjZq1NXnNdHpj2QoLZNqz7_WrOMMeta || {}), ...{"middleware":["dynamic-page-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/topic/[...all].vue")
  },
  {
    name: "searchMap___de",
    path: "/de/auf-karte-suchen",
    meta: indexcC_YwpQW2wza5shY4xyyAiOUCx43F7xc8O9luapV7fcMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/searchMap/index.vue")
  },
  {
    name: "searchMap___en",
    path: "/en/search-on-map",
    meta: indexcC_YwpQW2wza5shY4xyyAiOUCx43F7xc8O9luapV7fcMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/searchMap/index.vue")
  },
  {
    name: "searchMap___nl",
    path: "/nl/zoek-op-kaart",
    meta: indexcC_YwpQW2wza5shY4xyyAiOUCx43F7xc8O9luapV7fcMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/searchMap/index.vue")
  },
  {
    name: "searchMap___fr",
    path: "/fr/recherche-carte",
    meta: indexcC_YwpQW2wza5shY4xyyAiOUCx43F7xc8O9luapV7fcMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/searchMap/index.vue")
  },
  {
    name: "searchMap___it",
    path: "/it/cerca-mappa",
    meta: indexcC_YwpQW2wza5shY4xyyAiOUCx43F7xc8O9luapV7fcMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/searchMap/index.vue")
  },
  {
    name: "searchMap___es",
    path: "/es/buscar-en-el-mapa",
    meta: indexcC_YwpQW2wza5shY4xyyAiOUCx43F7xc8O9luapV7fcMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/searchMap/index.vue")
  },
  {
    name: "searchMap___bg",
    path: "/bg/%D1%82%D1%8A%D1%80%D1%81%D0%B5%D0%BD%D0%B5-%D0%BA%D0%B0%D1%80%D1%82%D0%B0",
    meta: indexcC_YwpQW2wza5shY4xyyAiOUCx43F7xc8O9luapV7fcMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/searchMap/index.vue")
  },
  {
    name: "searchMap___bs",
    path: "/bs/mapa-pretrage",
    meta: indexcC_YwpQW2wza5shY4xyyAiOUCx43F7xc8O9luapV7fcMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/searchMap/index.vue")
  },
  {
    name: "searchMap___cs",
    path: "/cs/vyhledavaci-mapa",
    meta: indexcC_YwpQW2wza5shY4xyyAiOUCx43F7xc8O9luapV7fcMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/searchMap/index.vue")
  },
  {
    name: "searchMap___da",
    path: "/da/s%C3%B8ge-kort",
    meta: indexcC_YwpQW2wza5shY4xyyAiOUCx43F7xc8O9luapV7fcMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/searchMap/index.vue")
  },
  {
    name: "searchMap___el",
    path: "/el/%CE%B1%CE%BD%CE%B1%CE%B6%CE%B7%CF%84%CE%B7%CF%83%CE%B7-%CF%87%CE%B1%CF%81%CF%84%CE%B7",
    meta: indexcC_YwpQW2wza5shY4xyyAiOUCx43F7xc8O9luapV7fcMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/searchMap/index.vue")
  },
  {
    name: "searchMap___et",
    path: "/et/otsingu-kaart",
    meta: indexcC_YwpQW2wza5shY4xyyAiOUCx43F7xc8O9luapV7fcMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/searchMap/index.vue")
  },
  {
    name: "searchMap___fi",
    path: "/fi/haku-kartta",
    meta: indexcC_YwpQW2wza5shY4xyyAiOUCx43F7xc8O9luapV7fcMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/searchMap/index.vue")
  },
  {
    name: "searchMap___hr",
    path: "/hr/mapa-pretrage",
    meta: indexcC_YwpQW2wza5shY4xyyAiOUCx43F7xc8O9luapV7fcMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/searchMap/index.vue")
  },
  {
    name: "searchMap___hu",
    path: "/hu/kereses-terkepen",
    meta: indexcC_YwpQW2wza5shY4xyyAiOUCx43F7xc8O9luapV7fcMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/searchMap/index.vue")
  },
  {
    name: "searchMap___lt",
    path: "/lt/ieskoti-zemelapyje",
    meta: indexcC_YwpQW2wza5shY4xyyAiOUCx43F7xc8O9luapV7fcMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/searchMap/index.vue")
  },
  {
    name: "searchMap___lv",
    path: "/lv/mekle-karti",
    meta: indexcC_YwpQW2wza5shY4xyyAiOUCx43F7xc8O9luapV7fcMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/searchMap/index.vue")
  },
  {
    name: "searchMap___no",
    path: "/no/soek-kart",
    meta: indexcC_YwpQW2wza5shY4xyyAiOUCx43F7xc8O9luapV7fcMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/searchMap/index.vue")
  },
  {
    name: "searchMap___pl",
    path: "/pl/mapa-wyszukiwania",
    meta: indexcC_YwpQW2wza5shY4xyyAiOUCx43F7xc8O9luapV7fcMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/searchMap/index.vue")
  },
  {
    name: "searchMap___pt",
    path: "/pt/mapa-de-pesquisa",
    meta: indexcC_YwpQW2wza5shY4xyyAiOUCx43F7xc8O9luapV7fcMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/searchMap/index.vue")
  },
  {
    name: "searchMap___ro",
    path: "/ro/cautare-harta",
    meta: indexcC_YwpQW2wza5shY4xyyAiOUCx43F7xc8O9luapV7fcMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/searchMap/index.vue")
  },
  {
    name: "searchMap___ru",
    path: "/ru/%D0%BF%D0%BE%D0%B8%D1%81%D0%BA-%D0%BD%D0%B0-%D0%BA%D0%B0%D1%80%D1%82%D0%B5",
    meta: indexcC_YwpQW2wza5shY4xyyAiOUCx43F7xc8O9luapV7fcMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/searchMap/index.vue")
  },
  {
    name: "searchMap___sk",
    path: "/sk/hladat-na-mape",
    meta: indexcC_YwpQW2wza5shY4xyyAiOUCx43F7xc8O9luapV7fcMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/searchMap/index.vue")
  },
  {
    name: "searchMap___sl",
    path: "/sl/iskanje-zemljevid",
    meta: indexcC_YwpQW2wza5shY4xyyAiOUCx43F7xc8O9luapV7fcMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/searchMap/index.vue")
  },
  {
    name: "searchMap___sr",
    path: "/sr/pretraga-mape",
    meta: indexcC_YwpQW2wza5shY4xyyAiOUCx43F7xc8O9luapV7fcMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/searchMap/index.vue")
  },
  {
    name: "searchMap___sv",
    path: "/sv/sok-karta",
    meta: indexcC_YwpQW2wza5shY4xyyAiOUCx43F7xc8O9luapV7fcMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/searchMap/index.vue")
  },
  {
    name: "searchMap___tr",
    path: "/tr/haritada-ara",
    meta: indexcC_YwpQW2wza5shY4xyyAiOUCx43F7xc8O9luapV7fcMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/searchMap/index.vue")
  },
  {
    name: "account-login___de",
    path: "/de/account/anmelden",
    meta: indexSBCh5PkIAC_SO_RONs92Lw_2MOuoLREniqayUQ3EExAMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/login/index.vue")
  },
  {
    name: "account-login___en",
    path: "/en/account/login",
    meta: indexSBCh5PkIAC_SO_RONs92Lw_2MOuoLREniqayUQ3EExAMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/login/index.vue")
  },
  {
    name: "account-login___nl",
    path: "/nl/account/inlog-formulier",
    meta: indexSBCh5PkIAC_SO_RONs92Lw_2MOuoLREniqayUQ3EExAMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/login/index.vue")
  },
  {
    name: "account-login___fr",
    path: "/fr/account/formulaire-de-connexion",
    meta: indexSBCh5PkIAC_SO_RONs92Lw_2MOuoLREniqayUQ3EExAMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/login/index.vue")
  },
  {
    name: "account-login___it",
    path: "/it/account/modulo-login",
    meta: indexSBCh5PkIAC_SO_RONs92Lw_2MOuoLREniqayUQ3EExAMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/login/index.vue")
  },
  {
    name: "account-login___es",
    path: "/es/account/iniciar-sesi%C3%B3n",
    meta: indexSBCh5PkIAC_SO_RONs92Lw_2MOuoLREniqayUQ3EExAMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/login/index.vue")
  },
  {
    name: "account-login___bg",
    path: "/bg/account/%D0%B2%D0%BF%D0%B8%D1%81%D0%B2%D0%B0%D0%BD%D0%B5-%D0%B1%D0%BB%D0%B0%D0%BD%D0%BA%D0%B0",
    meta: indexSBCh5PkIAC_SO_RONs92Lw_2MOuoLREniqayUQ3EExAMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/login/index.vue")
  },
  {
    name: "account-login___bs",
    path: "/bs/account/forma-za-prijavu",
    meta: indexSBCh5PkIAC_SO_RONs92Lw_2MOuoLREniqayUQ3EExAMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/login/index.vue")
  },
  {
    name: "account-login___cs",
    path: "/cs/account/prihlasovaci-formular",
    meta: indexSBCh5PkIAC_SO_RONs92Lw_2MOuoLREniqayUQ3EExAMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/login/index.vue")
  },
  {
    name: "account-login___da",
    path: "/da/account/login-form",
    meta: indexSBCh5PkIAC_SO_RONs92Lw_2MOuoLREniqayUQ3EExAMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/login/index.vue")
  },
  {
    name: "account-login___el",
    path: "/el/account/%CF%86%CE%BF%CF%81%CE%BC%CE%B1-%CF%83%CF%85%CE%BD%CE%B4%CE%B5%CF%83%CE%B7%CF%82",
    meta: indexSBCh5PkIAC_SO_RONs92Lw_2MOuoLREniqayUQ3EExAMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/login/index.vue")
  },
  {
    name: "account-login___et",
    path: "/et/account/login-vorm",
    meta: indexSBCh5PkIAC_SO_RONs92Lw_2MOuoLREniqayUQ3EExAMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/login/index.vue")
  },
  {
    name: "account-login___fi",
    path: "/fi/account/kirjautumis-lomake",
    meta: indexSBCh5PkIAC_SO_RONs92Lw_2MOuoLREniqayUQ3EExAMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/login/index.vue")
  },
  {
    name: "account-login___hr",
    path: "/hr/account/obrazac-za-prijavu",
    meta: indexSBCh5PkIAC_SO_RONs92Lw_2MOuoLREniqayUQ3EExAMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/login/index.vue")
  },
  {
    name: "account-login___hu",
    path: "/hu/account/bejelentkezesi-urlap",
    meta: indexSBCh5PkIAC_SO_RONs92Lw_2MOuoLREniqayUQ3EExAMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/login/index.vue")
  },
  {
    name: "account-login___lt",
    path: "/lt/account/prisijungimas",
    meta: indexSBCh5PkIAC_SO_RONs92Lw_2MOuoLREniqayUQ3EExAMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/login/index.vue")
  },
  {
    name: "account-login___lv",
    path: "/lv/account/ielogosanas-forma",
    meta: indexSBCh5PkIAC_SO_RONs92Lw_2MOuoLREniqayUQ3EExAMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/login/index.vue")
  },
  {
    name: "account-login___no",
    path: "/no/account/logg-inn-skjema",
    meta: indexSBCh5PkIAC_SO_RONs92Lw_2MOuoLREniqayUQ3EExAMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/login/index.vue")
  },
  {
    name: "account-login___pl",
    path: "/pl/account/formularz-logowania",
    meta: indexSBCh5PkIAC_SO_RONs92Lw_2MOuoLREniqayUQ3EExAMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/login/index.vue")
  },
  {
    name: "account-login___pt",
    path: "/pt/account/formulario-de-login",
    meta: indexSBCh5PkIAC_SO_RONs92Lw_2MOuoLREniqayUQ3EExAMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/login/index.vue")
  },
  {
    name: "account-login___ro",
    path: "/ro/account/formular-conectare",
    meta: indexSBCh5PkIAC_SO_RONs92Lw_2MOuoLREniqayUQ3EExAMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/login/index.vue")
  },
  {
    name: "account-login___ru",
    path: "/ru/account/%D1%84%D0%BE%D1%80%D0%BC%D0%B0-%D0%B2%D1%85%D0%BE%D0%B4%D0%B0-%D0%B2-%D1%81%D0%B8%D1%81%D1%82%D0%B5%D0%BC%D1%83%20",
    meta: indexSBCh5PkIAC_SO_RONs92Lw_2MOuoLREniqayUQ3EExAMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/login/index.vue")
  },
  {
    name: "account-login___sk",
    path: "/sk/account/prihlasovaci-formular",
    meta: indexSBCh5PkIAC_SO_RONs92Lw_2MOuoLREniqayUQ3EExAMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/login/index.vue")
  },
  {
    name: "account-login___sl",
    path: "/sl/account/prijavni-obrazec",
    meta: indexSBCh5PkIAC_SO_RONs92Lw_2MOuoLREniqayUQ3EExAMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/login/index.vue")
  },
  {
    name: "account-login___sr",
    path: "/sr/account/obrazac-prijave",
    meta: indexSBCh5PkIAC_SO_RONs92Lw_2MOuoLREniqayUQ3EExAMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/login/index.vue")
  },
  {
    name: "account-login___sv",
    path: "/sv/account/login-formular",
    meta: indexSBCh5PkIAC_SO_RONs92Lw_2MOuoLREniqayUQ3EExAMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/login/index.vue")
  },
  {
    name: "account-login___tr",
    path: "/tr/account/oturum-acma-formu",
    meta: indexSBCh5PkIAC_SO_RONs92Lw_2MOuoLREniqayUQ3EExAMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/login/index.vue")
  },
  {
    name: "account-media___de",
    path: "/de/account/media",
    meta: index45hAQ5uQTu_JOOUvqQ89nY38OBI3Ml7_s0xnsFWwCUsMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/media/index.vue")
  },
  {
    name: "account-media___en",
    path: "/en/account/media",
    meta: index45hAQ5uQTu_JOOUvqQ89nY38OBI3Ml7_s0xnsFWwCUsMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/media/index.vue")
  },
  {
    name: "account-media___nl",
    path: "/nl/account/media",
    meta: index45hAQ5uQTu_JOOUvqQ89nY38OBI3Ml7_s0xnsFWwCUsMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/media/index.vue")
  },
  {
    name: "account-media___fr",
    path: "/fr/account/media",
    meta: index45hAQ5uQTu_JOOUvqQ89nY38OBI3Ml7_s0xnsFWwCUsMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/media/index.vue")
  },
  {
    name: "account-media___it",
    path: "/it/account/media",
    meta: index45hAQ5uQTu_JOOUvqQ89nY38OBI3Ml7_s0xnsFWwCUsMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/media/index.vue")
  },
  {
    name: "account-media___es",
    path: "/es/account/media",
    meta: index45hAQ5uQTu_JOOUvqQ89nY38OBI3Ml7_s0xnsFWwCUsMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/media/index.vue")
  },
  {
    name: "account-media___bg",
    path: "/bg/account/media",
    meta: index45hAQ5uQTu_JOOUvqQ89nY38OBI3Ml7_s0xnsFWwCUsMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/media/index.vue")
  },
  {
    name: "account-media___bs",
    path: "/bs/account/media",
    meta: index45hAQ5uQTu_JOOUvqQ89nY38OBI3Ml7_s0xnsFWwCUsMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/media/index.vue")
  },
  {
    name: "account-media___cs",
    path: "/cs/account/media",
    meta: index45hAQ5uQTu_JOOUvqQ89nY38OBI3Ml7_s0xnsFWwCUsMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/media/index.vue")
  },
  {
    name: "account-media___da",
    path: "/da/account/media",
    meta: index45hAQ5uQTu_JOOUvqQ89nY38OBI3Ml7_s0xnsFWwCUsMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/media/index.vue")
  },
  {
    name: "account-media___el",
    path: "/el/account/media",
    meta: index45hAQ5uQTu_JOOUvqQ89nY38OBI3Ml7_s0xnsFWwCUsMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/media/index.vue")
  },
  {
    name: "account-media___et",
    path: "/et/account/media",
    meta: index45hAQ5uQTu_JOOUvqQ89nY38OBI3Ml7_s0xnsFWwCUsMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/media/index.vue")
  },
  {
    name: "account-media___fi",
    path: "/fi/account/media",
    meta: index45hAQ5uQTu_JOOUvqQ89nY38OBI3Ml7_s0xnsFWwCUsMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/media/index.vue")
  },
  {
    name: "account-media___hr",
    path: "/hr/account/media",
    meta: index45hAQ5uQTu_JOOUvqQ89nY38OBI3Ml7_s0xnsFWwCUsMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/media/index.vue")
  },
  {
    name: "account-media___hu",
    path: "/hu/account/media",
    meta: index45hAQ5uQTu_JOOUvqQ89nY38OBI3Ml7_s0xnsFWwCUsMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/media/index.vue")
  },
  {
    name: "account-media___lt",
    path: "/lt/account/media",
    meta: index45hAQ5uQTu_JOOUvqQ89nY38OBI3Ml7_s0xnsFWwCUsMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/media/index.vue")
  },
  {
    name: "account-media___lv",
    path: "/lv/account/media",
    meta: index45hAQ5uQTu_JOOUvqQ89nY38OBI3Ml7_s0xnsFWwCUsMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/media/index.vue")
  },
  {
    name: "account-media___no",
    path: "/no/account/media",
    meta: index45hAQ5uQTu_JOOUvqQ89nY38OBI3Ml7_s0xnsFWwCUsMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/media/index.vue")
  },
  {
    name: "account-media___pl",
    path: "/pl/account/media",
    meta: index45hAQ5uQTu_JOOUvqQ89nY38OBI3Ml7_s0xnsFWwCUsMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/media/index.vue")
  },
  {
    name: "account-media___pt",
    path: "/pt/account/media",
    meta: index45hAQ5uQTu_JOOUvqQ89nY38OBI3Ml7_s0xnsFWwCUsMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/media/index.vue")
  },
  {
    name: "account-media___ro",
    path: "/ro/account/media",
    meta: index45hAQ5uQTu_JOOUvqQ89nY38OBI3Ml7_s0xnsFWwCUsMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/media/index.vue")
  },
  {
    name: "account-media___ru",
    path: "/ru/account/media",
    meta: index45hAQ5uQTu_JOOUvqQ89nY38OBI3Ml7_s0xnsFWwCUsMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/media/index.vue")
  },
  {
    name: "account-media___sk",
    path: "/sk/account/media",
    meta: index45hAQ5uQTu_JOOUvqQ89nY38OBI3Ml7_s0xnsFWwCUsMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/media/index.vue")
  },
  {
    name: "account-media___sl",
    path: "/sl/account/media",
    meta: index45hAQ5uQTu_JOOUvqQ89nY38OBI3Ml7_s0xnsFWwCUsMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/media/index.vue")
  },
  {
    name: "account-media___sr",
    path: "/sr/account/media",
    meta: index45hAQ5uQTu_JOOUvqQ89nY38OBI3Ml7_s0xnsFWwCUsMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/media/index.vue")
  },
  {
    name: "account-media___sv",
    path: "/sv/account/media",
    meta: index45hAQ5uQTu_JOOUvqQ89nY38OBI3Ml7_s0xnsFWwCUsMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/media/index.vue")
  },
  {
    name: "account-media___tr",
    path: "/tr/account/media",
    meta: index45hAQ5uQTu_JOOUvqQ89nY38OBI3Ml7_s0xnsFWwCUsMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/media/index.vue")
  },
  {
    name: "popularRegion___de",
    path: "/de/beliebte-region",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/popularRegion/index.vue")
  },
  {
    name: "popularRegion___en",
    path: "/en/popular-region",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/popularRegion/index.vue")
  },
  {
    name: "popularRegion___nl",
    path: "/nl/populaire-landen",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/popularRegion/index.vue")
  },
  {
    name: "popularRegion___fr",
    path: "/fr/region-populaire",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/popularRegion/index.vue")
  },
  {
    name: "popularRegion___it",
    path: "/it/regione-popolare",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/popularRegion/index.vue")
  },
  {
    name: "popularRegion___es",
    path: "/es/regi%C3%B3n-popular",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/popularRegion/index.vue")
  },
  {
    name: "popularRegion___bg",
    path: "/bg/%D0%BF%D0%BE%D0%BF%D1%83%D0%BB%D1%8F%D1%80%D0%BD%D0%B0-%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/popularRegion/index.vue")
  },
  {
    name: "popularRegion___bs",
    path: "/bs/popularan-region",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/popularRegion/index.vue")
  },
  {
    name: "popularRegion___cs",
    path: "/cs/oblibene-regiony",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/popularRegion/index.vue")
  },
  {
    name: "popularRegion___da",
    path: "/da/popul%C3%A6r-region",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/popularRegion/index.vue")
  },
  {
    name: "popularRegion___el",
    path: "/el/%CE%B4%CE%B7%CE%BC%CE%BF%CF%86%CE%B9%CE%BB%CE%B7%CF%82-%CF%80%CE%B5%CF%81%CE%B9%CE%BF%CF%87%CE%B7",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/popularRegion/index.vue")
  },
  {
    name: "popularRegion___et",
    path: "/et/populaarne-piirkond",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/popularRegion/index.vue")
  },
  {
    name: "popularRegion___fi",
    path: "/fi/suosittu-alue",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/popularRegion/index.vue")
  },
  {
    name: "popularRegion___hr",
    path: "/hr/popularna-regija",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/popularRegion/index.vue")
  },
  {
    name: "popularRegion___hu",
    path: "/hu/nepszeru-regio",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/popularRegion/index.vue")
  },
  {
    name: "popularRegion___lt",
    path: "/lt/populiarus-regionas",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/popularRegion/index.vue")
  },
  {
    name: "popularRegion___lv",
    path: "/lv/populari-regioni",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/popularRegion/index.vue")
  },
  {
    name: "popularRegion___no",
    path: "/no/populaer-region",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/popularRegion/index.vue")
  },
  {
    name: "popularRegion___pl",
    path: "/pl/popularny-region",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/popularRegion/index.vue")
  },
  {
    name: "popularRegion___pt",
    path: "/pt/regiao-popular",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/popularRegion/index.vue")
  },
  {
    name: "popularRegion___ro",
    path: "/ro/regiune-populara",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/popularRegion/index.vue")
  },
  {
    name: "popularRegion___ru",
    path: "/ru/%D0%BF%D0%BE%D0%BF%D1%83%D0%BB%D1%8F%D1%80%D0%BD%D1%8B%D0%B8-%D1%80%D0%B5%D0%B3%D0%B8%D0%BE%D0%BD",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/popularRegion/index.vue")
  },
  {
    name: "popularRegion___sk",
    path: "/sk/popularna-oblast",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/popularRegion/index.vue")
  },
  {
    name: "popularRegion___sl",
    path: "/sl/priljubljena-regija",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/popularRegion/index.vue")
  },
  {
    name: "popularRegion___sr",
    path: "/sr/popularan-region",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/popularRegion/index.vue")
  },
  {
    name: "popularRegion___sv",
    path: "/sv/popular-region",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/popularRegion/index.vue")
  },
  {
    name: "popularRegion___tr",
    path: "/tr/populer-bolge",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/popularRegion/index.vue")
  },
  {
    name: "account-profile___de",
    path: "/de/account/profile",
    meta: indexhlSN1VF0eQAzJDhyl1giArp_g0CQPDsWUoVGXJl13WkMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/profile/index.vue")
  },
  {
    name: "account-profile___en",
    path: "/en/account/profile",
    meta: indexhlSN1VF0eQAzJDhyl1giArp_g0CQPDsWUoVGXJl13WkMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/profile/index.vue")
  },
  {
    name: "account-profile___nl",
    path: "/nl/account/profile",
    meta: indexhlSN1VF0eQAzJDhyl1giArp_g0CQPDsWUoVGXJl13WkMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/profile/index.vue")
  },
  {
    name: "account-profile___fr",
    path: "/fr/account/profile",
    meta: indexhlSN1VF0eQAzJDhyl1giArp_g0CQPDsWUoVGXJl13WkMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/profile/index.vue")
  },
  {
    name: "account-profile___it",
    path: "/it/account/profile",
    meta: indexhlSN1VF0eQAzJDhyl1giArp_g0CQPDsWUoVGXJl13WkMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/profile/index.vue")
  },
  {
    name: "account-profile___es",
    path: "/es/account/profile",
    meta: indexhlSN1VF0eQAzJDhyl1giArp_g0CQPDsWUoVGXJl13WkMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/profile/index.vue")
  },
  {
    name: "account-profile___bg",
    path: "/bg/account/profile",
    meta: indexhlSN1VF0eQAzJDhyl1giArp_g0CQPDsWUoVGXJl13WkMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/profile/index.vue")
  },
  {
    name: "account-profile___bs",
    path: "/bs/account/profile",
    meta: indexhlSN1VF0eQAzJDhyl1giArp_g0CQPDsWUoVGXJl13WkMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/profile/index.vue")
  },
  {
    name: "account-profile___cs",
    path: "/cs/account/profile",
    meta: indexhlSN1VF0eQAzJDhyl1giArp_g0CQPDsWUoVGXJl13WkMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/profile/index.vue")
  },
  {
    name: "account-profile___da",
    path: "/da/account/profile",
    meta: indexhlSN1VF0eQAzJDhyl1giArp_g0CQPDsWUoVGXJl13WkMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/profile/index.vue")
  },
  {
    name: "account-profile___el",
    path: "/el/account/profile",
    meta: indexhlSN1VF0eQAzJDhyl1giArp_g0CQPDsWUoVGXJl13WkMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/profile/index.vue")
  },
  {
    name: "account-profile___et",
    path: "/et/account/profile",
    meta: indexhlSN1VF0eQAzJDhyl1giArp_g0CQPDsWUoVGXJl13WkMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/profile/index.vue")
  },
  {
    name: "account-profile___fi",
    path: "/fi/account/profile",
    meta: indexhlSN1VF0eQAzJDhyl1giArp_g0CQPDsWUoVGXJl13WkMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/profile/index.vue")
  },
  {
    name: "account-profile___hr",
    path: "/hr/account/profile",
    meta: indexhlSN1VF0eQAzJDhyl1giArp_g0CQPDsWUoVGXJl13WkMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/profile/index.vue")
  },
  {
    name: "account-profile___hu",
    path: "/hu/account/profile",
    meta: indexhlSN1VF0eQAzJDhyl1giArp_g0CQPDsWUoVGXJl13WkMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/profile/index.vue")
  },
  {
    name: "account-profile___lt",
    path: "/lt/account/profile",
    meta: indexhlSN1VF0eQAzJDhyl1giArp_g0CQPDsWUoVGXJl13WkMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/profile/index.vue")
  },
  {
    name: "account-profile___lv",
    path: "/lv/account/profile",
    meta: indexhlSN1VF0eQAzJDhyl1giArp_g0CQPDsWUoVGXJl13WkMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/profile/index.vue")
  },
  {
    name: "account-profile___no",
    path: "/no/account/profile",
    meta: indexhlSN1VF0eQAzJDhyl1giArp_g0CQPDsWUoVGXJl13WkMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/profile/index.vue")
  },
  {
    name: "account-profile___pl",
    path: "/pl/account/profile",
    meta: indexhlSN1VF0eQAzJDhyl1giArp_g0CQPDsWUoVGXJl13WkMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/profile/index.vue")
  },
  {
    name: "account-profile___pt",
    path: "/pt/account/profile",
    meta: indexhlSN1VF0eQAzJDhyl1giArp_g0CQPDsWUoVGXJl13WkMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/profile/index.vue")
  },
  {
    name: "account-profile___ro",
    path: "/ro/account/profile",
    meta: indexhlSN1VF0eQAzJDhyl1giArp_g0CQPDsWUoVGXJl13WkMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/profile/index.vue")
  },
  {
    name: "account-profile___ru",
    path: "/ru/account/profile",
    meta: indexhlSN1VF0eQAzJDhyl1giArp_g0CQPDsWUoVGXJl13WkMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/profile/index.vue")
  },
  {
    name: "account-profile___sk",
    path: "/sk/account/profile",
    meta: indexhlSN1VF0eQAzJDhyl1giArp_g0CQPDsWUoVGXJl13WkMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/profile/index.vue")
  },
  {
    name: "account-profile___sl",
    path: "/sl/account/profile",
    meta: indexhlSN1VF0eQAzJDhyl1giArp_g0CQPDsWUoVGXJl13WkMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/profile/index.vue")
  },
  {
    name: "account-profile___sr",
    path: "/sr/account/profile",
    meta: indexhlSN1VF0eQAzJDhyl1giArp_g0CQPDsWUoVGXJl13WkMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/profile/index.vue")
  },
  {
    name: "account-profile___sv",
    path: "/sv/account/profile",
    meta: indexhlSN1VF0eQAzJDhyl1giArp_g0CQPDsWUoVGXJl13WkMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/profile/index.vue")
  },
  {
    name: "account-profile___tr",
    path: "/tr/account/profile",
    meta: indexhlSN1VF0eQAzJDhyl1giArp_g0CQPDsWUoVGXJl13WkMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/profile/index.vue")
  },
  {
    name: "account-reviews___de",
    path: "/de/account/bewertungen",
    meta: indexljWhkMatVk_QhDSJ_d2N6YcQytqyc1YnJt5svS4g7KQMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/reviews/index.vue")
  },
  {
    name: "account-reviews___en",
    path: "/en/account/reviews",
    meta: indexljWhkMatVk_QhDSJ_d2N6YcQytqyc1YnJt5svS4g7KQMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/reviews/index.vue")
  },
  {
    name: "account-reviews___nl",
    path: "/nl/account/beoordelingen",
    meta: indexljWhkMatVk_QhDSJ_d2N6YcQytqyc1YnJt5svS4g7KQMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/reviews/index.vue")
  },
  {
    name: "account-reviews___fr",
    path: "/fr/account/critiques",
    meta: indexljWhkMatVk_QhDSJ_d2N6YcQytqyc1YnJt5svS4g7KQMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/reviews/index.vue")
  },
  {
    name: "account-reviews___it",
    path: "/it/account/recensioni",
    meta: indexljWhkMatVk_QhDSJ_d2N6YcQytqyc1YnJt5svS4g7KQMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/reviews/index.vue")
  },
  {
    name: "account-reviews___es",
    path: "/es/account/valoraciones",
    meta: indexljWhkMatVk_QhDSJ_d2N6YcQytqyc1YnJt5svS4g7KQMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/reviews/index.vue")
  },
  {
    name: "account-reviews___bg",
    path: "/bg/account/%D0%BC%D0%BD%D0%B5%D0%BD%D0%B8%D1%8F",
    meta: indexljWhkMatVk_QhDSJ_d2N6YcQytqyc1YnJt5svS4g7KQMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/reviews/index.vue")
  },
  {
    name: "account-reviews___bs",
    path: "/bs/account/recenzije",
    meta: indexljWhkMatVk_QhDSJ_d2N6YcQytqyc1YnJt5svS4g7KQMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/reviews/index.vue")
  },
  {
    name: "account-reviews___cs",
    path: "/cs/account/recenze",
    meta: indexljWhkMatVk_QhDSJ_d2N6YcQytqyc1YnJt5svS4g7KQMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/reviews/index.vue")
  },
  {
    name: "account-reviews___da",
    path: "/da/account/anmeldelser",
    meta: indexljWhkMatVk_QhDSJ_d2N6YcQytqyc1YnJt5svS4g7KQMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/reviews/index.vue")
  },
  {
    name: "account-reviews___el",
    path: "/el/account/%CF%83%CF%87%CF%8C%CE%BB%CE%B9%CE%B1",
    meta: indexljWhkMatVk_QhDSJ_d2N6YcQytqyc1YnJt5svS4g7KQMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/reviews/index.vue")
  },
  {
    name: "account-reviews___et",
    path: "/et/account/%C3%BClevaated",
    meta: indexljWhkMatVk_QhDSJ_d2N6YcQytqyc1YnJt5svS4g7KQMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/reviews/index.vue")
  },
  {
    name: "account-reviews___fi",
    path: "/fi/account/arvostelut",
    meta: indexljWhkMatVk_QhDSJ_d2N6YcQytqyc1YnJt5svS4g7KQMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/reviews/index.vue")
  },
  {
    name: "account-reviews___hr",
    path: "/hr/account/recenzije",
    meta: indexljWhkMatVk_QhDSJ_d2N6YcQytqyc1YnJt5svS4g7KQMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/reviews/index.vue")
  },
  {
    name: "account-reviews___hu",
    path: "/hu/account/v%C3%A9lem%C3%A9nyek",
    meta: indexljWhkMatVk_QhDSJ_d2N6YcQytqyc1YnJt5svS4g7KQMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/reviews/index.vue")
  },
  {
    name: "account-reviews___lt",
    path: "/lt/account/atsiliepimai",
    meta: indexljWhkMatVk_QhDSJ_d2N6YcQytqyc1YnJt5svS4g7KQMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/reviews/index.vue")
  },
  {
    name: "account-reviews___lv",
    path: "/lv/account/atsauksmes",
    meta: indexljWhkMatVk_QhDSJ_d2N6YcQytqyc1YnJt5svS4g7KQMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/reviews/index.vue")
  },
  {
    name: "account-reviews___no",
    path: "/no/account/anmeldelser",
    meta: indexljWhkMatVk_QhDSJ_d2N6YcQytqyc1YnJt5svS4g7KQMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/reviews/index.vue")
  },
  {
    name: "account-reviews___pl",
    path: "/pl/account/recenzje",
    meta: indexljWhkMatVk_QhDSJ_d2N6YcQytqyc1YnJt5svS4g7KQMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/reviews/index.vue")
  },
  {
    name: "account-reviews___pt",
    path: "/pt/account/rever",
    meta: indexljWhkMatVk_QhDSJ_d2N6YcQytqyc1YnJt5svS4g7KQMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/reviews/index.vue")
  },
  {
    name: "account-reviews___ro",
    path: "/ro/account/comentarii",
    meta: indexljWhkMatVk_QhDSJ_d2N6YcQytqyc1YnJt5svS4g7KQMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/reviews/index.vue")
  },
  {
    name: "account-reviews___ru",
    path: "/ru/account/%D0%BE%D1%82%D0%B7%D1%8B%D0%B2%D1%8B",
    meta: indexljWhkMatVk_QhDSJ_d2N6YcQytqyc1YnJt5svS4g7KQMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/reviews/index.vue")
  },
  {
    name: "account-reviews___sk",
    path: "/sk/account/recenzia",
    meta: indexljWhkMatVk_QhDSJ_d2N6YcQytqyc1YnJt5svS4g7KQMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/reviews/index.vue")
  },
  {
    name: "account-reviews___sl",
    path: "/sl/account/pregledi",
    meta: indexljWhkMatVk_QhDSJ_d2N6YcQytqyc1YnJt5svS4g7KQMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/reviews/index.vue")
  },
  {
    name: "account-reviews___sr",
    path: "/sr/account/mi%C5%A1ljenja",
    meta: indexljWhkMatVk_QhDSJ_d2N6YcQytqyc1YnJt5svS4g7KQMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/reviews/index.vue")
  },
  {
    name: "account-reviews___sv",
    path: "/sv/account/recensioner",
    meta: indexljWhkMatVk_QhDSJ_d2N6YcQytqyc1YnJt5svS4g7KQMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/reviews/index.vue")
  },
  {
    name: "account-reviews___tr",
    path: "/tr/account/yorumlar",
    meta: indexljWhkMatVk_QhDSJ_d2N6YcQytqyc1YnJt5svS4g7KQMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/reviews/index.vue")
  },
  {
    name: "city-citySlug___de",
    path: "/de/stadt/:citySlug()",
    meta: { ...(index4IUqchCD6RD31oEGayz3Yw8Fg9HItLurOWm5yQP0Ao8Meta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/city/[citySlug]/index.vue")
  },
  {
    name: "city-citySlug___en",
    path: "/en/city/:citySlug()",
    meta: { ...(index4IUqchCD6RD31oEGayz3Yw8Fg9HItLurOWm5yQP0Ao8Meta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/city/[citySlug]/index.vue")
  },
  {
    name: "city-citySlug___nl",
    path: "/nl/stad/:citySlug()",
    meta: { ...(index4IUqchCD6RD31oEGayz3Yw8Fg9HItLurOWm5yQP0Ao8Meta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/city/[citySlug]/index.vue")
  },
  {
    name: "city-citySlug___fr",
    path: "/fr/ville/:citySlug()",
    meta: { ...(index4IUqchCD6RD31oEGayz3Yw8Fg9HItLurOWm5yQP0Ao8Meta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/city/[citySlug]/index.vue")
  },
  {
    name: "city-citySlug___it",
    path: "/it/citt%C3%A0/:citySlug()",
    meta: { ...(index4IUqchCD6RD31oEGayz3Yw8Fg9HItLurOWm5yQP0Ao8Meta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/city/[citySlug]/index.vue")
  },
  {
    name: "city-citySlug___es",
    path: "/es/ciudad/:citySlug()",
    meta: { ...(index4IUqchCD6RD31oEGayz3Yw8Fg9HItLurOWm5yQP0Ao8Meta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/city/[citySlug]/index.vue")
  },
  {
    name: "city-citySlug___bg",
    path: "/bg/%D0%B3%D1%80%D0%B0%D0%B4/:citySlug()",
    meta: { ...(index4IUqchCD6RD31oEGayz3Yw8Fg9HItLurOWm5yQP0Ao8Meta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/city/[citySlug]/index.vue")
  },
  {
    name: "city-citySlug___bs",
    path: "/bs/grad/:citySlug()",
    meta: { ...(index4IUqchCD6RD31oEGayz3Yw8Fg9HItLurOWm5yQP0Ao8Meta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/city/[citySlug]/index.vue")
  },
  {
    name: "city-citySlug___cs",
    path: "/cs/grad/:citySlug()",
    meta: { ...(index4IUqchCD6RD31oEGayz3Yw8Fg9HItLurOWm5yQP0Ao8Meta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/city/[citySlug]/index.vue")
  },
  {
    name: "city-citySlug___da",
    path: "/da/by/:citySlug()",
    meta: { ...(index4IUqchCD6RD31oEGayz3Yw8Fg9HItLurOWm5yQP0Ao8Meta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/city/[citySlug]/index.vue")
  },
  {
    name: "city-citySlug___el",
    path: "/el/%CF%80%CF%8C%CE%BB%CE%B7/:citySlug()",
    meta: { ...(index4IUqchCD6RD31oEGayz3Yw8Fg9HItLurOWm5yQP0Ao8Meta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/city/[citySlug]/index.vue")
  },
  {
    name: "city-citySlug___et",
    path: "/et/linn/:citySlug()",
    meta: { ...(index4IUqchCD6RD31oEGayz3Yw8Fg9HItLurOWm5yQP0Ao8Meta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/city/[citySlug]/index.vue")
  },
  {
    name: "city-citySlug___fi",
    path: "/fi/kaupunki/:citySlug()",
    meta: { ...(index4IUqchCD6RD31oEGayz3Yw8Fg9HItLurOWm5yQP0Ao8Meta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/city/[citySlug]/index.vue")
  },
  {
    name: "city-citySlug___hr",
    path: "/hr/grad/:citySlug()",
    meta: { ...(index4IUqchCD6RD31oEGayz3Yw8Fg9HItLurOWm5yQP0Ao8Meta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/city/[citySlug]/index.vue")
  },
  {
    name: "city-citySlug___hu",
    path: "/hu/v%C3%A1ros/:citySlug()",
    meta: { ...(index4IUqchCD6RD31oEGayz3Yw8Fg9HItLurOWm5yQP0Ao8Meta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/city/[citySlug]/index.vue")
  },
  {
    name: "city-citySlug___lt",
    path: "/lt/miestas/:citySlug()",
    meta: { ...(index4IUqchCD6RD31oEGayz3Yw8Fg9HItLurOWm5yQP0Ao8Meta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/city/[citySlug]/index.vue")
  },
  {
    name: "city-citySlug___lv",
    path: "/lv/pils%C4%93ta/:citySlug()",
    meta: { ...(index4IUqchCD6RD31oEGayz3Yw8Fg9HItLurOWm5yQP0Ao8Meta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/city/[citySlug]/index.vue")
  },
  {
    name: "city-citySlug___no",
    path: "/no/by/:citySlug()",
    meta: { ...(index4IUqchCD6RD31oEGayz3Yw8Fg9HItLurOWm5yQP0Ao8Meta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/city/[citySlug]/index.vue")
  },
  {
    name: "city-citySlug___pl",
    path: "/pl/miasto/:citySlug()",
    meta: { ...(index4IUqchCD6RD31oEGayz3Yw8Fg9HItLurOWm5yQP0Ao8Meta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/city/[citySlug]/index.vue")
  },
  {
    name: "city-citySlug___pt",
    path: "/pt/cidade/:citySlug()",
    meta: { ...(index4IUqchCD6RD31oEGayz3Yw8Fg9HItLurOWm5yQP0Ao8Meta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/city/[citySlug]/index.vue")
  },
  {
    name: "city-citySlug___ro",
    path: "/ro/ora%C8%99/:citySlug()",
    meta: { ...(index4IUqchCD6RD31oEGayz3Yw8Fg9HItLurOWm5yQP0Ao8Meta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/city/[citySlug]/index.vue")
  },
  {
    name: "city-citySlug___ru",
    path: "/ru/%D0%B3%D0%BE%D1%80%D0%BE%D0%B4/:citySlug()",
    meta: { ...(index4IUqchCD6RD31oEGayz3Yw8Fg9HItLurOWm5yQP0Ao8Meta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/city/[citySlug]/index.vue")
  },
  {
    name: "city-citySlug___sk",
    path: "/sk/mesto/:citySlug()",
    meta: { ...(index4IUqchCD6RD31oEGayz3Yw8Fg9HItLurOWm5yQP0Ao8Meta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/city/[citySlug]/index.vue")
  },
  {
    name: "city-citySlug___sl",
    path: "/sl/mesto/:citySlug()",
    meta: { ...(index4IUqchCD6RD31oEGayz3Yw8Fg9HItLurOWm5yQP0Ao8Meta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/city/[citySlug]/index.vue")
  },
  {
    name: "city-citySlug___sr",
    path: "/sr/%D0%B3%D1%80%D0%B0%D0%B4/:citySlug()",
    meta: { ...(index4IUqchCD6RD31oEGayz3Yw8Fg9HItLurOWm5yQP0Ao8Meta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/city/[citySlug]/index.vue")
  },
  {
    name: "city-citySlug___sv",
    path: "/sv/stad/:citySlug()",
    meta: { ...(index4IUqchCD6RD31oEGayz3Yw8Fg9HItLurOWm5yQP0Ao8Meta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/city/[citySlug]/index.vue")
  },
  {
    name: "city-citySlug___tr",
    path: "/tr/kent/:citySlug()",
    meta: { ...(index4IUqchCD6RD31oEGayz3Yw8Fg9HItLurOWm5yQP0Ao8Meta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/city/[citySlug]/index.vue")
  },
  {
    name: "account-register___de",
    path: "/de/account/registrieren",
    meta: indexSS_8eDuhxcj1DZk6mIC__3eC1jdCvFwfD5i4M7j2F_gMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/register/index.vue")
  },
  {
    name: "account-register___en",
    path: "/en/account/register",
    meta: indexSS_8eDuhxcj1DZk6mIC__3eC1jdCvFwfD5i4M7j2F_gMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/register/index.vue")
  },
  {
    name: "account-register___nl",
    path: "/nl/account/registratieformulier",
    meta: indexSS_8eDuhxcj1DZk6mIC__3eC1jdCvFwfD5i4M7j2F_gMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/register/index.vue")
  },
  {
    name: "account-register___fr",
    path: "/fr/account/formulaire-d-inscription",
    meta: indexSS_8eDuhxcj1DZk6mIC__3eC1jdCvFwfD5i4M7j2F_gMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/register/index.vue")
  },
  {
    name: "account-register___it",
    path: "/it/account/modulo-registrazione",
    meta: indexSS_8eDuhxcj1DZk6mIC__3eC1jdCvFwfD5i4M7j2F_gMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/register/index.vue")
  },
  {
    name: "account-register___es",
    path: "/es/account/registro",
    meta: indexSS_8eDuhxcj1DZk6mIC__3eC1jdCvFwfD5i4M7j2F_gMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/register/index.vue")
  },
  {
    name: "account-register___bg",
    path: "/bg/account/%D1%80%D0%B5%D0%B3%D0%B8%D1%81%D1%82%D1%80%D0%B0%D1%86%D0%B8%D1%8F-%D0%B1%D0%BB%D0%B0%D0%BD%D0%BA%D0%B0",
    meta: indexSS_8eDuhxcj1DZk6mIC__3eC1jdCvFwfD5i4M7j2F_gMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/register/index.vue")
  },
  {
    name: "account-register___bs",
    path: "/bs/account/registraciona-forma",
    meta: indexSS_8eDuhxcj1DZk6mIC__3eC1jdCvFwfD5i4M7j2F_gMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/register/index.vue")
  },
  {
    name: "account-register___cs",
    path: "/cs/account/registracni-formular",
    meta: indexSS_8eDuhxcj1DZk6mIC__3eC1jdCvFwfD5i4M7j2F_gMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/register/index.vue")
  },
  {
    name: "account-register___da",
    path: "/da/account/tilmeldings-form",
    meta: indexSS_8eDuhxcj1DZk6mIC__3eC1jdCvFwfD5i4M7j2F_gMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/register/index.vue")
  },
  {
    name: "account-register___el",
    path: "/el/account/%CF%86%CE%BF%CF%81%CE%BC%CE%B1-%CE%B5%CE%B3%CE%B3%CF%81%CE%B1%CF%86%CE%B7%CF%82",
    meta: indexSS_8eDuhxcj1DZk6mIC__3eC1jdCvFwfD5i4M7j2F_gMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/register/index.vue")
  },
  {
    name: "account-register___et",
    path: "/et/account/registreerimise-vorm",
    meta: indexSS_8eDuhxcj1DZk6mIC__3eC1jdCvFwfD5i4M7j2F_gMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/register/index.vue")
  },
  {
    name: "account-register___fi",
    path: "/fi/account/rekisterointi-lomake",
    meta: indexSS_8eDuhxcj1DZk6mIC__3eC1jdCvFwfD5i4M7j2F_gMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/register/index.vue")
  },
  {
    name: "account-register___hr",
    path: "/hr/account/obrazac-za-registraciju",
    meta: indexSS_8eDuhxcj1DZk6mIC__3eC1jdCvFwfD5i4M7j2F_gMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/register/index.vue")
  },
  {
    name: "account-register___hu",
    path: "/hu/account/regisztracios-urlap",
    meta: indexSS_8eDuhxcj1DZk6mIC__3eC1jdCvFwfD5i4M7j2F_gMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/register/index.vue")
  },
  {
    name: "account-register___lt",
    path: "/lt/account/registracija",
    meta: indexSS_8eDuhxcj1DZk6mIC__3eC1jdCvFwfD5i4M7j2F_gMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/register/index.vue")
  },
  {
    name: "account-register___lv",
    path: "/lv/account/registracijas-veidlapa",
    meta: indexSS_8eDuhxcj1DZk6mIC__3eC1jdCvFwfD5i4M7j2F_gMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/register/index.vue")
  },
  {
    name: "account-register___no",
    path: "/no/account/registreringsskjema",
    meta: indexSS_8eDuhxcj1DZk6mIC__3eC1jdCvFwfD5i4M7j2F_gMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/register/index.vue")
  },
  {
    name: "account-register___pl",
    path: "/pl/account/formularz-rejestracyjny",
    meta: indexSS_8eDuhxcj1DZk6mIC__3eC1jdCvFwfD5i4M7j2F_gMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/register/index.vue")
  },
  {
    name: "account-register___pt",
    path: "/pt/account/formulario-de-registro",
    meta: indexSS_8eDuhxcj1DZk6mIC__3eC1jdCvFwfD5i4M7j2F_gMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/register/index.vue")
  },
  {
    name: "account-register___ro",
    path: "/ro/account/formular-inregistrare",
    meta: indexSS_8eDuhxcj1DZk6mIC__3eC1jdCvFwfD5i4M7j2F_gMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/register/index.vue")
  },
  {
    name: "account-register___ru",
    path: "/ru/account/%D1%84%D0%BE%D1%80%D0%BC%D0%B0-%D1%80%D0%B5%D0%B3%D0%B8%D1%81%D1%82%D1%80%D0%B0%D1%86%D0%B8%D0%B8",
    meta: indexSS_8eDuhxcj1DZk6mIC__3eC1jdCvFwfD5i4M7j2F_gMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/register/index.vue")
  },
  {
    name: "account-register___sk",
    path: "/sk/account/registracny-formular",
    meta: indexSS_8eDuhxcj1DZk6mIC__3eC1jdCvFwfD5i4M7j2F_gMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/register/index.vue")
  },
  {
    name: "account-register___sl",
    path: "/sl/account/registracija-obrazec",
    meta: indexSS_8eDuhxcj1DZk6mIC__3eC1jdCvFwfD5i4M7j2F_gMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/register/index.vue")
  },
  {
    name: "account-register___sr",
    path: "/sr/account/obrazac-registracije",
    meta: indexSS_8eDuhxcj1DZk6mIC__3eC1jdCvFwfD5i4M7j2F_gMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/register/index.vue")
  },
  {
    name: "account-register___sv",
    path: "/sv/account/registreringsformular",
    meta: indexSS_8eDuhxcj1DZk6mIC__3eC1jdCvFwfD5i4M7j2F_gMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/register/index.vue")
  },
  {
    name: "account-register___tr",
    path: "/tr/account/kayit-formu",
    meta: indexSS_8eDuhxcj1DZk6mIC__3eC1jdCvFwfD5i4M7j2F_gMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/register/index.vue")
  },
  {
    name: "account-favorites___de",
    path: "/de/account/favorites",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/favorites/index.vue")
  },
  {
    name: "account-favorites___en",
    path: "/en/account/favorites",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/favorites/index.vue")
  },
  {
    name: "account-favorites___nl",
    path: "/nl/account/favorites",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/favorites/index.vue")
  },
  {
    name: "account-favorites___fr",
    path: "/fr/account/favorites",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/favorites/index.vue")
  },
  {
    name: "account-favorites___it",
    path: "/it/account/favorites",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/favorites/index.vue")
  },
  {
    name: "account-favorites___es",
    path: "/es/account/favorites",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/favorites/index.vue")
  },
  {
    name: "account-favorites___bg",
    path: "/bg/account/favorites",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/favorites/index.vue")
  },
  {
    name: "account-favorites___bs",
    path: "/bs/account/favorites",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/favorites/index.vue")
  },
  {
    name: "account-favorites___cs",
    path: "/cs/account/favorites",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/favorites/index.vue")
  },
  {
    name: "account-favorites___da",
    path: "/da/account/favorites",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/favorites/index.vue")
  },
  {
    name: "account-favorites___el",
    path: "/el/account/favorites",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/favorites/index.vue")
  },
  {
    name: "account-favorites___et",
    path: "/et/account/favorites",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/favorites/index.vue")
  },
  {
    name: "account-favorites___fi",
    path: "/fi/account/favorites",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/favorites/index.vue")
  },
  {
    name: "account-favorites___hr",
    path: "/hr/account/favorites",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/favorites/index.vue")
  },
  {
    name: "account-favorites___hu",
    path: "/hu/account/favorites",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/favorites/index.vue")
  },
  {
    name: "account-favorites___lt",
    path: "/lt/account/favorites",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/favorites/index.vue")
  },
  {
    name: "account-favorites___lv",
    path: "/lv/account/favorites",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/favorites/index.vue")
  },
  {
    name: "account-favorites___no",
    path: "/no/account/favorites",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/favorites/index.vue")
  },
  {
    name: "account-favorites___pl",
    path: "/pl/account/favorites",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/favorites/index.vue")
  },
  {
    name: "account-favorites___pt",
    path: "/pt/account/favorites",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/favorites/index.vue")
  },
  {
    name: "account-favorites___ro",
    path: "/ro/account/favorites",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/favorites/index.vue")
  },
  {
    name: "account-favorites___ru",
    path: "/ru/account/favorites",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/favorites/index.vue")
  },
  {
    name: "account-favorites___sk",
    path: "/sk/account/favorites",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/favorites/index.vue")
  },
  {
    name: "account-favorites___sl",
    path: "/sl/account/favorites",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/favorites/index.vue")
  },
  {
    name: "account-favorites___sr",
    path: "/sr/account/favorites",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/favorites/index.vue")
  },
  {
    name: "account-favorites___sv",
    path: "/sv/account/favorites",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/favorites/index.vue")
  },
  {
    name: "account-favorites___tr",
    path: "/tr/account/favorites",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/favorites/index.vue")
  },
  {
    name: "account-change-mail___de",
    path: "/de/account/change-mail",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/change-mail/index.vue")
  },
  {
    name: "account-change-mail___en",
    path: "/en/account/change-mail",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/change-mail/index.vue")
  },
  {
    name: "account-change-mail___nl",
    path: "/nl/account/change-mail",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/change-mail/index.vue")
  },
  {
    name: "account-change-mail___fr",
    path: "/fr/account/change-mail",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/change-mail/index.vue")
  },
  {
    name: "account-change-mail___it",
    path: "/it/account/change-mail",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/change-mail/index.vue")
  },
  {
    name: "account-change-mail___es",
    path: "/es/account/change-mail",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/change-mail/index.vue")
  },
  {
    name: "account-change-mail___bg",
    path: "/bg/account/change-mail",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/change-mail/index.vue")
  },
  {
    name: "account-change-mail___bs",
    path: "/bs/account/change-mail",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/change-mail/index.vue")
  },
  {
    name: "account-change-mail___cs",
    path: "/cs/account/change-mail",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/change-mail/index.vue")
  },
  {
    name: "account-change-mail___da",
    path: "/da/account/change-mail",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/change-mail/index.vue")
  },
  {
    name: "account-change-mail___el",
    path: "/el/account/change-mail",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/change-mail/index.vue")
  },
  {
    name: "account-change-mail___et",
    path: "/et/account/change-mail",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/change-mail/index.vue")
  },
  {
    name: "account-change-mail___fi",
    path: "/fi/account/change-mail",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/change-mail/index.vue")
  },
  {
    name: "account-change-mail___hr",
    path: "/hr/account/change-mail",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/change-mail/index.vue")
  },
  {
    name: "account-change-mail___hu",
    path: "/hu/account/change-mail",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/change-mail/index.vue")
  },
  {
    name: "account-change-mail___lt",
    path: "/lt/account/change-mail",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/change-mail/index.vue")
  },
  {
    name: "account-change-mail___lv",
    path: "/lv/account/change-mail",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/change-mail/index.vue")
  },
  {
    name: "account-change-mail___no",
    path: "/no/account/change-mail",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/change-mail/index.vue")
  },
  {
    name: "account-change-mail___pl",
    path: "/pl/account/change-mail",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/change-mail/index.vue")
  },
  {
    name: "account-change-mail___pt",
    path: "/pt/account/change-mail",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/change-mail/index.vue")
  },
  {
    name: "account-change-mail___ro",
    path: "/ro/account/change-mail",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/change-mail/index.vue")
  },
  {
    name: "account-change-mail___ru",
    path: "/ru/account/change-mail",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/change-mail/index.vue")
  },
  {
    name: "account-change-mail___sk",
    path: "/sk/account/change-mail",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/change-mail/index.vue")
  },
  {
    name: "account-change-mail___sl",
    path: "/sl/account/change-mail",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/change-mail/index.vue")
  },
  {
    name: "account-change-mail___sr",
    path: "/sr/account/change-mail",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/change-mail/index.vue")
  },
  {
    name: "account-change-mail___sv",
    path: "/sv/account/change-mail",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/change-mail/index.vue")
  },
  {
    name: "account-change-mail___tr",
    path: "/tr/account/change-mail",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/change-mail/index.vue")
  },
  {
    name: "account-email-optin___de",
    path: "/de/account/email-optin",
    meta: index_DXBtsq6QZ6pag4mXND2_wd1HXOakDbS0C0zk1cJu3YMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/email-optin/index.vue")
  },
  {
    name: "account-email-optin___en",
    path: "/en/account/email-optin",
    meta: index_DXBtsq6QZ6pag4mXND2_wd1HXOakDbS0C0zk1cJu3YMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/email-optin/index.vue")
  },
  {
    name: "account-email-optin___nl",
    path: "/nl/account/email-optin",
    meta: index_DXBtsq6QZ6pag4mXND2_wd1HXOakDbS0C0zk1cJu3YMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/email-optin/index.vue")
  },
  {
    name: "account-email-optin___fr",
    path: "/fr/account/email-optin",
    meta: index_DXBtsq6QZ6pag4mXND2_wd1HXOakDbS0C0zk1cJu3YMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/email-optin/index.vue")
  },
  {
    name: "account-email-optin___it",
    path: "/it/account/email-optin",
    meta: index_DXBtsq6QZ6pag4mXND2_wd1HXOakDbS0C0zk1cJu3YMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/email-optin/index.vue")
  },
  {
    name: "account-email-optin___es",
    path: "/es/account/email-optin",
    meta: index_DXBtsq6QZ6pag4mXND2_wd1HXOakDbS0C0zk1cJu3YMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/email-optin/index.vue")
  },
  {
    name: "account-email-optin___bg",
    path: "/bg/account/email-optin",
    meta: index_DXBtsq6QZ6pag4mXND2_wd1HXOakDbS0C0zk1cJu3YMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/email-optin/index.vue")
  },
  {
    name: "account-email-optin___bs",
    path: "/bs/account/email-optin",
    meta: index_DXBtsq6QZ6pag4mXND2_wd1HXOakDbS0C0zk1cJu3YMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/email-optin/index.vue")
  },
  {
    name: "account-email-optin___cs",
    path: "/cs/account/email-optin",
    meta: index_DXBtsq6QZ6pag4mXND2_wd1HXOakDbS0C0zk1cJu3YMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/email-optin/index.vue")
  },
  {
    name: "account-email-optin___da",
    path: "/da/account/email-optin",
    meta: index_DXBtsq6QZ6pag4mXND2_wd1HXOakDbS0C0zk1cJu3YMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/email-optin/index.vue")
  },
  {
    name: "account-email-optin___el",
    path: "/el/account/email-optin",
    meta: index_DXBtsq6QZ6pag4mXND2_wd1HXOakDbS0C0zk1cJu3YMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/email-optin/index.vue")
  },
  {
    name: "account-email-optin___et",
    path: "/et/account/email-optin",
    meta: index_DXBtsq6QZ6pag4mXND2_wd1HXOakDbS0C0zk1cJu3YMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/email-optin/index.vue")
  },
  {
    name: "account-email-optin___fi",
    path: "/fi/account/email-optin",
    meta: index_DXBtsq6QZ6pag4mXND2_wd1HXOakDbS0C0zk1cJu3YMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/email-optin/index.vue")
  },
  {
    name: "account-email-optin___hr",
    path: "/hr/account/email-optin",
    meta: index_DXBtsq6QZ6pag4mXND2_wd1HXOakDbS0C0zk1cJu3YMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/email-optin/index.vue")
  },
  {
    name: "account-email-optin___hu",
    path: "/hu/account/email-optin",
    meta: index_DXBtsq6QZ6pag4mXND2_wd1HXOakDbS0C0zk1cJu3YMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/email-optin/index.vue")
  },
  {
    name: "account-email-optin___lt",
    path: "/lt/account/email-optin",
    meta: index_DXBtsq6QZ6pag4mXND2_wd1HXOakDbS0C0zk1cJu3YMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/email-optin/index.vue")
  },
  {
    name: "account-email-optin___lv",
    path: "/lv/account/email-optin",
    meta: index_DXBtsq6QZ6pag4mXND2_wd1HXOakDbS0C0zk1cJu3YMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/email-optin/index.vue")
  },
  {
    name: "account-email-optin___no",
    path: "/no/account/email-optin",
    meta: index_DXBtsq6QZ6pag4mXND2_wd1HXOakDbS0C0zk1cJu3YMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/email-optin/index.vue")
  },
  {
    name: "account-email-optin___pl",
    path: "/pl/account/email-optin",
    meta: index_DXBtsq6QZ6pag4mXND2_wd1HXOakDbS0C0zk1cJu3YMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/email-optin/index.vue")
  },
  {
    name: "account-email-optin___pt",
    path: "/pt/account/email-optin",
    meta: index_DXBtsq6QZ6pag4mXND2_wd1HXOakDbS0C0zk1cJu3YMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/email-optin/index.vue")
  },
  {
    name: "account-email-optin___ro",
    path: "/ro/account/email-optin",
    meta: index_DXBtsq6QZ6pag4mXND2_wd1HXOakDbS0C0zk1cJu3YMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/email-optin/index.vue")
  },
  {
    name: "account-email-optin___ru",
    path: "/ru/account/email-optin",
    meta: index_DXBtsq6QZ6pag4mXND2_wd1HXOakDbS0C0zk1cJu3YMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/email-optin/index.vue")
  },
  {
    name: "account-email-optin___sk",
    path: "/sk/account/email-optin",
    meta: index_DXBtsq6QZ6pag4mXND2_wd1HXOakDbS0C0zk1cJu3YMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/email-optin/index.vue")
  },
  {
    name: "account-email-optin___sl",
    path: "/sl/account/email-optin",
    meta: index_DXBtsq6QZ6pag4mXND2_wd1HXOakDbS0C0zk1cJu3YMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/email-optin/index.vue")
  },
  {
    name: "account-email-optin___sr",
    path: "/sr/account/email-optin",
    meta: index_DXBtsq6QZ6pag4mXND2_wd1HXOakDbS0C0zk1cJu3YMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/email-optin/index.vue")
  },
  {
    name: "account-email-optin___sv",
    path: "/sv/account/email-optin",
    meta: index_DXBtsq6QZ6pag4mXND2_wd1HXOakDbS0C0zk1cJu3YMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/email-optin/index.vue")
  },
  {
    name: "account-email-optin___tr",
    path: "/tr/account/email-optin",
    meta: index_DXBtsq6QZ6pag4mXND2_wd1HXOakDbS0C0zk1cJu3YMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/email-optin/index.vue")
  },
  {
    name: "account-confirmEmail___de",
    path: "/de/account/email-bestaetigen",
    meta: indexhUWB5KuZCkhGUZbO0va5vw3R_idd74fOd0lOYuyEAjkMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirmEmail/index.vue")
  },
  {
    name: "account-confirmEmail___en",
    path: "/en/account/confirm-email",
    meta: indexhUWB5KuZCkhGUZbO0va5vw3R_idd74fOd0lOYuyEAjkMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirmEmail/index.vue")
  },
  {
    name: "account-confirmEmail___nl",
    path: "/nl/account/bevestiging-email",
    meta: indexhUWB5KuZCkhGUZbO0va5vw3R_idd74fOd0lOYuyEAjkMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirmEmail/index.vue")
  },
  {
    name: "account-confirmEmail___fr",
    path: "/fr/account/confirmer-e-mail",
    meta: indexhUWB5KuZCkhGUZbO0va5vw3R_idd74fOd0lOYuyEAjkMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirmEmail/index.vue")
  },
  {
    name: "account-confirmEmail___it",
    path: "/it/account/conferma-email",
    meta: indexhUWB5KuZCkhGUZbO0va5vw3R_idd74fOd0lOYuyEAjkMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirmEmail/index.vue")
  },
  {
    name: "account-confirmEmail___es",
    path: "/es/account/confirmar-email",
    meta: indexhUWB5KuZCkhGUZbO0va5vw3R_idd74fOd0lOYuyEAjkMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirmEmail/index.vue")
  },
  {
    name: "account-confirmEmail___bg",
    path: "/bg/account/%D0%BF%D0%BE%D1%82%D0%B2%D1%8A%D1%80%D0%B6%D0%B4%D0%B5%D0%BD%D0%B8%D0%B5-%D0%B8%D0%BC%D0%B5%D0%B9%D0%BB",
    meta: indexhUWB5KuZCkhGUZbO0va5vw3R_idd74fOd0lOYuyEAjkMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirmEmail/index.vue")
  },
  {
    name: "account-confirmEmail___bs",
    path: "/bs/account/potvrdite-email",
    meta: indexhUWB5KuZCkhGUZbO0va5vw3R_idd74fOd0lOYuyEAjkMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirmEmail/index.vue")
  },
  {
    name: "account-confirmEmail___cs",
    path: "/cs/account/potvrzeni-e-mailu",
    meta: indexhUWB5KuZCkhGUZbO0va5vw3R_idd74fOd0lOYuyEAjkMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirmEmail/index.vue")
  },
  {
    name: "account-confirmEmail___da",
    path: "/da/account/bekr%C3%A6ft-email",
    meta: indexhUWB5KuZCkhGUZbO0va5vw3R_idd74fOd0lOYuyEAjkMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirmEmail/index.vue")
  },
  {
    name: "account-confirmEmail___el",
    path: "/el/account/%CE%B5%CF%80%CE%B9%CE%B2%CE%B5%CE%B2%CE%B1%CE%B9%CF%89%CF%83%CE%B7-email",
    meta: indexhUWB5KuZCkhGUZbO0va5vw3R_idd74fOd0lOYuyEAjkMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirmEmail/index.vue")
  },
  {
    name: "account-confirmEmail___et",
    path: "/et/account/kinnita-email",
    meta: indexhUWB5KuZCkhGUZbO0va5vw3R_idd74fOd0lOYuyEAjkMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirmEmail/index.vue")
  },
  {
    name: "account-confirmEmail___fi",
    path: "/fi/account/vahvista-sahkoposti",
    meta: indexhUWB5KuZCkhGUZbO0va5vw3R_idd74fOd0lOYuyEAjkMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirmEmail/index.vue")
  },
  {
    name: "account-confirmEmail___hr",
    path: "/hr/account/potvrdi-e-adresu",
    meta: indexhUWB5KuZCkhGUZbO0va5vw3R_idd74fOd0lOYuyEAjkMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirmEmail/index.vue")
  },
  {
    name: "account-confirmEmail___hu",
    path: "/hu/account/email-megerosites",
    meta: indexhUWB5KuZCkhGUZbO0va5vw3R_idd74fOd0lOYuyEAjkMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirmEmail/index.vue")
  },
  {
    name: "account-confirmEmail___lt",
    path: "/lt/account/patvirtinti-el-pasto-adresa",
    meta: indexhUWB5KuZCkhGUZbO0va5vw3R_idd74fOd0lOYuyEAjkMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirmEmail/index.vue")
  },
  {
    name: "account-confirmEmail___lv",
    path: "/lv/account/apstiprini-e-pastu",
    meta: indexhUWB5KuZCkhGUZbO0va5vw3R_idd74fOd0lOYuyEAjkMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirmEmail/index.vue")
  },
  {
    name: "account-confirmEmail___no",
    path: "/no/account/bekreft-e-postadresse",
    meta: indexhUWB5KuZCkhGUZbO0va5vw3R_idd74fOd0lOYuyEAjkMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirmEmail/index.vue")
  },
  {
    name: "account-confirmEmail___pl",
    path: "/pl/account/potwierdz-email",
    meta: indexhUWB5KuZCkhGUZbO0va5vw3R_idd74fOd0lOYuyEAjkMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirmEmail/index.vue")
  },
  {
    name: "account-confirmEmail___pt",
    path: "/pt/account/confirmar-email",
    meta: indexhUWB5KuZCkhGUZbO0va5vw3R_idd74fOd0lOYuyEAjkMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirmEmail/index.vue")
  },
  {
    name: "account-confirmEmail___ro",
    path: "/ro/account/confirmare-e-mail",
    meta: indexhUWB5KuZCkhGUZbO0va5vw3R_idd74fOd0lOYuyEAjkMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirmEmail/index.vue")
  },
  {
    name: "account-confirmEmail___ru",
    path: "/ru/account/%D0%BF%D0%BE%D0%B4%D1%82%D0%B2%D0%B5%D1%80%D0%B4%D0%B8%D1%82%D0%B5-%D1%8D%D0%BB%D0%B5%D0%BA%D1%82%D1%80%D0%BE%D0%BD%D0%BD%D1%8B%D0%B8-%D0%B0%D0%B4%D1%80%D0%B5%D1%81",
    meta: indexhUWB5KuZCkhGUZbO0va5vw3R_idd74fOd0lOYuyEAjkMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirmEmail/index.vue")
  },
  {
    name: "account-confirmEmail___sk",
    path: "/sk/account/potvrdit-e-mail%20",
    meta: indexhUWB5KuZCkhGUZbO0va5vw3R_idd74fOd0lOYuyEAjkMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirmEmail/index.vue")
  },
  {
    name: "account-confirmEmail___sl",
    path: "/sl/account/potrdite-email",
    meta: indexhUWB5KuZCkhGUZbO0va5vw3R_idd74fOd0lOYuyEAjkMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirmEmail/index.vue")
  },
  {
    name: "account-confirmEmail___sr",
    path: "/sr/account/imejl-potvrda",
    meta: indexhUWB5KuZCkhGUZbO0va5vw3R_idd74fOd0lOYuyEAjkMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirmEmail/index.vue")
  },
  {
    name: "account-confirmEmail___sv",
    path: "/sv/account/bakrafta-e-postadressen",
    meta: indexhUWB5KuZCkhGUZbO0va5vw3R_idd74fOd0lOYuyEAjkMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirmEmail/index.vue")
  },
  {
    name: "account-confirmEmail___tr",
    path: "/tr/account/e-postayi-onayla",
    meta: indexhUWB5KuZCkhGUZbO0va5vw3R_idd74fOd0lOYuyEAjkMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirmEmail/index.vue")
  },
  {
    name: "campsite-identifier___de",
    path: "/de/campingplatz/:identifier()",
    meta: { ...(indext7_QRrt7bfo4yMCAbfPnP_udVYU6f3GxEmDIJHh816YMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/index.vue")
  },
  {
    name: "campsite-identifier___en",
    path: "/en/campsite/:identifier()",
    meta: { ...(indext7_QRrt7bfo4yMCAbfPnP_udVYU6f3GxEmDIJHh816YMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/index.vue")
  },
  {
    name: "campsite-identifier___nl",
    path: "/nl/kampeerplek/:identifier()",
    meta: { ...(indext7_QRrt7bfo4yMCAbfPnP_udVYU6f3GxEmDIJHh816YMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/index.vue")
  },
  {
    name: "campsite-identifier___fr",
    path: "/fr/emplacement-de-camping/:identifier()",
    meta: { ...(indext7_QRrt7bfo4yMCAbfPnP_udVYU6f3GxEmDIJHh816YMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/index.vue")
  },
  {
    name: "campsite-identifier___it",
    path: "/it/campeggio/:identifier()",
    meta: { ...(indext7_QRrt7bfo4yMCAbfPnP_udVYU6f3GxEmDIJHh816YMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/index.vue")
  },
  {
    name: "campsite-identifier___es",
    path: "/es/camping/:identifier()",
    meta: { ...(indext7_QRrt7bfo4yMCAbfPnP_udVYU6f3GxEmDIJHh816YMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/index.vue")
  },
  {
    name: "campsite-identifier___bg",
    path: "/bg/%D0%BB%D0%B0%D0%B3%D0%B5%D1%80/:identifier()",
    meta: { ...(indext7_QRrt7bfo4yMCAbfPnP_udVYU6f3GxEmDIJHh816YMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/index.vue")
  },
  {
    name: "campsite-identifier___bs",
    path: "/bs/kamp-mjesto/:identifier()",
    meta: { ...(indext7_QRrt7bfo4yMCAbfPnP_udVYU6f3GxEmDIJHh816YMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/index.vue")
  },
  {
    name: "campsite-identifier___cs",
    path: "/cs/kemp/:identifier()",
    meta: { ...(indext7_QRrt7bfo4yMCAbfPnP_udVYU6f3GxEmDIJHh816YMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/index.vue")
  },
  {
    name: "campsite-identifier___da",
    path: "/da/campinggrund/:identifier()",
    meta: { ...(indext7_QRrt7bfo4yMCAbfPnP_udVYU6f3GxEmDIJHh816YMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/index.vue")
  },
  {
    name: "campsite-identifier___el",
    path: "/el/%CE%B8%CE%B5%CF%83%CE%B7-%CE%BA%CE%B1%CE%BC%CF%80%CE%B9%CE%BD%CE%B3%CE%BA/:identifier()",
    meta: { ...(indext7_QRrt7bfo4yMCAbfPnP_udVYU6f3GxEmDIJHh816YMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/index.vue")
  },
  {
    name: "campsite-identifier___et",
    path: "/et/kamping/:identifier()",
    meta: { ...(indext7_QRrt7bfo4yMCAbfPnP_udVYU6f3GxEmDIJHh816YMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/index.vue")
  },
  {
    name: "campsite-identifier___fi",
    path: "/fi/leirintaalue/:identifier()",
    meta: { ...(indext7_QRrt7bfo4yMCAbfPnP_udVYU6f3GxEmDIJHh816YMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/index.vue")
  },
  {
    name: "campsite-identifier___hr",
    path: "/hr/mjesto-za-kampiranje/:identifier()",
    meta: { ...(indext7_QRrt7bfo4yMCAbfPnP_udVYU6f3GxEmDIJHh816YMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/index.vue")
  },
  {
    name: "campsite-identifier___hu",
    path: "/hu/taborhely/:identifier()",
    meta: { ...(indext7_QRrt7bfo4yMCAbfPnP_udVYU6f3GxEmDIJHh816YMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/index.vue")
  },
  {
    name: "campsite-identifier___lt",
    path: "/lt/stovyklaviete/:identifier()",
    meta: { ...(indext7_QRrt7bfo4yMCAbfPnP_udVYU6f3GxEmDIJHh816YMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/index.vue")
  },
  {
    name: "campsite-identifier___lv",
    path: "/lv/karavanu-vieta/:identifier()",
    meta: { ...(indext7_QRrt7bfo4yMCAbfPnP_udVYU6f3GxEmDIJHh816YMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/index.vue")
  },
  {
    name: "campsite-identifier___no",
    path: "/no/campingplass/:identifier()",
    meta: { ...(indext7_QRrt7bfo4yMCAbfPnP_udVYU6f3GxEmDIJHh816YMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/index.vue")
  },
  {
    name: "campsite-identifier___pl",
    path: "/pl/miejsce-kempingowe/:identifier()",
    meta: { ...(indext7_QRrt7bfo4yMCAbfPnP_udVYU6f3GxEmDIJHh816YMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/index.vue")
  },
  {
    name: "campsite-identifier___pt",
    path: "/pt/acampamento/:identifier()",
    meta: { ...(indext7_QRrt7bfo4yMCAbfPnP_udVYU6f3GxEmDIJHh816YMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/index.vue")
  },
  {
    name: "campsite-identifier___ro",
    path: "/ro/loc-de-campare/:identifier()",
    meta: { ...(indext7_QRrt7bfo4yMCAbfPnP_udVYU6f3GxEmDIJHh816YMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/index.vue")
  },
  {
    name: "campsite-identifier___ru",
    path: "/ru/%D0%BA%D0%B5%D0%BC%D0%BF%D0%B8%D0%BD%D0%B3-%D0%BB%D0%B0%D0%B3%D0%B5%D1%80%D1%8C/:identifier()",
    meta: { ...(indext7_QRrt7bfo4yMCAbfPnP_udVYU6f3GxEmDIJHh816YMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/index.vue")
  },
  {
    name: "campsite-identifier___sk",
    path: "/sk/miesto-na-kempovanie/:identifier()",
    meta: { ...(indext7_QRrt7bfo4yMCAbfPnP_udVYU6f3GxEmDIJHh816YMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/index.vue")
  },
  {
    name: "campsite-identifier___sl",
    path: "/sl/kamp/:identifier()",
    meta: { ...(indext7_QRrt7bfo4yMCAbfPnP_udVYU6f3GxEmDIJHh816YMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/index.vue")
  },
  {
    name: "campsite-identifier___sr",
    path: "/sr/kamp-lokacija/:identifier()",
    meta: { ...(indext7_QRrt7bfo4yMCAbfPnP_udVYU6f3GxEmDIJHh816YMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/index.vue")
  },
  {
    name: "campsite-identifier___sv",
    path: "/sv/taltplats/:identifier()",
    meta: { ...(indext7_QRrt7bfo4yMCAbfPnP_udVYU6f3GxEmDIJHh816YMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/index.vue")
  },
  {
    name: "campsite-identifier___tr",
    path: "/tr/kamp-alani/:identifier()",
    meta: { ...(indext7_QRrt7bfo4yMCAbfPnP_udVYU6f3GxEmDIJHh816YMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/index.vue")
  },
  {
    name: "country-countrySlug___de",
    path: "/de/land/:countrySlug()",
    meta: { ...(indexvt7EsgevNKYq7CLwuMN5WQxQ6wOB9yAQ9gbotVjwPMwMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/[countrySlug]/index.vue")
  },
  {
    name: "country-countrySlug___en",
    path: "/en/country/:countrySlug()",
    meta: { ...(indexvt7EsgevNKYq7CLwuMN5WQxQ6wOB9yAQ9gbotVjwPMwMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/[countrySlug]/index.vue")
  },
  {
    name: "country-countrySlug___nl",
    path: "/nl/land/:countrySlug()",
    meta: { ...(indexvt7EsgevNKYq7CLwuMN5WQxQ6wOB9yAQ9gbotVjwPMwMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/[countrySlug]/index.vue")
  },
  {
    name: "country-countrySlug___fr",
    path: "/fr/pays/:countrySlug()",
    meta: { ...(indexvt7EsgevNKYq7CLwuMN5WQxQ6wOB9yAQ9gbotVjwPMwMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/[countrySlug]/index.vue")
  },
  {
    name: "country-countrySlug___it",
    path: "/it/paese/:countrySlug()",
    meta: { ...(indexvt7EsgevNKYq7CLwuMN5WQxQ6wOB9yAQ9gbotVjwPMwMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/[countrySlug]/index.vue")
  },
  {
    name: "country-countrySlug___es",
    path: "/es/pa%C3%ADs/:countrySlug()",
    meta: { ...(indexvt7EsgevNKYq7CLwuMN5WQxQ6wOB9yAQ9gbotVjwPMwMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/[countrySlug]/index.vue")
  },
  {
    name: "country-countrySlug___bg",
    path: "/bg/%D0%B4%D1%8A%D1%80%D0%B6%D0%B0%D0%B2%D0%B0/:countrySlug()",
    meta: { ...(indexvt7EsgevNKYq7CLwuMN5WQxQ6wOB9yAQ9gbotVjwPMwMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/[countrySlug]/index.vue")
  },
  {
    name: "country-countrySlug___bs",
    path: "/bs/drzava/:countrySlug()",
    meta: { ...(indexvt7EsgevNKYq7CLwuMN5WQxQ6wOB9yAQ9gbotVjwPMwMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/[countrySlug]/index.vue")
  },
  {
    name: "country-countrySlug___cs",
    path: "/cs/zeme/:countrySlug()",
    meta: { ...(indexvt7EsgevNKYq7CLwuMN5WQxQ6wOB9yAQ9gbotVjwPMwMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/[countrySlug]/index.vue")
  },
  {
    name: "country-countrySlug___da",
    path: "/da/land/:countrySlug()",
    meta: { ...(indexvt7EsgevNKYq7CLwuMN5WQxQ6wOB9yAQ9gbotVjwPMwMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/[countrySlug]/index.vue")
  },
  {
    name: "country-countrySlug___el",
    path: "/el/%CF%87%CF%89%CF%81%CE%B1/:countrySlug()",
    meta: { ...(indexvt7EsgevNKYq7CLwuMN5WQxQ6wOB9yAQ9gbotVjwPMwMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/[countrySlug]/index.vue")
  },
  {
    name: "country-countrySlug___et",
    path: "/et/riik/:countrySlug()",
    meta: { ...(indexvt7EsgevNKYq7CLwuMN5WQxQ6wOB9yAQ9gbotVjwPMwMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/[countrySlug]/index.vue")
  },
  {
    name: "country-countrySlug___fi",
    path: "/fi/maa/:countrySlug()",
    meta: { ...(indexvt7EsgevNKYq7CLwuMN5WQxQ6wOB9yAQ9gbotVjwPMwMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/[countrySlug]/index.vue")
  },
  {
    name: "country-countrySlug___hr",
    path: "/hr/zemlja/:countrySlug()",
    meta: { ...(indexvt7EsgevNKYq7CLwuMN5WQxQ6wOB9yAQ9gbotVjwPMwMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/[countrySlug]/index.vue")
  },
  {
    name: "country-countrySlug___hu",
    path: "/hu/orszag/:countrySlug()",
    meta: { ...(indexvt7EsgevNKYq7CLwuMN5WQxQ6wOB9yAQ9gbotVjwPMwMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/[countrySlug]/index.vue")
  },
  {
    name: "country-countrySlug___lt",
    path: "/lt/salis/:countrySlug()",
    meta: { ...(indexvt7EsgevNKYq7CLwuMN5WQxQ6wOB9yAQ9gbotVjwPMwMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/[countrySlug]/index.vue")
  },
  {
    name: "country-countrySlug___lv",
    path: "/lv/valsts/:countrySlug()",
    meta: { ...(indexvt7EsgevNKYq7CLwuMN5WQxQ6wOB9yAQ9gbotVjwPMwMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/[countrySlug]/index.vue")
  },
  {
    name: "country-countrySlug___no",
    path: "/no/land/:countrySlug()",
    meta: { ...(indexvt7EsgevNKYq7CLwuMN5WQxQ6wOB9yAQ9gbotVjwPMwMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/[countrySlug]/index.vue")
  },
  {
    name: "country-countrySlug___pl",
    path: "/pl/kraj/:countrySlug()",
    meta: { ...(indexvt7EsgevNKYq7CLwuMN5WQxQ6wOB9yAQ9gbotVjwPMwMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/[countrySlug]/index.vue")
  },
  {
    name: "country-countrySlug___pt",
    path: "/pt/pais/:countrySlug()",
    meta: { ...(indexvt7EsgevNKYq7CLwuMN5WQxQ6wOB9yAQ9gbotVjwPMwMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/[countrySlug]/index.vue")
  },
  {
    name: "country-countrySlug___ro",
    path: "/ro/tara/:countrySlug()",
    meta: { ...(indexvt7EsgevNKYq7CLwuMN5WQxQ6wOB9yAQ9gbotVjwPMwMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/[countrySlug]/index.vue")
  },
  {
    name: "country-countrySlug___ru",
    path: "/ru/%D1%81%D1%82%D1%80%D0%B0%D0%BD%D0%B0/:countrySlug()",
    meta: { ...(indexvt7EsgevNKYq7CLwuMN5WQxQ6wOB9yAQ9gbotVjwPMwMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/[countrySlug]/index.vue")
  },
  {
    name: "country-countrySlug___sk",
    path: "/sk/krajina/:countrySlug()",
    meta: { ...(indexvt7EsgevNKYq7CLwuMN5WQxQ6wOB9yAQ9gbotVjwPMwMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/[countrySlug]/index.vue")
  },
  {
    name: "country-countrySlug___sl",
    path: "/sl/drzava/:countrySlug()",
    meta: { ...(indexvt7EsgevNKYq7CLwuMN5WQxQ6wOB9yAQ9gbotVjwPMwMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/[countrySlug]/index.vue")
  },
  {
    name: "country-countrySlug___sr",
    path: "/sr/zemlja/:countrySlug()",
    meta: { ...(indexvt7EsgevNKYq7CLwuMN5WQxQ6wOB9yAQ9gbotVjwPMwMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/[countrySlug]/index.vue")
  },
  {
    name: "country-countrySlug___sv",
    path: "/sv/land/:countrySlug()",
    meta: { ...(indexvt7EsgevNKYq7CLwuMN5WQxQ6wOB9yAQ9gbotVjwPMwMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/[countrySlug]/index.vue")
  },
  {
    name: "country-countrySlug___tr",
    path: "/tr/ulke/:countrySlug()",
    meta: { ...(indexvt7EsgevNKYq7CLwuMN5WQxQ6wOB9yAQ9gbotVjwPMwMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/[countrySlug]/index.vue")
  },
  {
    name: "account-reset-password___de",
    path: "/de/account/passwort-zuruecksetzen",
    meta: indexGmSdnK0m42VE940yNoOfYHxfQmlWQVf2xnziqt3zYvwMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/reset-password/index.vue")
  },
  {
    name: "account-reset-password___en",
    path: "/en/account/reset-password",
    meta: indexGmSdnK0m42VE940yNoOfYHxfQmlWQVf2xnziqt3zYvwMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/reset-password/index.vue")
  },
  {
    name: "account-reset-password___nl",
    path: "/nl/account/wachtwoord-herstellen",
    meta: indexGmSdnK0m42VE940yNoOfYHxfQmlWQVf2xnziqt3zYvwMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/reset-password/index.vue")
  },
  {
    name: "account-reset-password___fr",
    path: "/fr/account/reinitialiser-mot-de-passe",
    meta: indexGmSdnK0m42VE940yNoOfYHxfQmlWQVf2xnziqt3zYvwMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/reset-password/index.vue")
  },
  {
    name: "account-reset-password___it",
    path: "/it/account/reimposta-password",
    meta: indexGmSdnK0m42VE940yNoOfYHxfQmlWQVf2xnziqt3zYvwMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/reset-password/index.vue")
  },
  {
    name: "account-reset-password___es",
    path: "/es/account/restablecer-contrase%C3%B1a",
    meta: indexGmSdnK0m42VE940yNoOfYHxfQmlWQVf2xnziqt3zYvwMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/reset-password/index.vue")
  },
  {
    name: "account-reset-password___bg",
    path: "/bg/account/%D0%BD%D1%83%D0%BB%D0%B8%D1%80%D0%B0%D0%BD%D0%B5-%D0%BF%D0%B0%D1%80%D0%BE%D0%BB%D0%B0",
    meta: indexGmSdnK0m42VE940yNoOfYHxfQmlWQVf2xnziqt3zYvwMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/reset-password/index.vue")
  },
  {
    name: "account-reset-password___bs",
    path: "/bs/account/resetuj-lozinku",
    meta: indexGmSdnK0m42VE940yNoOfYHxfQmlWQVf2xnziqt3zYvwMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/reset-password/index.vue")
  },
  {
    name: "account-reset-password___cs",
    path: "/cs/account/obnova-hesla",
    meta: indexGmSdnK0m42VE940yNoOfYHxfQmlWQVf2xnziqt3zYvwMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/reset-password/index.vue")
  },
  {
    name: "account-reset-password___da",
    path: "/da/account/nulstil-adgangskode",
    meta: indexGmSdnK0m42VE940yNoOfYHxfQmlWQVf2xnziqt3zYvwMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/reset-password/index.vue")
  },
  {
    name: "account-reset-password___el",
    path: "/el/account/%CE%B5%CF%80%CE%B1%CE%BD%CE%B1%CF%86%CE%BF%CF%81%CE%B1-%CE%BA%CF%89%CE%B4%CE%B9%CE%BA%CE%BF%CF%85-%CF%80%CF%81%CE%BF%CF%83%CE%B2%CE%B1%CF%83%CE%B7%CF%82",
    meta: indexGmSdnK0m42VE940yNoOfYHxfQmlWQVf2xnziqt3zYvwMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/reset-password/index.vue")
  },
  {
    name: "account-reset-password___et",
    path: "/et/account/lahtesta-salasona",
    meta: indexGmSdnK0m42VE940yNoOfYHxfQmlWQVf2xnziqt3zYvwMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/reset-password/index.vue")
  },
  {
    name: "account-reset-password___fi",
    path: "/fi/account/nollaa-salasana",
    meta: indexGmSdnK0m42VE940yNoOfYHxfQmlWQVf2xnziqt3zYvwMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/reset-password/index.vue")
  },
  {
    name: "account-reset-password___hr",
    path: "/hr/account/ponovno-postavi-lozinku",
    meta: indexGmSdnK0m42VE940yNoOfYHxfQmlWQVf2xnziqt3zYvwMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/reset-password/index.vue")
  },
  {
    name: "account-reset-password___hu",
    path: "/hu/account/uj-jelszo-beallitasa",
    meta: indexGmSdnK0m42VE940yNoOfYHxfQmlWQVf2xnziqt3zYvwMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/reset-password/index.vue")
  },
  {
    name: "account-reset-password___lt",
    path: "/lt/account/nustatyti-slaptazodi-is-naujo",
    meta: indexGmSdnK0m42VE940yNoOfYHxfQmlWQVf2xnziqt3zYvwMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/reset-password/index.vue")
  },
  {
    name: "account-reset-password___lv",
    path: "/lv/account/atjaunot-paroli",
    meta: indexGmSdnK0m42VE940yNoOfYHxfQmlWQVf2xnziqt3zYvwMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/reset-password/index.vue")
  },
  {
    name: "account-reset-password___no",
    path: "/no/account/tilbakestille-passord",
    meta: indexGmSdnK0m42VE940yNoOfYHxfQmlWQVf2xnziqt3zYvwMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/reset-password/index.vue")
  },
  {
    name: "account-reset-password___pl",
    path: "/pl/account/zresetuj-has%C5%82o",
    meta: indexGmSdnK0m42VE940yNoOfYHxfQmlWQVf2xnziqt3zYvwMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/reset-password/index.vue")
  },
  {
    name: "account-reset-password___pt",
    path: "/pt/account/redefinir-senha",
    meta: indexGmSdnK0m42VE940yNoOfYHxfQmlWQVf2xnziqt3zYvwMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/reset-password/index.vue")
  },
  {
    name: "account-reset-password___ro",
    path: "/ro/account/resetare-parola",
    meta: indexGmSdnK0m42VE940yNoOfYHxfQmlWQVf2xnziqt3zYvwMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/reset-password/index.vue")
  },
  {
    name: "account-reset-password___ru",
    path: "/ru/account/%D1%81%D0%B1%D1%80%D0%BE%D1%81-%D0%BF%D0%B0%D1%80%D0%BE%D0%BB%D1%8F",
    meta: indexGmSdnK0m42VE940yNoOfYHxfQmlWQVf2xnziqt3zYvwMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/reset-password/index.vue")
  },
  {
    name: "account-reset-password___sk",
    path: "/sk/account/obnovit-heslo",
    meta: indexGmSdnK0m42VE940yNoOfYHxfQmlWQVf2xnziqt3zYvwMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/reset-password/index.vue")
  },
  {
    name: "account-reset-password___sl",
    path: "/sl/account/ponastavitev-geslo",
    meta: indexGmSdnK0m42VE940yNoOfYHxfQmlWQVf2xnziqt3zYvwMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/reset-password/index.vue")
  },
  {
    name: "account-reset-password___sr",
    path: "/sr/account/resetovanje-lozinke",
    meta: indexGmSdnK0m42VE940yNoOfYHxfQmlWQVf2xnziqt3zYvwMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/reset-password/index.vue")
  },
  {
    name: "account-reset-password___sv",
    path: "/sv/account/aterstall-losenord",
    meta: indexGmSdnK0m42VE940yNoOfYHxfQmlWQVf2xnziqt3zYvwMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/reset-password/index.vue")
  },
  {
    name: "account-reset-password___tr",
    path: "/tr/account/parolayi-sifirla",
    meta: indexGmSdnK0m42VE940yNoOfYHxfQmlWQVf2xnziqt3zYvwMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/reset-password/index.vue")
  },
  {
    name: "account-change-password___de",
    path: "/de/account/change-password",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/change-password/index.vue")
  },
  {
    name: "account-change-password___en",
    path: "/en/account/change-password",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/change-password/index.vue")
  },
  {
    name: "account-change-password___nl",
    path: "/nl/account/change-password",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/change-password/index.vue")
  },
  {
    name: "account-change-password___fr",
    path: "/fr/account/change-password",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/change-password/index.vue")
  },
  {
    name: "account-change-password___it",
    path: "/it/account/change-password",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/change-password/index.vue")
  },
  {
    name: "account-change-password___es",
    path: "/es/account/change-password",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/change-password/index.vue")
  },
  {
    name: "account-change-password___bg",
    path: "/bg/account/change-password",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/change-password/index.vue")
  },
  {
    name: "account-change-password___bs",
    path: "/bs/account/change-password",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/change-password/index.vue")
  },
  {
    name: "account-change-password___cs",
    path: "/cs/account/change-password",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/change-password/index.vue")
  },
  {
    name: "account-change-password___da",
    path: "/da/account/change-password",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/change-password/index.vue")
  },
  {
    name: "account-change-password___el",
    path: "/el/account/change-password",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/change-password/index.vue")
  },
  {
    name: "account-change-password___et",
    path: "/et/account/change-password",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/change-password/index.vue")
  },
  {
    name: "account-change-password___fi",
    path: "/fi/account/change-password",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/change-password/index.vue")
  },
  {
    name: "account-change-password___hr",
    path: "/hr/account/change-password",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/change-password/index.vue")
  },
  {
    name: "account-change-password___hu",
    path: "/hu/account/change-password",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/change-password/index.vue")
  },
  {
    name: "account-change-password___lt",
    path: "/lt/account/change-password",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/change-password/index.vue")
  },
  {
    name: "account-change-password___lv",
    path: "/lv/account/change-password",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/change-password/index.vue")
  },
  {
    name: "account-change-password___no",
    path: "/no/account/change-password",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/change-password/index.vue")
  },
  {
    name: "account-change-password___pl",
    path: "/pl/account/change-password",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/change-password/index.vue")
  },
  {
    name: "account-change-password___pt",
    path: "/pt/account/change-password",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/change-password/index.vue")
  },
  {
    name: "account-change-password___ro",
    path: "/ro/account/change-password",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/change-password/index.vue")
  },
  {
    name: "account-change-password___ru",
    path: "/ru/account/change-password",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/change-password/index.vue")
  },
  {
    name: "account-change-password___sk",
    path: "/sk/account/change-password",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/change-password/index.vue")
  },
  {
    name: "account-change-password___sl",
    path: "/sl/account/change-password",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/change-password/index.vue")
  },
  {
    name: "account-change-password___sr",
    path: "/sr/account/change-password",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/change-password/index.vue")
  },
  {
    name: "account-change-password___sv",
    path: "/sv/account/change-password",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/change-password/index.vue")
  },
  {
    name: "account-change-password___tr",
    path: "/tr/account/change-password",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/change-password/index.vue")
  },
  {
    name: "account-confirm-password___de",
    path: "/de/account/neues-passwort",
    meta: indextB1WLRBm7XYsIucRV_s_Ka8Ip23oXZhCN4iQSujmsosMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirm-password/index.vue")
  },
  {
    name: "account-confirm-password___en",
    path: "/en/account/new-password",
    meta: indextB1WLRBm7XYsIucRV_s_Ka8Ip23oXZhCN4iQSujmsosMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirm-password/index.vue")
  },
  {
    name: "account-confirm-password___nl",
    path: "/nl/account/bevestiging-wachtwoord",
    meta: indextB1WLRBm7XYsIucRV_s_Ka8Ip23oXZhCN4iQSujmsosMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirm-password/index.vue")
  },
  {
    name: "account-confirm-password___fr",
    path: "/fr/account/confirmer-mot-de-passe",
    meta: indextB1WLRBm7XYsIucRV_s_Ka8Ip23oXZhCN4iQSujmsosMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirm-password/index.vue")
  },
  {
    name: "account-confirm-password___it",
    path: "/it/account/conferma-password",
    meta: indextB1WLRBm7XYsIucRV_s_Ka8Ip23oXZhCN4iQSujmsosMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirm-password/index.vue")
  },
  {
    name: "account-confirm-password___es",
    path: "/es/account/nueva-contrase%C3%B1a",
    meta: indextB1WLRBm7XYsIucRV_s_Ka8Ip23oXZhCN4iQSujmsosMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirm-password/index.vue")
  },
  {
    name: "account-confirm-password___bg",
    path: "/bg/account/%D0%BF%D0%BE%D1%82%D0%B2%D1%8A%D1%80%D0%B6%D0%B4%D0%B5%D0%BD%D0%B8%D0%B5-%D0%BF%D0%B0%D1%80%D0%BE%D0%BB%D0%B0",
    meta: indextB1WLRBm7XYsIucRV_s_Ka8Ip23oXZhCN4iQSujmsosMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirm-password/index.vue")
  },
  {
    name: "account-confirm-password___bs",
    path: "/bs/account/potvrdite-lozinku",
    meta: indextB1WLRBm7XYsIucRV_s_Ka8Ip23oXZhCN4iQSujmsosMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirm-password/index.vue")
  },
  {
    name: "account-confirm-password___cs",
    path: "/cs/account/potvrzeni-hesla",
    meta: indextB1WLRBm7XYsIucRV_s_Ka8Ip23oXZhCN4iQSujmsosMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirm-password/index.vue")
  },
  {
    name: "account-confirm-password___da",
    path: "/da/account/bekr%C3%A6ft-adgangskode",
    meta: indextB1WLRBm7XYsIucRV_s_Ka8Ip23oXZhCN4iQSujmsosMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirm-password/index.vue")
  },
  {
    name: "account-confirm-password___el",
    path: "/el/account/%CE%B5%CF%80%CE%B9%CE%B2%CE%B5%CE%B2%CE%B1%CE%B9%CF%89%CF%83%CE%B7-%CE%BA%CF%89%CE%B4%CE%B9%CE%BA%CE%BF%CF%85-%CF%80%CF%81%CE%BF%CF%83%CE%B2%CE%B1%CF%83%CE%B7%CF%82",
    meta: indextB1WLRBm7XYsIucRV_s_Ka8Ip23oXZhCN4iQSujmsosMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirm-password/index.vue")
  },
  {
    name: "account-confirm-password___et",
    path: "/et/account/kinnita-salasona",
    meta: indextB1WLRBm7XYsIucRV_s_Ka8Ip23oXZhCN4iQSujmsosMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirm-password/index.vue")
  },
  {
    name: "account-confirm-password___fi",
    path: "/fi/account/vahvista-salasana",
    meta: indextB1WLRBm7XYsIucRV_s_Ka8Ip23oXZhCN4iQSujmsosMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirm-password/index.vue")
  },
  {
    name: "account-confirm-password___hr",
    path: "/hr/account/potvrdi-lozinku",
    meta: indextB1WLRBm7XYsIucRV_s_Ka8Ip23oXZhCN4iQSujmsosMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirm-password/index.vue")
  },
  {
    name: "account-confirm-password___hu",
    path: "/hu/account/jelszo-megerosites",
    meta: indextB1WLRBm7XYsIucRV_s_Ka8Ip23oXZhCN4iQSujmsosMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirm-password/index.vue")
  },
  {
    name: "account-confirm-password___lt",
    path: "/lt/account/patvirtinti-slaptazodi",
    meta: indextB1WLRBm7XYsIucRV_s_Ka8Ip23oXZhCN4iQSujmsosMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirm-password/index.vue")
  },
  {
    name: "account-confirm-password___lv",
    path: "/lv/account/apstiprini-paroli",
    meta: indextB1WLRBm7XYsIucRV_s_Ka8Ip23oXZhCN4iQSujmsosMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirm-password/index.vue")
  },
  {
    name: "account-confirm-password___no",
    path: "/no/account/bekreft-passord",
    meta: indextB1WLRBm7XYsIucRV_s_Ka8Ip23oXZhCN4iQSujmsosMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirm-password/index.vue")
  },
  {
    name: "account-confirm-password___pl",
    path: "/pl/account/potwierdz-haslo",
    meta: indextB1WLRBm7XYsIucRV_s_Ka8Ip23oXZhCN4iQSujmsosMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirm-password/index.vue")
  },
  {
    name: "account-confirm-password___pt",
    path: "/pt/account/confirme-a-senha",
    meta: indextB1WLRBm7XYsIucRV_s_Ka8Ip23oXZhCN4iQSujmsosMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirm-password/index.vue")
  },
  {
    name: "account-confirm-password___ro",
    path: "/ro/account/confirmare-parola",
    meta: indextB1WLRBm7XYsIucRV_s_Ka8Ip23oXZhCN4iQSujmsosMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirm-password/index.vue")
  },
  {
    name: "account-confirm-password___ru",
    path: "/ru/account/%D0%BF%D0%BE%D0%B4%D1%82%D0%B2%D0%B5%D1%80%D0%B4%D0%B8%D1%82%D0%B5-%D0%BF%D0%B0%D1%80%D0%BE%D0%BB%D1%8C",
    meta: indextB1WLRBm7XYsIucRV_s_Ka8Ip23oXZhCN4iQSujmsosMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirm-password/index.vue")
  },
  {
    name: "account-confirm-password___sk",
    path: "/sk/account/potvrdit-heslo",
    meta: indextB1WLRBm7XYsIucRV_s_Ka8Ip23oXZhCN4iQSujmsosMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirm-password/index.vue")
  },
  {
    name: "account-confirm-password___sl",
    path: "/sl/account/potrdite-geslo",
    meta: indextB1WLRBm7XYsIucRV_s_Ka8Ip23oXZhCN4iQSujmsosMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirm-password/index.vue")
  },
  {
    name: "account-confirm-password___sr",
    path: "/sr/account/potvrda-lozinke",
    meta: indextB1WLRBm7XYsIucRV_s_Ka8Ip23oXZhCN4iQSujmsosMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirm-password/index.vue")
  },
  {
    name: "account-confirm-password___sv",
    path: "/sv/account/bekrafta-losenord",
    meta: indextB1WLRBm7XYsIucRV_s_Ka8Ip23oXZhCN4iQSujmsosMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirm-password/index.vue")
  },
  {
    name: "account-confirm-password___tr",
    path: "/tr/account/sifreyi-onayla",
    meta: indextB1WLRBm7XYsIucRV_s_Ka8Ip23oXZhCN4iQSujmsosMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirm-password/index.vue")
  },
  {
    name: "account-media-identifier___de",
    path: "/de/account/media/:identifier()",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/media/[identifier]/index.vue")
  },
  {
    name: "account-media-identifier___en",
    path: "/en/account/media/:identifier()",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/media/[identifier]/index.vue")
  },
  {
    name: "account-media-identifier___nl",
    path: "/nl/account/media/:identifier()",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/media/[identifier]/index.vue")
  },
  {
    name: "account-media-identifier___fr",
    path: "/fr/account/media/:identifier()",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/media/[identifier]/index.vue")
  },
  {
    name: "account-media-identifier___it",
    path: "/it/account/media/:identifier()",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/media/[identifier]/index.vue")
  },
  {
    name: "account-media-identifier___es",
    path: "/es/account/media/:identifier()",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/media/[identifier]/index.vue")
  },
  {
    name: "account-media-identifier___bg",
    path: "/bg/account/media/:identifier()",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/media/[identifier]/index.vue")
  },
  {
    name: "account-media-identifier___bs",
    path: "/bs/account/media/:identifier()",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/media/[identifier]/index.vue")
  },
  {
    name: "account-media-identifier___cs",
    path: "/cs/account/media/:identifier()",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/media/[identifier]/index.vue")
  },
  {
    name: "account-media-identifier___da",
    path: "/da/account/media/:identifier()",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/media/[identifier]/index.vue")
  },
  {
    name: "account-media-identifier___el",
    path: "/el/account/media/:identifier()",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/media/[identifier]/index.vue")
  },
  {
    name: "account-media-identifier___et",
    path: "/et/account/media/:identifier()",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/media/[identifier]/index.vue")
  },
  {
    name: "account-media-identifier___fi",
    path: "/fi/account/media/:identifier()",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/media/[identifier]/index.vue")
  },
  {
    name: "account-media-identifier___hr",
    path: "/hr/account/media/:identifier()",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/media/[identifier]/index.vue")
  },
  {
    name: "account-media-identifier___hu",
    path: "/hu/account/media/:identifier()",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/media/[identifier]/index.vue")
  },
  {
    name: "account-media-identifier___lt",
    path: "/lt/account/media/:identifier()",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/media/[identifier]/index.vue")
  },
  {
    name: "account-media-identifier___lv",
    path: "/lv/account/media/:identifier()",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/media/[identifier]/index.vue")
  },
  {
    name: "account-media-identifier___no",
    path: "/no/account/media/:identifier()",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/media/[identifier]/index.vue")
  },
  {
    name: "account-media-identifier___pl",
    path: "/pl/account/media/:identifier()",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/media/[identifier]/index.vue")
  },
  {
    name: "account-media-identifier___pt",
    path: "/pt/account/media/:identifier()",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/media/[identifier]/index.vue")
  },
  {
    name: "account-media-identifier___ro",
    path: "/ro/account/media/:identifier()",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/media/[identifier]/index.vue")
  },
  {
    name: "account-media-identifier___ru",
    path: "/ru/account/media/:identifier()",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/media/[identifier]/index.vue")
  },
  {
    name: "account-media-identifier___sk",
    path: "/sk/account/media/:identifier()",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/media/[identifier]/index.vue")
  },
  {
    name: "account-media-identifier___sl",
    path: "/sl/account/media/:identifier()",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/media/[identifier]/index.vue")
  },
  {
    name: "account-media-identifier___sr",
    path: "/sr/account/media/:identifier()",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/media/[identifier]/index.vue")
  },
  {
    name: "account-media-identifier___sv",
    path: "/sv/account/media/:identifier()",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/media/[identifier]/index.vue")
  },
  {
    name: "account-media-identifier___tr",
    path: "/tr/account/media/:identifier()",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/media/[identifier]/index.vue")
  },
  {
    name: "campsite-identifier-rate___de",
    path: "/de/campingplatz/:identifier()/bewerten",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/index.vue")
  },
  {
    name: "campsite-identifier-rate___en",
    path: "/en/campsite/:identifier()/rate",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/index.vue")
  },
  {
    name: "campsite-identifier-rate___nl",
    path: "/nl/kampeerplek/:identifier()/schatten",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/index.vue")
  },
  {
    name: "campsite-identifier-rate___fr",
    path: "/fr/emplacement-de-camping/:identifier()/%C3%A9valuer",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/index.vue")
  },
  {
    name: "campsite-identifier-rate___it",
    path: "/it/campeggio/:identifier()/valutare",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/index.vue")
  },
  {
    name: "campsite-identifier-rate___es",
    path: "/es/camping/:identifier()/valorar",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/index.vue")
  },
  {
    name: "campsite-identifier-rate___bg",
    path: "/bg/%D0%BB%D0%B0%D0%B3%D0%B5%D1%80/:identifier()/%D0%BE%D1%86%D0%B5%D0%BD%D0%B8",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/index.vue")
  },
  {
    name: "campsite-identifier-rate___bs",
    path: "/bs/kamp-mjesto/:identifier()/procijeniti",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/index.vue")
  },
  {
    name: "campsite-identifier-rate___cs",
    path: "/cs/kemp/:identifier()/posoudit",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/index.vue")
  },
  {
    name: "campsite-identifier-rate___da",
    path: "/da/campinggrund/:identifier()/vurdere",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/index.vue")
  },
  {
    name: "campsite-identifier-rate___el",
    path: "/el/%CE%B8%CE%B5%CF%83%CE%B7-%CE%BA%CE%B1%CE%BC%CF%80%CE%B9%CE%BD%CE%B3%CE%BA/:identifier()/%CE%B1%CE%BE%CE%B9%CE%BF%CE%BB%CF%8C%CE%B3%CE%B7%CF%83%CE%B7",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/index.vue")
  },
  {
    name: "campsite-identifier-rate___et",
    path: "/et/kamping/:identifier()/hindama",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/index.vue")
  },
  {
    name: "campsite-identifier-rate___fi",
    path: "/fi/leirintaalue/:identifier()/arvioida",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/index.vue")
  },
  {
    name: "campsite-identifier-rate___hr",
    path: "/hr/mjesto-za-kampiranje/:identifier()/procijeniti",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/index.vue")
  },
  {
    name: "campsite-identifier-rate___hu",
    path: "/hu/taborhely/:identifier()/%C3%A9rt%C3%A9keli",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/index.vue")
  },
  {
    name: "campsite-identifier-rate___lt",
    path: "/lt/stovyklaviete/:identifier()/%C4%AFvertinti",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/index.vue")
  },
  {
    name: "campsite-identifier-rate___lv",
    path: "/lv/karavanu-vieta/:identifier()/noteikt",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/index.vue")
  },
  {
    name: "campsite-identifier-rate___no",
    path: "/no/campingplass/:identifier()/vurdere",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/index.vue")
  },
  {
    name: "campsite-identifier-rate___pl",
    path: "/pl/miejsce-kempingowe/:identifier()/oszacowa%C4%87",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/index.vue")
  },
  {
    name: "campsite-identifier-rate___pt",
    path: "/pt/acampamento/:identifier()/avaliar",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/index.vue")
  },
  {
    name: "campsite-identifier-rate___ro",
    path: "/ro/loc-de-campare/:identifier()/evalua",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/index.vue")
  },
  {
    name: "campsite-identifier-rate___ru",
    path: "/ru/%D0%BA%D0%B5%D0%BC%D0%BF%D0%B8%D0%BD%D0%B3-%D0%BB%D0%B0%D0%B3%D0%B5%D1%80%D1%8C/:identifier()/%D0%BE%D1%86%D0%B5%D0%BD%D0%B8%D1%82%D1%8C",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/index.vue")
  },
  {
    name: "campsite-identifier-rate___sk",
    path: "/sk/miesto-na-kempovanie/:identifier()/pos%C3%BAdi%C5%A5",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/index.vue")
  },
  {
    name: "campsite-identifier-rate___sl",
    path: "/sl/kamp/:identifier()/oceniti",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/index.vue")
  },
  {
    name: "campsite-identifier-rate___sr",
    path: "/sr/kamp-lokacija/:identifier()/proceniti",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/index.vue")
  },
  {
    name: "campsite-identifier-rate___sv",
    path: "/sv/taltplats/:identifier()/bed%C3%B6ma",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/index.vue")
  },
  {
    name: "campsite-identifier-rate___tr",
    path: "/tr/kamp-alani/:identifier()/belirlemek",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/index.vue")
  },
  {
    name: "popularRegion-regionSlug___de",
    path: "/de/beliebte-region/:regionSlug()",
    meta: { ...(indexUxKA0LBXCqZOaptHXPfgjSIoHyiWng63iFE1BZr_1rwMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/popularRegion/[regionSlug]/index.vue")
  },
  {
    name: "popularRegion-regionSlug___en",
    path: "/en/popular-region/:regionSlug()",
    meta: { ...(indexUxKA0LBXCqZOaptHXPfgjSIoHyiWng63iFE1BZr_1rwMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/popularRegion/[regionSlug]/index.vue")
  },
  {
    name: "popularRegion-regionSlug___nl",
    path: "/nl/populaire-landen/:regionSlug()",
    meta: { ...(indexUxKA0LBXCqZOaptHXPfgjSIoHyiWng63iFE1BZr_1rwMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/popularRegion/[regionSlug]/index.vue")
  },
  {
    name: "popularRegion-regionSlug___fr",
    path: "/fr/region-populaire/:regionSlug()",
    meta: { ...(indexUxKA0LBXCqZOaptHXPfgjSIoHyiWng63iFE1BZr_1rwMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/popularRegion/[regionSlug]/index.vue")
  },
  {
    name: "popularRegion-regionSlug___it",
    path: "/it/regione-popolare/:regionSlug()",
    meta: { ...(indexUxKA0LBXCqZOaptHXPfgjSIoHyiWng63iFE1BZr_1rwMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/popularRegion/[regionSlug]/index.vue")
  },
  {
    name: "popularRegion-regionSlug___es",
    path: "/es/regi%C3%B3n-popular/:regionSlug()",
    meta: { ...(indexUxKA0LBXCqZOaptHXPfgjSIoHyiWng63iFE1BZr_1rwMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/popularRegion/[regionSlug]/index.vue")
  },
  {
    name: "popularRegion-regionSlug___bg",
    path: "/bg/%D0%BF%D0%BE%D0%BF%D1%83%D0%BB%D1%8F%D1%80%D0%BD%D0%B0-%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82/:regionSlug()",
    meta: { ...(indexUxKA0LBXCqZOaptHXPfgjSIoHyiWng63iFE1BZr_1rwMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/popularRegion/[regionSlug]/index.vue")
  },
  {
    name: "popularRegion-regionSlug___bs",
    path: "/bs/popularan-region/:regionSlug()",
    meta: { ...(indexUxKA0LBXCqZOaptHXPfgjSIoHyiWng63iFE1BZr_1rwMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/popularRegion/[regionSlug]/index.vue")
  },
  {
    name: "popularRegion-regionSlug___cs",
    path: "/cs/oblibene-regiony/:regionSlug()",
    meta: { ...(indexUxKA0LBXCqZOaptHXPfgjSIoHyiWng63iFE1BZr_1rwMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/popularRegion/[regionSlug]/index.vue")
  },
  {
    name: "popularRegion-regionSlug___da",
    path: "/da/popul%C3%A6r-region/:regionSlug()",
    meta: { ...(indexUxKA0LBXCqZOaptHXPfgjSIoHyiWng63iFE1BZr_1rwMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/popularRegion/[regionSlug]/index.vue")
  },
  {
    name: "popularRegion-regionSlug___el",
    path: "/el/%CE%B4%CE%B7%CE%BC%CE%BF%CF%86%CE%B9%CE%BB%CE%B7%CF%82-%CF%80%CE%B5%CF%81%CE%B9%CE%BF%CF%87%CE%B7/:regionSlug()",
    meta: { ...(indexUxKA0LBXCqZOaptHXPfgjSIoHyiWng63iFE1BZr_1rwMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/popularRegion/[regionSlug]/index.vue")
  },
  {
    name: "popularRegion-regionSlug___et",
    path: "/et/populaarne-piirkond/:regionSlug()",
    meta: { ...(indexUxKA0LBXCqZOaptHXPfgjSIoHyiWng63iFE1BZr_1rwMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/popularRegion/[regionSlug]/index.vue")
  },
  {
    name: "popularRegion-regionSlug___fi",
    path: "/fi/suosittu-alue/:regionSlug()",
    meta: { ...(indexUxKA0LBXCqZOaptHXPfgjSIoHyiWng63iFE1BZr_1rwMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/popularRegion/[regionSlug]/index.vue")
  },
  {
    name: "popularRegion-regionSlug___hr",
    path: "/hr/popularna-regija/:regionSlug()",
    meta: { ...(indexUxKA0LBXCqZOaptHXPfgjSIoHyiWng63iFE1BZr_1rwMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/popularRegion/[regionSlug]/index.vue")
  },
  {
    name: "popularRegion-regionSlug___hu",
    path: "/hu/nepszeru-regio/:regionSlug()",
    meta: { ...(indexUxKA0LBXCqZOaptHXPfgjSIoHyiWng63iFE1BZr_1rwMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/popularRegion/[regionSlug]/index.vue")
  },
  {
    name: "popularRegion-regionSlug___lt",
    path: "/lt/populiarus-regionas/:regionSlug()",
    meta: { ...(indexUxKA0LBXCqZOaptHXPfgjSIoHyiWng63iFE1BZr_1rwMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/popularRegion/[regionSlug]/index.vue")
  },
  {
    name: "popularRegion-regionSlug___lv",
    path: "/lv/populari-regioni/:regionSlug()",
    meta: { ...(indexUxKA0LBXCqZOaptHXPfgjSIoHyiWng63iFE1BZr_1rwMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/popularRegion/[regionSlug]/index.vue")
  },
  {
    name: "popularRegion-regionSlug___no",
    path: "/no/populaer-region/:regionSlug()",
    meta: { ...(indexUxKA0LBXCqZOaptHXPfgjSIoHyiWng63iFE1BZr_1rwMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/popularRegion/[regionSlug]/index.vue")
  },
  {
    name: "popularRegion-regionSlug___pl",
    path: "/pl/popularny-region/:regionSlug()",
    meta: { ...(indexUxKA0LBXCqZOaptHXPfgjSIoHyiWng63iFE1BZr_1rwMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/popularRegion/[regionSlug]/index.vue")
  },
  {
    name: "popularRegion-regionSlug___pt",
    path: "/pt/regiao-popular/:regionSlug()",
    meta: { ...(indexUxKA0LBXCqZOaptHXPfgjSIoHyiWng63iFE1BZr_1rwMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/popularRegion/[regionSlug]/index.vue")
  },
  {
    name: "popularRegion-regionSlug___ro",
    path: "/ro/regiune-populara/:regionSlug()",
    meta: { ...(indexUxKA0LBXCqZOaptHXPfgjSIoHyiWng63iFE1BZr_1rwMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/popularRegion/[regionSlug]/index.vue")
  },
  {
    name: "popularRegion-regionSlug___ru",
    path: "/ru/%D0%BF%D0%BE%D0%BF%D1%83%D0%BB%D1%8F%D1%80%D0%BD%D1%8B%D0%B8-%D1%80%D0%B5%D0%B3%D0%B8%D0%BE%D0%BD/:regionSlug()",
    meta: { ...(indexUxKA0LBXCqZOaptHXPfgjSIoHyiWng63iFE1BZr_1rwMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/popularRegion/[regionSlug]/index.vue")
  },
  {
    name: "popularRegion-regionSlug___sk",
    path: "/sk/popularna-oblast/:regionSlug()",
    meta: { ...(indexUxKA0LBXCqZOaptHXPfgjSIoHyiWng63iFE1BZr_1rwMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/popularRegion/[regionSlug]/index.vue")
  },
  {
    name: "popularRegion-regionSlug___sl",
    path: "/sl/priljubljena-regija/:regionSlug()",
    meta: { ...(indexUxKA0LBXCqZOaptHXPfgjSIoHyiWng63iFE1BZr_1rwMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/popularRegion/[regionSlug]/index.vue")
  },
  {
    name: "popularRegion-regionSlug___sr",
    path: "/sr/popularan-region/:regionSlug()",
    meta: { ...(indexUxKA0LBXCqZOaptHXPfgjSIoHyiWng63iFE1BZr_1rwMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/popularRegion/[regionSlug]/index.vue")
  },
  {
    name: "popularRegion-regionSlug___sv",
    path: "/sv/popular-region/:regionSlug()",
    meta: { ...(indexUxKA0LBXCqZOaptHXPfgjSIoHyiWng63iFE1BZr_1rwMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/popularRegion/[regionSlug]/index.vue")
  },
  {
    name: "popularRegion-regionSlug___tr",
    path: "/tr/populer-bolge/:regionSlug()",
    meta: { ...(indexUxKA0LBXCqZOaptHXPfgjSIoHyiWng63iFE1BZr_1rwMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/popularRegion/[regionSlug]/index.vue")
  },
  {
    name: "campsite-identifier-media___de",
    path: "/de/campingplatz/:identifier()/media",
    meta: indexp_sjgyuWvL_ST02FWKCmVF_vBng6N4_HEDRC5SrnXhUMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/media/index.vue")
  },
  {
    name: "campsite-identifier-media___en",
    path: "/en/campsite/:identifier()/media",
    meta: indexp_sjgyuWvL_ST02FWKCmVF_vBng6N4_HEDRC5SrnXhUMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/media/index.vue")
  },
  {
    name: "campsite-identifier-media___nl",
    path: "/nl/kampeerplek/:identifier()/media",
    meta: indexp_sjgyuWvL_ST02FWKCmVF_vBng6N4_HEDRC5SrnXhUMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/media/index.vue")
  },
  {
    name: "campsite-identifier-media___fr",
    path: "/fr/emplacement-de-camping/:identifier()/media",
    meta: indexp_sjgyuWvL_ST02FWKCmVF_vBng6N4_HEDRC5SrnXhUMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/media/index.vue")
  },
  {
    name: "campsite-identifier-media___it",
    path: "/it/campeggio/:identifier()/media",
    meta: indexp_sjgyuWvL_ST02FWKCmVF_vBng6N4_HEDRC5SrnXhUMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/media/index.vue")
  },
  {
    name: "campsite-identifier-media___es",
    path: "/es/camping/:identifier()/media",
    meta: indexp_sjgyuWvL_ST02FWKCmVF_vBng6N4_HEDRC5SrnXhUMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/media/index.vue")
  },
  {
    name: "campsite-identifier-media___bg",
    path: "/bg/%D0%BB%D0%B0%D0%B3%D0%B5%D1%80/:identifier()/media",
    meta: indexp_sjgyuWvL_ST02FWKCmVF_vBng6N4_HEDRC5SrnXhUMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/media/index.vue")
  },
  {
    name: "campsite-identifier-media___bs",
    path: "/bs/kamp-mjesto/:identifier()/media",
    meta: indexp_sjgyuWvL_ST02FWKCmVF_vBng6N4_HEDRC5SrnXhUMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/media/index.vue")
  },
  {
    name: "campsite-identifier-media___cs",
    path: "/cs/kemp/:identifier()/media",
    meta: indexp_sjgyuWvL_ST02FWKCmVF_vBng6N4_HEDRC5SrnXhUMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/media/index.vue")
  },
  {
    name: "campsite-identifier-media___da",
    path: "/da/campinggrund/:identifier()/media",
    meta: indexp_sjgyuWvL_ST02FWKCmVF_vBng6N4_HEDRC5SrnXhUMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/media/index.vue")
  },
  {
    name: "campsite-identifier-media___el",
    path: "/el/%CE%B8%CE%B5%CF%83%CE%B7-%CE%BA%CE%B1%CE%BC%CF%80%CE%B9%CE%BD%CE%B3%CE%BA/:identifier()/media",
    meta: indexp_sjgyuWvL_ST02FWKCmVF_vBng6N4_HEDRC5SrnXhUMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/media/index.vue")
  },
  {
    name: "campsite-identifier-media___et",
    path: "/et/kamping/:identifier()/media",
    meta: indexp_sjgyuWvL_ST02FWKCmVF_vBng6N4_HEDRC5SrnXhUMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/media/index.vue")
  },
  {
    name: "campsite-identifier-media___fi",
    path: "/fi/leirintaalue/:identifier()/media",
    meta: indexp_sjgyuWvL_ST02FWKCmVF_vBng6N4_HEDRC5SrnXhUMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/media/index.vue")
  },
  {
    name: "campsite-identifier-media___hr",
    path: "/hr/mjesto-za-kampiranje/:identifier()/media",
    meta: indexp_sjgyuWvL_ST02FWKCmVF_vBng6N4_HEDRC5SrnXhUMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/media/index.vue")
  },
  {
    name: "campsite-identifier-media___hu",
    path: "/hu/taborhely/:identifier()/media",
    meta: indexp_sjgyuWvL_ST02FWKCmVF_vBng6N4_HEDRC5SrnXhUMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/media/index.vue")
  },
  {
    name: "campsite-identifier-media___lt",
    path: "/lt/stovyklaviete/:identifier()/media",
    meta: indexp_sjgyuWvL_ST02FWKCmVF_vBng6N4_HEDRC5SrnXhUMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/media/index.vue")
  },
  {
    name: "campsite-identifier-media___lv",
    path: "/lv/karavanu-vieta/:identifier()/media",
    meta: indexp_sjgyuWvL_ST02FWKCmVF_vBng6N4_HEDRC5SrnXhUMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/media/index.vue")
  },
  {
    name: "campsite-identifier-media___no",
    path: "/no/campingplass/:identifier()/media",
    meta: indexp_sjgyuWvL_ST02FWKCmVF_vBng6N4_HEDRC5SrnXhUMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/media/index.vue")
  },
  {
    name: "campsite-identifier-media___pl",
    path: "/pl/miejsce-kempingowe/:identifier()/media",
    meta: indexp_sjgyuWvL_ST02FWKCmVF_vBng6N4_HEDRC5SrnXhUMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/media/index.vue")
  },
  {
    name: "campsite-identifier-media___pt",
    path: "/pt/acampamento/:identifier()/media",
    meta: indexp_sjgyuWvL_ST02FWKCmVF_vBng6N4_HEDRC5SrnXhUMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/media/index.vue")
  },
  {
    name: "campsite-identifier-media___ro",
    path: "/ro/loc-de-campare/:identifier()/media",
    meta: indexp_sjgyuWvL_ST02FWKCmVF_vBng6N4_HEDRC5SrnXhUMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/media/index.vue")
  },
  {
    name: "campsite-identifier-media___ru",
    path: "/ru/%D0%BA%D0%B5%D0%BC%D0%BF%D0%B8%D0%BD%D0%B3-%D0%BB%D0%B0%D0%B3%D0%B5%D1%80%D1%8C/:identifier()/media",
    meta: indexp_sjgyuWvL_ST02FWKCmVF_vBng6N4_HEDRC5SrnXhUMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/media/index.vue")
  },
  {
    name: "campsite-identifier-media___sk",
    path: "/sk/miesto-na-kempovanie/:identifier()/media",
    meta: indexp_sjgyuWvL_ST02FWKCmVF_vBng6N4_HEDRC5SrnXhUMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/media/index.vue")
  },
  {
    name: "campsite-identifier-media___sl",
    path: "/sl/kamp/:identifier()/media",
    meta: indexp_sjgyuWvL_ST02FWKCmVF_vBng6N4_HEDRC5SrnXhUMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/media/index.vue")
  },
  {
    name: "campsite-identifier-media___sr",
    path: "/sr/kamp-lokacija/:identifier()/media",
    meta: indexp_sjgyuWvL_ST02FWKCmVF_vBng6N4_HEDRC5SrnXhUMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/media/index.vue")
  },
  {
    name: "campsite-identifier-media___sv",
    path: "/sv/taltplats/:identifier()/media",
    meta: indexp_sjgyuWvL_ST02FWKCmVF_vBng6N4_HEDRC5SrnXhUMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/media/index.vue")
  },
  {
    name: "campsite-identifier-media___tr",
    path: "/tr/kamp-alani/:identifier()/media",
    meta: indexp_sjgyuWvL_ST02FWKCmVF_vBng6N4_HEDRC5SrnXhUMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/media/index.vue")
  },
  {
    name: "account-confirm-email-change___de",
    path: "/de/account/confirm-email-change",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirm-email-change/index.vue")
  },
  {
    name: "account-confirm-email-change___en",
    path: "/en/account/confirm-email-change",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirm-email-change/index.vue")
  },
  {
    name: "account-confirm-email-change___nl",
    path: "/nl/account/confirm-email-change",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirm-email-change/index.vue")
  },
  {
    name: "account-confirm-email-change___fr",
    path: "/fr/account/confirm-email-change",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirm-email-change/index.vue")
  },
  {
    name: "account-confirm-email-change___it",
    path: "/it/account/confirm-email-change",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirm-email-change/index.vue")
  },
  {
    name: "account-confirm-email-change___es",
    path: "/es/account/confirm-email-change",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirm-email-change/index.vue")
  },
  {
    name: "account-confirm-email-change___bg",
    path: "/bg/account/confirm-email-change",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirm-email-change/index.vue")
  },
  {
    name: "account-confirm-email-change___bs",
    path: "/bs/account/confirm-email-change",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirm-email-change/index.vue")
  },
  {
    name: "account-confirm-email-change___cs",
    path: "/cs/account/confirm-email-change",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirm-email-change/index.vue")
  },
  {
    name: "account-confirm-email-change___da",
    path: "/da/account/confirm-email-change",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirm-email-change/index.vue")
  },
  {
    name: "account-confirm-email-change___el",
    path: "/el/account/confirm-email-change",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirm-email-change/index.vue")
  },
  {
    name: "account-confirm-email-change___et",
    path: "/et/account/confirm-email-change",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirm-email-change/index.vue")
  },
  {
    name: "account-confirm-email-change___fi",
    path: "/fi/account/confirm-email-change",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirm-email-change/index.vue")
  },
  {
    name: "account-confirm-email-change___hr",
    path: "/hr/account/confirm-email-change",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirm-email-change/index.vue")
  },
  {
    name: "account-confirm-email-change___hu",
    path: "/hu/account/confirm-email-change",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirm-email-change/index.vue")
  },
  {
    name: "account-confirm-email-change___lt",
    path: "/lt/account/confirm-email-change",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirm-email-change/index.vue")
  },
  {
    name: "account-confirm-email-change___lv",
    path: "/lv/account/confirm-email-change",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirm-email-change/index.vue")
  },
  {
    name: "account-confirm-email-change___no",
    path: "/no/account/confirm-email-change",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirm-email-change/index.vue")
  },
  {
    name: "account-confirm-email-change___pl",
    path: "/pl/account/confirm-email-change",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirm-email-change/index.vue")
  },
  {
    name: "account-confirm-email-change___pt",
    path: "/pt/account/confirm-email-change",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirm-email-change/index.vue")
  },
  {
    name: "account-confirm-email-change___ro",
    path: "/ro/account/confirm-email-change",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirm-email-change/index.vue")
  },
  {
    name: "account-confirm-email-change___ru",
    path: "/ru/account/confirm-email-change",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirm-email-change/index.vue")
  },
  {
    name: "account-confirm-email-change___sk",
    path: "/sk/account/confirm-email-change",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirm-email-change/index.vue")
  },
  {
    name: "account-confirm-email-change___sl",
    path: "/sl/account/confirm-email-change",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirm-email-change/index.vue")
  },
  {
    name: "account-confirm-email-change___sr",
    path: "/sr/account/confirm-email-change",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirm-email-change/index.vue")
  },
  {
    name: "account-confirm-email-change___sv",
    path: "/sv/account/confirm-email-change",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirm-email-change/index.vue")
  },
  {
    name: "account-confirm-email-change___tr",
    path: "/tr/account/confirm-email-change",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/confirm-email-change/index.vue")
  },
  {
    name: "campsite-identifier-upload___de",
    path: "/de/campingplatz/:identifier()/hochladen",
    meta: indexw9sg5vp4gQj0Ee4wu_53oCjScnAgJIFkzF7n3KSY85MMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/index.vue")
  },
  {
    name: "campsite-identifier-upload___en",
    path: "/en/campsite/:identifier()/upload",
    meta: indexw9sg5vp4gQj0Ee4wu_53oCjScnAgJIFkzF7n3KSY85MMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/index.vue")
  },
  {
    name: "campsite-identifier-upload___nl",
    path: "/nl/kampeerplek/:identifier()/uploaden",
    meta: indexw9sg5vp4gQj0Ee4wu_53oCjScnAgJIFkzF7n3KSY85MMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/index.vue")
  },
  {
    name: "campsite-identifier-upload___fr",
    path: "/fr/emplacement-de-camping/:identifier()/t%C3%A9l%C3%A9charger",
    meta: indexw9sg5vp4gQj0Ee4wu_53oCjScnAgJIFkzF7n3KSY85MMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/index.vue")
  },
  {
    name: "campsite-identifier-upload___it",
    path: "/it/campeggio/:identifier()/upload",
    meta: indexw9sg5vp4gQj0Ee4wu_53oCjScnAgJIFkzF7n3KSY85MMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/index.vue")
  },
  {
    name: "campsite-identifier-upload___es",
    path: "/es/camping/:identifier()/subir",
    meta: indexw9sg5vp4gQj0Ee4wu_53oCjScnAgJIFkzF7n3KSY85MMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/index.vue")
  },
  {
    name: "campsite-identifier-upload___bg",
    path: "/bg/%D0%BB%D0%B0%D0%B3%D0%B5%D1%80/:identifier()/%D0%BA%D0%B0%D1%87%D0%B2%D0%B0%D0%BD%D0%B5",
    meta: indexw9sg5vp4gQj0Ee4wu_53oCjScnAgJIFkzF7n3KSY85MMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/index.vue")
  },
  {
    name: "campsite-identifier-upload___bs",
    path: "/bs/kamp-mjesto/:identifier()/upload",
    meta: indexw9sg5vp4gQj0Ee4wu_53oCjScnAgJIFkzF7n3KSY85MMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/index.vue")
  },
  {
    name: "campsite-identifier-upload___cs",
    path: "/cs/kemp/:identifier()/nahr%C3%A1t",
    meta: indexw9sg5vp4gQj0Ee4wu_53oCjScnAgJIFkzF7n3KSY85MMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/index.vue")
  },
  {
    name: "campsite-identifier-upload___da",
    path: "/da/campinggrund/:identifier()/uploade",
    meta: indexw9sg5vp4gQj0Ee4wu_53oCjScnAgJIFkzF7n3KSY85MMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/index.vue")
  },
  {
    name: "campsite-identifier-upload___el",
    path: "/el/%CE%B8%CE%B5%CF%83%CE%B7-%CE%BA%CE%B1%CE%BC%CF%80%CE%B9%CE%BD%CE%B3%CE%BA/:identifier()/upload",
    meta: indexw9sg5vp4gQj0Ee4wu_53oCjScnAgJIFkzF7n3KSY85MMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/index.vue")
  },
  {
    name: "campsite-identifier-upload___et",
    path: "/et/kamping/:identifier()/laadi-%C3%BCles",
    meta: indexw9sg5vp4gQj0Ee4wu_53oCjScnAgJIFkzF7n3KSY85MMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/index.vue")
  },
  {
    name: "campsite-identifier-upload___fi",
    path: "/fi/leirintaalue/:identifier()/upload",
    meta: indexw9sg5vp4gQj0Ee4wu_53oCjScnAgJIFkzF7n3KSY85MMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/index.vue")
  },
  {
    name: "campsite-identifier-upload___hr",
    path: "/hr/mjesto-za-kampiranje/:identifier()/uploadati",
    meta: indexw9sg5vp4gQj0Ee4wu_53oCjScnAgJIFkzF7n3KSY85MMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/index.vue")
  },
  {
    name: "campsite-identifier-upload___hu",
    path: "/hu/taborhely/:identifier()/upload",
    meta: indexw9sg5vp4gQj0Ee4wu_53oCjScnAgJIFkzF7n3KSY85MMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/index.vue")
  },
  {
    name: "campsite-identifier-upload___lt",
    path: "/lt/stovyklaviete/:identifier()/%C4%AFkelti",
    meta: indexw9sg5vp4gQj0Ee4wu_53oCjScnAgJIFkzF7n3KSY85MMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/index.vue")
  },
  {
    name: "campsite-identifier-upload___lv",
    path: "/lv/karavanu-vieta/:identifier()/aug%C5%A1upiel%C4%81d%C4%93t",
    meta: indexw9sg5vp4gQj0Ee4wu_53oCjScnAgJIFkzF7n3KSY85MMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/index.vue")
  },
  {
    name: "campsite-identifier-upload___no",
    path: "/no/campingplass/:identifier()/laste-opp",
    meta: indexw9sg5vp4gQj0Ee4wu_53oCjScnAgJIFkzF7n3KSY85MMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/index.vue")
  },
  {
    name: "campsite-identifier-upload___pl",
    path: "/pl/miejsce-kempingowe/:identifier()/przekaza%C4%87-plik",
    meta: indexw9sg5vp4gQj0Ee4wu_53oCjScnAgJIFkzF7n3KSY85MMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/index.vue")
  },
  {
    name: "campsite-identifier-upload___pt",
    path: "/pt/acampamento/:identifier()/inserir",
    meta: indexw9sg5vp4gQj0Ee4wu_53oCjScnAgJIFkzF7n3KSY85MMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/index.vue")
  },
  {
    name: "campsite-identifier-upload___ro",
    path: "/ro/loc-de-campare/:identifier()/%C3%AEnc%C4%83rcare",
    meta: indexw9sg5vp4gQj0Ee4wu_53oCjScnAgJIFkzF7n3KSY85MMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/index.vue")
  },
  {
    name: "campsite-identifier-upload___ru",
    path: "/ru/%D0%BA%D0%B5%D0%BC%D0%BF%D0%B8%D0%BD%D0%B3-%D0%BB%D0%B0%D0%B3%D0%B5%D1%80%D1%8C/:identifier()/%D0%B7%D0%B0%D0%B3%D1%80%D1%83%D0%B7%D0%BA%D0%B0",
    meta: indexw9sg5vp4gQj0Ee4wu_53oCjScnAgJIFkzF7n3KSY85MMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/index.vue")
  },
  {
    name: "campsite-identifier-upload___sk",
    path: "/sk/miesto-na-kempovanie/:identifier()/upload",
    meta: indexw9sg5vp4gQj0Ee4wu_53oCjScnAgJIFkzF7n3KSY85MMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/index.vue")
  },
  {
    name: "campsite-identifier-upload___sl",
    path: "/sl/kamp/:identifier()/upload",
    meta: indexw9sg5vp4gQj0Ee4wu_53oCjScnAgJIFkzF7n3KSY85MMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/index.vue")
  },
  {
    name: "campsite-identifier-upload___sr",
    path: "/sr/kamp-lokacija/:identifier()/upload",
    meta: indexw9sg5vp4gQj0Ee4wu_53oCjScnAgJIFkzF7n3KSY85MMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/index.vue")
  },
  {
    name: "campsite-identifier-upload___sv",
    path: "/sv/taltplats/:identifier()/ladda-upp",
    meta: indexw9sg5vp4gQj0Ee4wu_53oCjScnAgJIFkzF7n3KSY85MMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/index.vue")
  },
  {
    name: "campsite-identifier-upload___tr",
    path: "/tr/kamp-alani/:identifier()/y%C3%BCklemek",
    meta: indexw9sg5vp4gQj0Ee4wu_53oCjScnAgJIFkzF7n3KSY85MMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/index.vue")
  },
  {
    name: "account-marketing-preferences___de",
    path: "/de/account/marketing-preferences",
    meta: indexFyyxBkV6Cc6ildN_M_woPkaIMlUHHEsRgOZhXa2SqXIMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/marketing-preferences/index.vue")
  },
  {
    name: "account-marketing-preferences___en",
    path: "/en/account/marketing-preferences",
    meta: indexFyyxBkV6Cc6ildN_M_woPkaIMlUHHEsRgOZhXa2SqXIMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/marketing-preferences/index.vue")
  },
  {
    name: "account-marketing-preferences___nl",
    path: "/nl/account/marketing-preferences",
    meta: indexFyyxBkV6Cc6ildN_M_woPkaIMlUHHEsRgOZhXa2SqXIMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/marketing-preferences/index.vue")
  },
  {
    name: "account-marketing-preferences___fr",
    path: "/fr/account/marketing-preferences",
    meta: indexFyyxBkV6Cc6ildN_M_woPkaIMlUHHEsRgOZhXa2SqXIMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/marketing-preferences/index.vue")
  },
  {
    name: "account-marketing-preferences___it",
    path: "/it/account/marketing-preferences",
    meta: indexFyyxBkV6Cc6ildN_M_woPkaIMlUHHEsRgOZhXa2SqXIMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/marketing-preferences/index.vue")
  },
  {
    name: "account-marketing-preferences___es",
    path: "/es/account/marketing-preferences",
    meta: indexFyyxBkV6Cc6ildN_M_woPkaIMlUHHEsRgOZhXa2SqXIMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/marketing-preferences/index.vue")
  },
  {
    name: "account-marketing-preferences___bg",
    path: "/bg/account/marketing-preferences",
    meta: indexFyyxBkV6Cc6ildN_M_woPkaIMlUHHEsRgOZhXa2SqXIMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/marketing-preferences/index.vue")
  },
  {
    name: "account-marketing-preferences___bs",
    path: "/bs/account/marketing-preferences",
    meta: indexFyyxBkV6Cc6ildN_M_woPkaIMlUHHEsRgOZhXa2SqXIMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/marketing-preferences/index.vue")
  },
  {
    name: "account-marketing-preferences___cs",
    path: "/cs/account/marketing-preferences",
    meta: indexFyyxBkV6Cc6ildN_M_woPkaIMlUHHEsRgOZhXa2SqXIMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/marketing-preferences/index.vue")
  },
  {
    name: "account-marketing-preferences___da",
    path: "/da/account/marketing-preferences",
    meta: indexFyyxBkV6Cc6ildN_M_woPkaIMlUHHEsRgOZhXa2SqXIMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/marketing-preferences/index.vue")
  },
  {
    name: "account-marketing-preferences___el",
    path: "/el/account/marketing-preferences",
    meta: indexFyyxBkV6Cc6ildN_M_woPkaIMlUHHEsRgOZhXa2SqXIMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/marketing-preferences/index.vue")
  },
  {
    name: "account-marketing-preferences___et",
    path: "/et/account/marketing-preferences",
    meta: indexFyyxBkV6Cc6ildN_M_woPkaIMlUHHEsRgOZhXa2SqXIMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/marketing-preferences/index.vue")
  },
  {
    name: "account-marketing-preferences___fi",
    path: "/fi/account/marketing-preferences",
    meta: indexFyyxBkV6Cc6ildN_M_woPkaIMlUHHEsRgOZhXa2SqXIMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/marketing-preferences/index.vue")
  },
  {
    name: "account-marketing-preferences___hr",
    path: "/hr/account/marketing-preferences",
    meta: indexFyyxBkV6Cc6ildN_M_woPkaIMlUHHEsRgOZhXa2SqXIMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/marketing-preferences/index.vue")
  },
  {
    name: "account-marketing-preferences___hu",
    path: "/hu/account/marketing-preferences",
    meta: indexFyyxBkV6Cc6ildN_M_woPkaIMlUHHEsRgOZhXa2SqXIMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/marketing-preferences/index.vue")
  },
  {
    name: "account-marketing-preferences___lt",
    path: "/lt/account/marketing-preferences",
    meta: indexFyyxBkV6Cc6ildN_M_woPkaIMlUHHEsRgOZhXa2SqXIMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/marketing-preferences/index.vue")
  },
  {
    name: "account-marketing-preferences___lv",
    path: "/lv/account/marketing-preferences",
    meta: indexFyyxBkV6Cc6ildN_M_woPkaIMlUHHEsRgOZhXa2SqXIMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/marketing-preferences/index.vue")
  },
  {
    name: "account-marketing-preferences___no",
    path: "/no/account/marketing-preferences",
    meta: indexFyyxBkV6Cc6ildN_M_woPkaIMlUHHEsRgOZhXa2SqXIMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/marketing-preferences/index.vue")
  },
  {
    name: "account-marketing-preferences___pl",
    path: "/pl/account/marketing-preferences",
    meta: indexFyyxBkV6Cc6ildN_M_woPkaIMlUHHEsRgOZhXa2SqXIMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/marketing-preferences/index.vue")
  },
  {
    name: "account-marketing-preferences___pt",
    path: "/pt/account/marketing-preferences",
    meta: indexFyyxBkV6Cc6ildN_M_woPkaIMlUHHEsRgOZhXa2SqXIMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/marketing-preferences/index.vue")
  },
  {
    name: "account-marketing-preferences___ro",
    path: "/ro/account/marketing-preferences",
    meta: indexFyyxBkV6Cc6ildN_M_woPkaIMlUHHEsRgOZhXa2SqXIMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/marketing-preferences/index.vue")
  },
  {
    name: "account-marketing-preferences___ru",
    path: "/ru/account/marketing-preferences",
    meta: indexFyyxBkV6Cc6ildN_M_woPkaIMlUHHEsRgOZhXa2SqXIMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/marketing-preferences/index.vue")
  },
  {
    name: "account-marketing-preferences___sk",
    path: "/sk/account/marketing-preferences",
    meta: indexFyyxBkV6Cc6ildN_M_woPkaIMlUHHEsRgOZhXa2SqXIMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/marketing-preferences/index.vue")
  },
  {
    name: "account-marketing-preferences___sl",
    path: "/sl/account/marketing-preferences",
    meta: indexFyyxBkV6Cc6ildN_M_woPkaIMlUHHEsRgOZhXa2SqXIMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/marketing-preferences/index.vue")
  },
  {
    name: "account-marketing-preferences___sr",
    path: "/sr/account/marketing-preferences",
    meta: indexFyyxBkV6Cc6ildN_M_woPkaIMlUHHEsRgOZhXa2SqXIMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/marketing-preferences/index.vue")
  },
  {
    name: "account-marketing-preferences___sv",
    path: "/sv/account/marketing-preferences",
    meta: indexFyyxBkV6Cc6ildN_M_woPkaIMlUHHEsRgOZhXa2SqXIMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/marketing-preferences/index.vue")
  },
  {
    name: "account-marketing-preferences___tr",
    path: "/tr/account/marketing-preferences",
    meta: indexFyyxBkV6Cc6ildN_M_woPkaIMlUHHEsRgOZhXa2SqXIMeta || {},
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/account/marketing-preferences/index.vue")
  },
  {
    name: "campsite-identifier-inquire___de",
    path: "/de/campingplatz/:identifier()/anfragen",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/inquire/index.vue")
  },
  {
    name: "campsite-identifier-inquire___en",
    path: "/en/campsite/:identifier()/inquire",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/inquire/index.vue")
  },
  {
    name: "campsite-identifier-inquire___nl",
    path: "/nl/kampeerplek/:identifier()/informeren",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/inquire/index.vue")
  },
  {
    name: "campsite-identifier-inquire___fr",
    path: "/fr/emplacement-de-camping/:identifier()/renseigner",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/inquire/index.vue")
  },
  {
    name: "campsite-identifier-inquire___it",
    path: "/it/campeggio/:identifier()/chiedere-informazioni",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/inquire/index.vue")
  },
  {
    name: "campsite-identifier-inquire___es",
    path: "/es/camping/:identifier()/preguntar",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/inquire/index.vue")
  },
  {
    name: "campsite-identifier-inquire___bg",
    path: "/bg/%D0%BB%D0%B0%D0%B3%D0%B5%D1%80/:identifier()/%D0%B7%D0%B0%D0%BF%D0%B8%D1%82%D0%B2%D0%B0%D0%BD%D0%B5",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/inquire/index.vue")
  },
  {
    name: "campsite-identifier-inquire___bs",
    path: "/bs/kamp-mjesto/:identifier()/raspitati-se",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/inquire/index.vue")
  },
  {
    name: "campsite-identifier-inquire___cs",
    path: "/cs/kemp/:identifier()/zeptat-se",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/inquire/index.vue")
  },
  {
    name: "campsite-identifier-inquire___da",
    path: "/da/campinggrund/:identifier()/forh%C3%B8re",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/inquire/index.vue")
  },
  {
    name: "campsite-identifier-inquire___el",
    path: "/el/%CE%B8%CE%B5%CF%83%CE%B7-%CE%BA%CE%B1%CE%BC%CF%80%CE%B9%CE%BD%CE%B3%CE%BA/:identifier()/%CF%81%CF%89%CF%84%CF%8E",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/inquire/index.vue")
  },
  {
    name: "campsite-identifier-inquire___et",
    path: "/et/kamping/:identifier()/k%C3%BCsima",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/inquire/index.vue")
  },
  {
    name: "campsite-identifier-inquire___fi",
    path: "/fi/leirintaalue/:identifier()/tiedustella",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/inquire/index.vue")
  },
  {
    name: "campsite-identifier-inquire___hr",
    path: "/hr/mjesto-za-kampiranje/:identifier()/raspitati",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/inquire/index.vue")
  },
  {
    name: "campsite-identifier-inquire___hu",
    path: "/hu/taborhely/:identifier()/%C3%A9rdekl%C5%91dik",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/inquire/index.vue")
  },
  {
    name: "campsite-identifier-inquire___lt",
    path: "/lt/stovyklaviete/:identifier()/teirautis",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/inquire/index.vue")
  },
  {
    name: "campsite-identifier-inquire___lv",
    path: "/lv/karavanu-vieta/:identifier()/jaut%C4%81t",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/inquire/index.vue")
  },
  {
    name: "campsite-identifier-inquire___no",
    path: "/no/campingplass/:identifier()/sp%C3%B8rre",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/inquire/index.vue")
  },
  {
    name: "campsite-identifier-inquire___pl",
    path: "/pl/miejsce-kempingowe/:identifier()/dowiadywa%C4%87-si%C4%99",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/inquire/index.vue")
  },
  {
    name: "campsite-identifier-inquire___pt",
    path: "/pt/acampamento/:identifier()/investigar",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/inquire/index.vue")
  },
  {
    name: "campsite-identifier-inquire___ro",
    path: "/ro/loc-de-campare/:identifier()/%C3%AEntreba",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/inquire/index.vue")
  },
  {
    name: "campsite-identifier-inquire___ru",
    path: "/ru/%D0%BA%D0%B5%D0%BC%D0%BF%D0%B8%D0%BD%D0%B3-%D0%BB%D0%B0%D0%B3%D0%B5%D1%80%D1%8C/:identifier()/%D1%81%D0%BF%D1%80%D0%B0%D0%B2%D0%BA%D0%B8",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/inquire/index.vue")
  },
  {
    name: "campsite-identifier-inquire___sk",
    path: "/sk/miesto-na-kempovanie/:identifier()/dotazovan%C3%ADm",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/inquire/index.vue")
  },
  {
    name: "campsite-identifier-inquire___sl",
    path: "/sl/kamp/:identifier()/poizvedovati",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/inquire/index.vue")
  },
  {
    name: "campsite-identifier-inquire___sr",
    path: "/sr/kamp-lokacija/:identifier()/%D0%BF%D0%B8%D1%82%D0%B0%D1%82%D0%B8",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/inquire/index.vue")
  },
  {
    name: "campsite-identifier-inquire___sv",
    path: "/sv/taltplats/:identifier()/fr%C3%A5ga",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/inquire/index.vue")
  },
  {
    name: "campsite-identifier-inquire___tr",
    path: "/tr/kamp-alani/:identifier()/sormak",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/inquire/index.vue")
  },
  {
    name: "campsite-identifier-reviews___de",
    path: "/de/campingplatz/:identifier()/bewertungen",
    meta: { ...(index59eZ49_1yPXOPE2T6wLlMZsa5BjSA55VriH39YVlm2wMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/reviews/index.vue")
  },
  {
    name: "campsite-identifier-reviews___en",
    path: "/en/campsite/:identifier()/reviews",
    meta: { ...(index59eZ49_1yPXOPE2T6wLlMZsa5BjSA55VriH39YVlm2wMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/reviews/index.vue")
  },
  {
    name: "campsite-identifier-reviews___nl",
    path: "/nl/kampeerplek/:identifier()/beoordelingen",
    meta: { ...(index59eZ49_1yPXOPE2T6wLlMZsa5BjSA55VriH39YVlm2wMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/reviews/index.vue")
  },
  {
    name: "campsite-identifier-reviews___fr",
    path: "/fr/emplacement-de-camping/:identifier()/critiques",
    meta: { ...(index59eZ49_1yPXOPE2T6wLlMZsa5BjSA55VriH39YVlm2wMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/reviews/index.vue")
  },
  {
    name: "campsite-identifier-reviews___it",
    path: "/it/campeggio/:identifier()/recensioni",
    meta: { ...(index59eZ49_1yPXOPE2T6wLlMZsa5BjSA55VriH39YVlm2wMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/reviews/index.vue")
  },
  {
    name: "campsite-identifier-reviews___es",
    path: "/es/camping/:identifier()/valoraciones",
    meta: { ...(index59eZ49_1yPXOPE2T6wLlMZsa5BjSA55VriH39YVlm2wMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/reviews/index.vue")
  },
  {
    name: "campsite-identifier-reviews___bg",
    path: "/bg/%D0%BB%D0%B0%D0%B3%D0%B5%D1%80/:identifier()/%D0%BC%D0%BD%D0%B5%D0%BD%D0%B8%D1%8F",
    meta: { ...(index59eZ49_1yPXOPE2T6wLlMZsa5BjSA55VriH39YVlm2wMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/reviews/index.vue")
  },
  {
    name: "campsite-identifier-reviews___bs",
    path: "/bs/kamp-mjesto/:identifier()/recenzije",
    meta: { ...(index59eZ49_1yPXOPE2T6wLlMZsa5BjSA55VriH39YVlm2wMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/reviews/index.vue")
  },
  {
    name: "campsite-identifier-reviews___cs",
    path: "/cs/kemp/:identifier()/recenze",
    meta: { ...(index59eZ49_1yPXOPE2T6wLlMZsa5BjSA55VriH39YVlm2wMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/reviews/index.vue")
  },
  {
    name: "campsite-identifier-reviews___da",
    path: "/da/campinggrund/:identifier()/anmeldelser",
    meta: { ...(index59eZ49_1yPXOPE2T6wLlMZsa5BjSA55VriH39YVlm2wMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/reviews/index.vue")
  },
  {
    name: "campsite-identifier-reviews___el",
    path: "/el/%CE%B8%CE%B5%CF%83%CE%B7-%CE%BA%CE%B1%CE%BC%CF%80%CE%B9%CE%BD%CE%B3%CE%BA/:identifier()/%CF%83%CF%87%CF%8C%CE%BB%CE%B9%CE%B1",
    meta: { ...(index59eZ49_1yPXOPE2T6wLlMZsa5BjSA55VriH39YVlm2wMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/reviews/index.vue")
  },
  {
    name: "campsite-identifier-reviews___et",
    path: "/et/kamping/:identifier()/%C3%BClevaated",
    meta: { ...(index59eZ49_1yPXOPE2T6wLlMZsa5BjSA55VriH39YVlm2wMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/reviews/index.vue")
  },
  {
    name: "campsite-identifier-reviews___fi",
    path: "/fi/leirintaalue/:identifier()/arvostelut",
    meta: { ...(index59eZ49_1yPXOPE2T6wLlMZsa5BjSA55VriH39YVlm2wMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/reviews/index.vue")
  },
  {
    name: "campsite-identifier-reviews___hr",
    path: "/hr/mjesto-za-kampiranje/:identifier()/recenzije",
    meta: { ...(index59eZ49_1yPXOPE2T6wLlMZsa5BjSA55VriH39YVlm2wMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/reviews/index.vue")
  },
  {
    name: "campsite-identifier-reviews___hu",
    path: "/hu/taborhely/:identifier()/v%C3%A9lem%C3%A9nyek",
    meta: { ...(index59eZ49_1yPXOPE2T6wLlMZsa5BjSA55VriH39YVlm2wMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/reviews/index.vue")
  },
  {
    name: "campsite-identifier-reviews___lt",
    path: "/lt/stovyklaviete/:identifier()/atsiliepimai",
    meta: { ...(index59eZ49_1yPXOPE2T6wLlMZsa5BjSA55VriH39YVlm2wMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/reviews/index.vue")
  },
  {
    name: "campsite-identifier-reviews___lv",
    path: "/lv/karavanu-vieta/:identifier()/atsauksmes",
    meta: { ...(index59eZ49_1yPXOPE2T6wLlMZsa5BjSA55VriH39YVlm2wMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/reviews/index.vue")
  },
  {
    name: "campsite-identifier-reviews___no",
    path: "/no/campingplass/:identifier()/anmeldelser",
    meta: { ...(index59eZ49_1yPXOPE2T6wLlMZsa5BjSA55VriH39YVlm2wMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/reviews/index.vue")
  },
  {
    name: "campsite-identifier-reviews___pl",
    path: "/pl/miejsce-kempingowe/:identifier()/recenzje",
    meta: { ...(index59eZ49_1yPXOPE2T6wLlMZsa5BjSA55VriH39YVlm2wMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/reviews/index.vue")
  },
  {
    name: "campsite-identifier-reviews___pt",
    path: "/pt/acampamento/:identifier()/rever",
    meta: { ...(index59eZ49_1yPXOPE2T6wLlMZsa5BjSA55VriH39YVlm2wMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/reviews/index.vue")
  },
  {
    name: "campsite-identifier-reviews___ro",
    path: "/ro/loc-de-campare/:identifier()/comentarii",
    meta: { ...(index59eZ49_1yPXOPE2T6wLlMZsa5BjSA55VriH39YVlm2wMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/reviews/index.vue")
  },
  {
    name: "campsite-identifier-reviews___ru",
    path: "/ru/%D0%BA%D0%B5%D0%BC%D0%BF%D0%B8%D0%BD%D0%B3-%D0%BB%D0%B0%D0%B3%D0%B5%D1%80%D1%8C/:identifier()/%D0%BE%D1%82%D0%B7%D1%8B%D0%B2%D1%8B",
    meta: { ...(index59eZ49_1yPXOPE2T6wLlMZsa5BjSA55VriH39YVlm2wMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/reviews/index.vue")
  },
  {
    name: "campsite-identifier-reviews___sk",
    path: "/sk/miesto-na-kempovanie/:identifier()/recenzia",
    meta: { ...(index59eZ49_1yPXOPE2T6wLlMZsa5BjSA55VriH39YVlm2wMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/reviews/index.vue")
  },
  {
    name: "campsite-identifier-reviews___sl",
    path: "/sl/kamp/:identifier()/pregledi",
    meta: { ...(index59eZ49_1yPXOPE2T6wLlMZsa5BjSA55VriH39YVlm2wMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/reviews/index.vue")
  },
  {
    name: "campsite-identifier-reviews___sr",
    path: "/sr/kamp-lokacija/:identifier()/mi%C5%A1ljenja",
    meta: { ...(index59eZ49_1yPXOPE2T6wLlMZsa5BjSA55VriH39YVlm2wMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/reviews/index.vue")
  },
  {
    name: "campsite-identifier-reviews___sv",
    path: "/sv/taltplats/:identifier()/recensioner",
    meta: { ...(index59eZ49_1yPXOPE2T6wLlMZsa5BjSA55VriH39YVlm2wMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/reviews/index.vue")
  },
  {
    name: "campsite-identifier-reviews___tr",
    path: "/tr/kamp-alani/:identifier()/yorumlar",
    meta: { ...(index59eZ49_1yPXOPE2T6wLlMZsa5BjSA55VriH39YVlm2wMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/reviews/index.vue")
  },
  {
    name: "campsite-identifier-rate-confirm___de",
    path: "/de/campingplatz/:identifier()/bewerten/best%C3%A4tigen",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/confirm/index.vue")
  },
  {
    name: "campsite-identifier-rate-confirm___en",
    path: "/en/campsite/:identifier()/rate/confirm",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/confirm/index.vue")
  },
  {
    name: "campsite-identifier-rate-confirm___nl",
    path: "/nl/kampeerplek/:identifier()/schatten/bevestigen",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/confirm/index.vue")
  },
  {
    name: "campsite-identifier-rate-confirm___fr",
    path: "/fr/emplacement-de-camping/:identifier()/%C3%A9valuer/confirmer",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/confirm/index.vue")
  },
  {
    name: "campsite-identifier-rate-confirm___it",
    path: "/it/campeggio/:identifier()/valutare/confermare",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/confirm/index.vue")
  },
  {
    name: "campsite-identifier-rate-confirm___es",
    path: "/es/camping/:identifier()/valorar/confirmar",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/confirm/index.vue")
  },
  {
    name: "campsite-identifier-rate-confirm___bg",
    path: "/bg/%D0%BB%D0%B0%D0%B3%D0%B5%D1%80/:identifier()/%D0%BE%D1%86%D0%B5%D0%BD%D0%B8/%D0%BF%D0%BE%D1%82%D0%B2%D1%8A%D1%80%D0%B6%D0%B4%D0%B0%D0%B2%D0%B0%D0%BD%D0%B5",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/confirm/index.vue")
  },
  {
    name: "campsite-identifier-rate-confirm___bs",
    path: "/bs/kamp-mjesto/:identifier()/procijeniti/potvrditi",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/confirm/index.vue")
  },
  {
    name: "campsite-identifier-rate-confirm___cs",
    path: "/cs/kemp/:identifier()/posoudit/potvrdit",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/confirm/index.vue")
  },
  {
    name: "campsite-identifier-rate-confirm___da",
    path: "/da/campinggrund/:identifier()/vurdere/bekr%C3%A6fte",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/confirm/index.vue")
  },
  {
    name: "campsite-identifier-rate-confirm___el",
    path: "/el/%CE%B8%CE%B5%CF%83%CE%B7-%CE%BA%CE%B1%CE%BC%CF%80%CE%B9%CE%BD%CE%B3%CE%BA/:identifier()/%CE%B1%CE%BE%CE%B9%CE%BF%CE%BB%CF%8C%CE%B3%CE%B7%CF%83%CE%B7/%CE%B5%CF%80%CE%B9%CE%B2%CE%B5%CE%B2%CE%B1%CE%B9%CF%8E%CE%BD%CF%89",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/confirm/index.vue")
  },
  {
    name: "campsite-identifier-rate-confirm___et",
    path: "/et/kamping/:identifier()/hindama/kinnitage",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/confirm/index.vue")
  },
  {
    name: "campsite-identifier-rate-confirm___fi",
    path: "/fi/leirintaalue/:identifier()/arvioida/vahvistaa",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/confirm/index.vue")
  },
  {
    name: "campsite-identifier-rate-confirm___hr",
    path: "/hr/mjesto-za-kampiranje/:identifier()/procijeniti/potvr%C4%91uju",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/confirm/index.vue")
  },
  {
    name: "campsite-identifier-rate-confirm___hu",
    path: "/hu/taborhely/:identifier()/%C3%A9rt%C3%A9keli/meger%C5%91s%C3%ADt",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/confirm/index.vue")
  },
  {
    name: "campsite-identifier-rate-confirm___lt",
    path: "/lt/stovyklaviete/:identifier()/%C4%AFvertinti/patvirtinti",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/confirm/index.vue")
  },
  {
    name: "campsite-identifier-rate-confirm___lv",
    path: "/lv/karavanu-vieta/:identifier()/noteikt/apstiprin%C4%81t",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/confirm/index.vue")
  },
  {
    name: "campsite-identifier-rate-confirm___no",
    path: "/no/campingplass/:identifier()/vurdere/bekrefte",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/confirm/index.vue")
  },
  {
    name: "campsite-identifier-rate-confirm___pl",
    path: "/pl/miejsce-kempingowe/:identifier()/oszacowa%C4%87/potwierdza%C4%87",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/confirm/index.vue")
  },
  {
    name: "campsite-identifier-rate-confirm___pt",
    path: "/pt/acampamento/:identifier()/avaliar/confirme",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/confirm/index.vue")
  },
  {
    name: "campsite-identifier-rate-confirm___ro",
    path: "/ro/loc-de-campare/:identifier()/evalua/a-confirma",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/confirm/index.vue")
  },
  {
    name: "campsite-identifier-rate-confirm___ru",
    path: "/ru/%D0%BA%D0%B5%D0%BC%D0%BF%D0%B8%D0%BD%D0%B3-%D0%BB%D0%B0%D0%B3%D0%B5%D1%80%D1%8C/:identifier()/%D0%BE%D1%86%D0%B5%D0%BD%D0%B8%D1%82%D1%8C/%D0%BF%D0%BE%D0%B4%D1%82%D0%B2%D0%B5%D1%80%D0%B6%D0%B4%D0%B5%D0%BD%D0%B8%D1%8F",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/confirm/index.vue")
  },
  {
    name: "campsite-identifier-rate-confirm___sk",
    path: "/sk/miesto-na-kempovanie/:identifier()/pos%C3%BAdi%C5%A5/potvrdit",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/confirm/index.vue")
  },
  {
    name: "campsite-identifier-rate-confirm___sl",
    path: "/sl/kamp/:identifier()/oceniti/potrdite",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/confirm/index.vue")
  },
  {
    name: "campsite-identifier-rate-confirm___sr",
    path: "/sr/kamp-lokacija/:identifier()/proceniti/%D0%9F%D0%BE%D1%82%D0%B2%D1%80%D0%B4%D0%B8",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/confirm/index.vue")
  },
  {
    name: "campsite-identifier-rate-confirm___sv",
    path: "/sv/taltplats/:identifier()/bed%C3%B6ma/bekr%C3%A4fta",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/confirm/index.vue")
  },
  {
    name: "campsite-identifier-rate-confirm___tr",
    path: "/tr/kamp-alani/:identifier()/belirlemek/onaylamak",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/confirm/index.vue")
  },
  {
    name: "campsite-identifier-reviews-id___de",
    path: "/de/campingplatz/:identifier()/bewertungen/:id()",
    meta: { ...(index43_QEHFhVIoNbpA0FStNhOpSHZu37M31C0BRkkqYYzQMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/reviews/[id]/index.vue")
  },
  {
    name: "campsite-identifier-reviews-id___en",
    path: "/en/campsite/:identifier()/reviews/:id()",
    meta: { ...(index43_QEHFhVIoNbpA0FStNhOpSHZu37M31C0BRkkqYYzQMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/reviews/[id]/index.vue")
  },
  {
    name: "campsite-identifier-reviews-id___nl",
    path: "/nl/kampeerplek/:identifier()/beoordelingen/:id()",
    meta: { ...(index43_QEHFhVIoNbpA0FStNhOpSHZu37M31C0BRkkqYYzQMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/reviews/[id]/index.vue")
  },
  {
    name: "campsite-identifier-reviews-id___fr",
    path: "/fr/emplacement-de-camping/:identifier()/critiques/:id()",
    meta: { ...(index43_QEHFhVIoNbpA0FStNhOpSHZu37M31C0BRkkqYYzQMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/reviews/[id]/index.vue")
  },
  {
    name: "campsite-identifier-reviews-id___it",
    path: "/it/campeggio/:identifier()/recensioni/:id()",
    meta: { ...(index43_QEHFhVIoNbpA0FStNhOpSHZu37M31C0BRkkqYYzQMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/reviews/[id]/index.vue")
  },
  {
    name: "campsite-identifier-reviews-id___es",
    path: "/es/camping/:identifier()/valoraciones/:id()",
    meta: { ...(index43_QEHFhVIoNbpA0FStNhOpSHZu37M31C0BRkkqYYzQMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/reviews/[id]/index.vue")
  },
  {
    name: "campsite-identifier-reviews-id___bg",
    path: "/bg/%D0%BB%D0%B0%D0%B3%D0%B5%D1%80/:identifier()/%D0%BC%D0%BD%D0%B5%D0%BD%D0%B8%D1%8F/:id()",
    meta: { ...(index43_QEHFhVIoNbpA0FStNhOpSHZu37M31C0BRkkqYYzQMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/reviews/[id]/index.vue")
  },
  {
    name: "campsite-identifier-reviews-id___bs",
    path: "/bs/kamp-mjesto/:identifier()/recenzije/:id()",
    meta: { ...(index43_QEHFhVIoNbpA0FStNhOpSHZu37M31C0BRkkqYYzQMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/reviews/[id]/index.vue")
  },
  {
    name: "campsite-identifier-reviews-id___cs",
    path: "/cs/kemp/:identifier()/recenze/:id()",
    meta: { ...(index43_QEHFhVIoNbpA0FStNhOpSHZu37M31C0BRkkqYYzQMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/reviews/[id]/index.vue")
  },
  {
    name: "campsite-identifier-reviews-id___da",
    path: "/da/campinggrund/:identifier()/anmeldelser/:id()",
    meta: { ...(index43_QEHFhVIoNbpA0FStNhOpSHZu37M31C0BRkkqYYzQMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/reviews/[id]/index.vue")
  },
  {
    name: "campsite-identifier-reviews-id___el",
    path: "/el/%CE%B8%CE%B5%CF%83%CE%B7-%CE%BA%CE%B1%CE%BC%CF%80%CE%B9%CE%BD%CE%B3%CE%BA/:identifier()/%CF%83%CF%87%CF%8C%CE%BB%CE%B9%CE%B1/:id()",
    meta: { ...(index43_QEHFhVIoNbpA0FStNhOpSHZu37M31C0BRkkqYYzQMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/reviews/[id]/index.vue")
  },
  {
    name: "campsite-identifier-reviews-id___et",
    path: "/et/kamping/:identifier()/%C3%BClevaated/:id()",
    meta: { ...(index43_QEHFhVIoNbpA0FStNhOpSHZu37M31C0BRkkqYYzQMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/reviews/[id]/index.vue")
  },
  {
    name: "campsite-identifier-reviews-id___fi",
    path: "/fi/leirintaalue/:identifier()/arvostelut/:id()",
    meta: { ...(index43_QEHFhVIoNbpA0FStNhOpSHZu37M31C0BRkkqYYzQMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/reviews/[id]/index.vue")
  },
  {
    name: "campsite-identifier-reviews-id___hr",
    path: "/hr/mjesto-za-kampiranje/:identifier()/recenzije/:id()",
    meta: { ...(index43_QEHFhVIoNbpA0FStNhOpSHZu37M31C0BRkkqYYzQMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/reviews/[id]/index.vue")
  },
  {
    name: "campsite-identifier-reviews-id___hu",
    path: "/hu/taborhely/:identifier()/v%C3%A9lem%C3%A9nyek/:id()",
    meta: { ...(index43_QEHFhVIoNbpA0FStNhOpSHZu37M31C0BRkkqYYzQMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/reviews/[id]/index.vue")
  },
  {
    name: "campsite-identifier-reviews-id___lt",
    path: "/lt/stovyklaviete/:identifier()/atsiliepimai/:id()",
    meta: { ...(index43_QEHFhVIoNbpA0FStNhOpSHZu37M31C0BRkkqYYzQMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/reviews/[id]/index.vue")
  },
  {
    name: "campsite-identifier-reviews-id___lv",
    path: "/lv/karavanu-vieta/:identifier()/atsauksmes/:id()",
    meta: { ...(index43_QEHFhVIoNbpA0FStNhOpSHZu37M31C0BRkkqYYzQMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/reviews/[id]/index.vue")
  },
  {
    name: "campsite-identifier-reviews-id___no",
    path: "/no/campingplass/:identifier()/anmeldelser/:id()",
    meta: { ...(index43_QEHFhVIoNbpA0FStNhOpSHZu37M31C0BRkkqYYzQMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/reviews/[id]/index.vue")
  },
  {
    name: "campsite-identifier-reviews-id___pl",
    path: "/pl/miejsce-kempingowe/:identifier()/recenzje/:id()",
    meta: { ...(index43_QEHFhVIoNbpA0FStNhOpSHZu37M31C0BRkkqYYzQMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/reviews/[id]/index.vue")
  },
  {
    name: "campsite-identifier-reviews-id___pt",
    path: "/pt/acampamento/:identifier()/rever/:id()",
    meta: { ...(index43_QEHFhVIoNbpA0FStNhOpSHZu37M31C0BRkkqYYzQMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/reviews/[id]/index.vue")
  },
  {
    name: "campsite-identifier-reviews-id___ro",
    path: "/ro/loc-de-campare/:identifier()/comentarii/:id()",
    meta: { ...(index43_QEHFhVIoNbpA0FStNhOpSHZu37M31C0BRkkqYYzQMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/reviews/[id]/index.vue")
  },
  {
    name: "campsite-identifier-reviews-id___ru",
    path: "/ru/%D0%BA%D0%B5%D0%BC%D0%BF%D0%B8%D0%BD%D0%B3-%D0%BB%D0%B0%D0%B3%D0%B5%D1%80%D1%8C/:identifier()/%D0%BE%D1%82%D0%B7%D1%8B%D0%B2%D1%8B/:id()",
    meta: { ...(index43_QEHFhVIoNbpA0FStNhOpSHZu37M31C0BRkkqYYzQMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/reviews/[id]/index.vue")
  },
  {
    name: "campsite-identifier-reviews-id___sk",
    path: "/sk/miesto-na-kempovanie/:identifier()/recenzia/:id()",
    meta: { ...(index43_QEHFhVIoNbpA0FStNhOpSHZu37M31C0BRkkqYYzQMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/reviews/[id]/index.vue")
  },
  {
    name: "campsite-identifier-reviews-id___sl",
    path: "/sl/kamp/:identifier()/pregledi/:id()",
    meta: { ...(index43_QEHFhVIoNbpA0FStNhOpSHZu37M31C0BRkkqYYzQMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/reviews/[id]/index.vue")
  },
  {
    name: "campsite-identifier-reviews-id___sr",
    path: "/sr/kamp-lokacija/:identifier()/mi%C5%A1ljenja/:id()",
    meta: { ...(index43_QEHFhVIoNbpA0FStNhOpSHZu37M31C0BRkkqYYzQMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/reviews/[id]/index.vue")
  },
  {
    name: "campsite-identifier-reviews-id___sv",
    path: "/sv/taltplats/:identifier()/recensioner/:id()",
    meta: { ...(index43_QEHFhVIoNbpA0FStNhOpSHZu37M31C0BRkkqYYzQMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/reviews/[id]/index.vue")
  },
  {
    name: "campsite-identifier-reviews-id___tr",
    path: "/tr/kamp-alani/:identifier()/yorumlar/:id()",
    meta: { ...(index43_QEHFhVIoNbpA0FStNhOpSHZu37M31C0BRkkqYYzQMeta || {}), ...{"middleware":["numeric-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/reviews/[id]/index.vue")
  },
  {
    name: "campsite-identifier-rating-widget___de",
    path: "/de/campingplatz/:identifier()/rating-widget",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rating-widget/index.vue")
  },
  {
    name: "campsite-identifier-rating-widget___en",
    path: "/en/campsite/:identifier()/rating-widget",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rating-widget/index.vue")
  },
  {
    name: "campsite-identifier-rating-widget___nl",
    path: "/nl/kampeerplek/:identifier()/rating-widget",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rating-widget/index.vue")
  },
  {
    name: "campsite-identifier-rating-widget___fr",
    path: "/fr/emplacement-de-camping/:identifier()/rating-widget",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rating-widget/index.vue")
  },
  {
    name: "campsite-identifier-rating-widget___it",
    path: "/it/campeggio/:identifier()/rating-widget",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rating-widget/index.vue")
  },
  {
    name: "campsite-identifier-rating-widget___es",
    path: "/es/camping/:identifier()/rating-widget",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rating-widget/index.vue")
  },
  {
    name: "campsite-identifier-rating-widget___bg",
    path: "/bg/%D0%BB%D0%B0%D0%B3%D0%B5%D1%80/:identifier()/rating-widget",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rating-widget/index.vue")
  },
  {
    name: "campsite-identifier-rating-widget___bs",
    path: "/bs/kamp-mjesto/:identifier()/rating-widget",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rating-widget/index.vue")
  },
  {
    name: "campsite-identifier-rating-widget___cs",
    path: "/cs/kemp/:identifier()/rating-widget",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rating-widget/index.vue")
  },
  {
    name: "campsite-identifier-rating-widget___da",
    path: "/da/campinggrund/:identifier()/rating-widget",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rating-widget/index.vue")
  },
  {
    name: "campsite-identifier-rating-widget___el",
    path: "/el/%CE%B8%CE%B5%CF%83%CE%B7-%CE%BA%CE%B1%CE%BC%CF%80%CE%B9%CE%BD%CE%B3%CE%BA/:identifier()/rating-widget",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rating-widget/index.vue")
  },
  {
    name: "campsite-identifier-rating-widget___et",
    path: "/et/kamping/:identifier()/rating-widget",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rating-widget/index.vue")
  },
  {
    name: "campsite-identifier-rating-widget___fi",
    path: "/fi/leirintaalue/:identifier()/rating-widget",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rating-widget/index.vue")
  },
  {
    name: "campsite-identifier-rating-widget___hr",
    path: "/hr/mjesto-za-kampiranje/:identifier()/rating-widget",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rating-widget/index.vue")
  },
  {
    name: "campsite-identifier-rating-widget___hu",
    path: "/hu/taborhely/:identifier()/rating-widget",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rating-widget/index.vue")
  },
  {
    name: "campsite-identifier-rating-widget___lt",
    path: "/lt/stovyklaviete/:identifier()/rating-widget",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rating-widget/index.vue")
  },
  {
    name: "campsite-identifier-rating-widget___lv",
    path: "/lv/karavanu-vieta/:identifier()/rating-widget",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rating-widget/index.vue")
  },
  {
    name: "campsite-identifier-rating-widget___no",
    path: "/no/campingplass/:identifier()/rating-widget",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rating-widget/index.vue")
  },
  {
    name: "campsite-identifier-rating-widget___pl",
    path: "/pl/miejsce-kempingowe/:identifier()/rating-widget",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rating-widget/index.vue")
  },
  {
    name: "campsite-identifier-rating-widget___pt",
    path: "/pt/acampamento/:identifier()/rating-widget",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rating-widget/index.vue")
  },
  {
    name: "campsite-identifier-rating-widget___ro",
    path: "/ro/loc-de-campare/:identifier()/rating-widget",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rating-widget/index.vue")
  },
  {
    name: "campsite-identifier-rating-widget___ru",
    path: "/ru/%D0%BA%D0%B5%D0%BC%D0%BF%D0%B8%D0%BD%D0%B3-%D0%BB%D0%B0%D0%B3%D0%B5%D1%80%D1%8C/:identifier()/rating-widget",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rating-widget/index.vue")
  },
  {
    name: "campsite-identifier-rating-widget___sk",
    path: "/sk/miesto-na-kempovanie/:identifier()/rating-widget",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rating-widget/index.vue")
  },
  {
    name: "campsite-identifier-rating-widget___sl",
    path: "/sl/kamp/:identifier()/rating-widget",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rating-widget/index.vue")
  },
  {
    name: "campsite-identifier-rating-widget___sr",
    path: "/sr/kamp-lokacija/:identifier()/rating-widget",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rating-widget/index.vue")
  },
  {
    name: "campsite-identifier-rating-widget___sv",
    path: "/sv/taltplats/:identifier()/rating-widget",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rating-widget/index.vue")
  },
  {
    name: "campsite-identifier-rating-widget___tr",
    path: "/tr/kamp-alani/:identifier()/rating-widget",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rating-widget/index.vue")
  },
  {
    name: "campsite-identifier-upload-images___de",
    path: "/de/campingplatz/:identifier()/hochladen/bilder",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/images/index.vue")
  },
  {
    name: "campsite-identifier-upload-images___en",
    path: "/en/campsite/:identifier()/upload/images",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/images/index.vue")
  },
  {
    name: "campsite-identifier-upload-images___nl",
    path: "/nl/kampeerplek/:identifier()/uploaden/afbeeldingen",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/images/index.vue")
  },
  {
    name: "campsite-identifier-upload-images___fr",
    path: "/fr/emplacement-de-camping/:identifier()/t%C3%A9l%C3%A9charger/images",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/images/index.vue")
  },
  {
    name: "campsite-identifier-upload-images___it",
    path: "/it/campeggio/:identifier()/upload/immagini",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/images/index.vue")
  },
  {
    name: "campsite-identifier-upload-images___es",
    path: "/es/camping/:identifier()/subir/im%C3%A1genes",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/images/index.vue")
  },
  {
    name: "campsite-identifier-upload-images___bg",
    path: "/bg/%D0%BB%D0%B0%D0%B3%D0%B5%D1%80/:identifier()/%D0%BA%D0%B0%D1%87%D0%B2%D0%B0%D0%BD%D0%B5/%D1%81%D0%BD%D0%B8%D0%BC%D0%BA%D0%B8",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/images/index.vue")
  },
  {
    name: "campsite-identifier-upload-images___bs",
    path: "/bs/kamp-mjesto/:identifier()/upload/slike",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/images/index.vue")
  },
  {
    name: "campsite-identifier-upload-images___cs",
    path: "/cs/kemp/:identifier()/nahr%C3%A1t/obrazy",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/images/index.vue")
  },
  {
    name: "campsite-identifier-upload-images___da",
    path: "/da/campinggrund/:identifier()/uploade/billeder",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/images/index.vue")
  },
  {
    name: "campsite-identifier-upload-images___el",
    path: "/el/%CE%B8%CE%B5%CF%83%CE%B7-%CE%BA%CE%B1%CE%BC%CF%80%CE%B9%CE%BD%CE%B3%CE%BA/:identifier()/upload/%CE%B5%CE%B9%CE%BA%CF%8C%CE%BD%CE%B5%CF%82",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/images/index.vue")
  },
  {
    name: "campsite-identifier-upload-images___et",
    path: "/et/kamping/:identifier()/laadi-%C3%BCles/pildid",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/images/index.vue")
  },
  {
    name: "campsite-identifier-upload-images___fi",
    path: "/fi/leirintaalue/:identifier()/upload/kuvat",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/images/index.vue")
  },
  {
    name: "campsite-identifier-upload-images___hr",
    path: "/hr/mjesto-za-kampiranje/:identifier()/uploadati/slike",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/images/index.vue")
  },
  {
    name: "campsite-identifier-upload-images___hu",
    path: "/hu/taborhely/:identifier()/upload/k%C3%A9pek",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/images/index.vue")
  },
  {
    name: "campsite-identifier-upload-images___lt",
    path: "/lt/stovyklaviete/:identifier()/%C4%AFkelti/paveiksl%C4%97liai",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/images/index.vue")
  },
  {
    name: "campsite-identifier-upload-images___lv",
    path: "/lv/karavanu-vieta/:identifier()/aug%C5%A1upiel%C4%81d%C4%93t/bildes",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/images/index.vue")
  },
  {
    name: "campsite-identifier-upload-images___no",
    path: "/no/campingplass/:identifier()/laste-opp/bilder",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/images/index.vue")
  },
  {
    name: "campsite-identifier-upload-images___pl",
    path: "/pl/miejsce-kempingowe/:identifier()/przekaza%C4%87-plik/zdj%C4%99cia",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/images/index.vue")
  },
  {
    name: "campsite-identifier-upload-images___pt",
    path: "/pt/acampamento/:identifier()/inserir/fotos",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/images/index.vue")
  },
  {
    name: "campsite-identifier-upload-images___ro",
    path: "/ro/loc-de-campare/:identifier()/%C3%AEnc%C4%83rcare/poze",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/images/index.vue")
  },
  {
    name: "campsite-identifier-upload-images___ru",
    path: "/ru/%D0%BA%D0%B5%D0%BC%D0%BF%D0%B8%D0%BD%D0%B3-%D0%BB%D0%B0%D0%B3%D0%B5%D1%80%D1%8C/:identifier()/%D0%B7%D0%B0%D0%B3%D1%80%D1%83%D0%B7%D0%BA%D0%B0/%D1%84%D0%BE%D1%82%D0%BE%D0%B3%D1%80%D0%B0%D1%84%D0%B8%D0%B8",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/images/index.vue")
  },
  {
    name: "campsite-identifier-upload-images___sk",
    path: "/sk/miesto-na-kempovanie/:identifier()/upload/fotografie",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/images/index.vue")
  },
  {
    name: "campsite-identifier-upload-images___sl",
    path: "/sl/kamp/:identifier()/upload/slike",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/images/index.vue")
  },
  {
    name: "campsite-identifier-upload-images___sr",
    path: "/sr/kamp-lokacija/:identifier()/upload/slike",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/images/index.vue")
  },
  {
    name: "campsite-identifier-upload-images___sv",
    path: "/sv/taltplats/:identifier()/ladda-upp/bilder",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/images/index.vue")
  },
  {
    name: "campsite-identifier-upload-images___tr",
    path: "/tr/kamp-alani/:identifier()/y%C3%BCklemek/resimler",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/images/index.vue")
  },
  {
    name: "campsite-identifier-upload-videos___de",
    path: "/de/campingplatz/:identifier()/hochladen/videos",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/videos/index.vue")
  },
  {
    name: "campsite-identifier-upload-videos___en",
    path: "/en/campsite/:identifier()/upload/videos",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/videos/index.vue")
  },
  {
    name: "campsite-identifier-upload-videos___nl",
    path: "/nl/kampeerplek/:identifier()/uploaden/videos",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/videos/index.vue")
  },
  {
    name: "campsite-identifier-upload-videos___fr",
    path: "/fr/emplacement-de-camping/:identifier()/t%C3%A9l%C3%A9charger/vid%C3%A9os",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/videos/index.vue")
  },
  {
    name: "campsite-identifier-upload-videos___it",
    path: "/it/campeggio/:identifier()/upload/video",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/videos/index.vue")
  },
  {
    name: "campsite-identifier-upload-videos___es",
    path: "/es/camping/:identifier()/subir/v%C3%ADdeos",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/videos/index.vue")
  },
  {
    name: "campsite-identifier-upload-videos___bg",
    path: "/bg/%D0%BB%D0%B0%D0%B3%D0%B5%D1%80/:identifier()/%D0%BA%D0%B0%D1%87%D0%B2%D0%B0%D0%BD%D0%B5/%D0%B2%D0%B8%D0%B4%D0%B5%D0%BE%D0%BA%D0%BB%D0%B8%D0%BF%D0%BE%D0%B2%D0%B5",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/videos/index.vue")
  },
  {
    name: "campsite-identifier-upload-videos___bs",
    path: "/bs/kamp-mjesto/:identifier()/upload/video",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/videos/index.vue")
  },
  {
    name: "campsite-identifier-upload-videos___cs",
    path: "/cs/kemp/:identifier()/nahr%C3%A1t/videa",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/videos/index.vue")
  },
  {
    name: "campsite-identifier-upload-videos___da",
    path: "/da/campinggrund/:identifier()/uploade/videoer",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/videos/index.vue")
  },
  {
    name: "campsite-identifier-upload-videos___el",
    path: "/el/%CE%B8%CE%B5%CF%83%CE%B7-%CE%BA%CE%B1%CE%BC%CF%80%CE%B9%CE%BD%CE%B3%CE%BA/:identifier()/upload/%CE%B2%CE%AF%CE%BD%CF%84%CE%B5%CE%BF",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/videos/index.vue")
  },
  {
    name: "campsite-identifier-upload-videos___et",
    path: "/et/kamping/:identifier()/laadi-%C3%BCles/videod",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/videos/index.vue")
  },
  {
    name: "campsite-identifier-upload-videos___fi",
    path: "/fi/leirintaalue/:identifier()/upload/videot",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/videos/index.vue")
  },
  {
    name: "campsite-identifier-upload-videos___hr",
    path: "/hr/mjesto-za-kampiranje/:identifier()/uploadati/video",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/videos/index.vue")
  },
  {
    name: "campsite-identifier-upload-videos___hu",
    path: "/hu/taborhely/:identifier()/upload/vide%C3%B3k",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/videos/index.vue")
  },
  {
    name: "campsite-identifier-upload-videos___lt",
    path: "/lt/stovyklaviete/:identifier()/%C4%AFkelti/vaizdo-%C4%AFra%C5%A1ai",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/videos/index.vue")
  },
  {
    name: "campsite-identifier-upload-videos___lv",
    path: "/lv/karavanu-vieta/:identifier()/aug%C5%A1upiel%C4%81d%C4%93t/video",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/videos/index.vue")
  },
  {
    name: "campsite-identifier-upload-videos___no",
    path: "/no/campingplass/:identifier()/laste-opp/videoer",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/videos/index.vue")
  },
  {
    name: "campsite-identifier-upload-videos___pl",
    path: "/pl/miejsce-kempingowe/:identifier()/przekaza%C4%87-plik/filmy",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/videos/index.vue")
  },
  {
    name: "campsite-identifier-upload-videos___pt",
    path: "/pt/acampamento/:identifier()/inserir/v%C3%ADdeos",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/videos/index.vue")
  },
  {
    name: "campsite-identifier-upload-videos___ro",
    path: "/ro/loc-de-campare/:identifier()/%C3%AEnc%C4%83rcare/videoclipuri",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/videos/index.vue")
  },
  {
    name: "campsite-identifier-upload-videos___ru",
    path: "/ru/%D0%BA%D0%B5%D0%BC%D0%BF%D0%B8%D0%BD%D0%B3-%D0%BB%D0%B0%D0%B3%D0%B5%D1%80%D1%8C/:identifier()/%D0%B7%D0%B0%D0%B3%D1%80%D1%83%D0%B7%D0%BA%D0%B0/%D0%B2%D0%B8%D0%B4%D0%B5%D0%BE",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/videos/index.vue")
  },
  {
    name: "campsite-identifier-upload-videos___sk",
    path: "/sk/miesto-na-kempovanie/:identifier()/upload/vide%C3%A1",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/videos/index.vue")
  },
  {
    name: "campsite-identifier-upload-videos___sl",
    path: "/sl/kamp/:identifier()/upload/videi",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/videos/index.vue")
  },
  {
    name: "campsite-identifier-upload-videos___sr",
    path: "/sr/kamp-lokacija/:identifier()/upload/video",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/videos/index.vue")
  },
  {
    name: "campsite-identifier-upload-videos___sv",
    path: "/sv/taltplats/:identifier()/ladda-upp/videor",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/videos/index.vue")
  },
  {
    name: "campsite-identifier-upload-videos___tr",
    path: "/tr/kamp-alani/:identifier()/y%C3%BCklemek/videolar",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/upload/videos/index.vue")
  },
  {
    name: "campsite-identifier-inquire-confirm___de",
    path: "/de/campingplatz/:identifier()/anfragen/best%C3%A4tigen",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/inquire/confirm/index.vue")
  },
  {
    name: "campsite-identifier-inquire-confirm___en",
    path: "/en/campsite/:identifier()/inquire/confirm",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/inquire/confirm/index.vue")
  },
  {
    name: "campsite-identifier-inquire-confirm___nl",
    path: "/nl/kampeerplek/:identifier()/informeren/bevestigen",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/inquire/confirm/index.vue")
  },
  {
    name: "campsite-identifier-inquire-confirm___fr",
    path: "/fr/emplacement-de-camping/:identifier()/renseigner/confirmer",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/inquire/confirm/index.vue")
  },
  {
    name: "campsite-identifier-inquire-confirm___it",
    path: "/it/campeggio/:identifier()/chiedere-informazioni/confermare",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/inquire/confirm/index.vue")
  },
  {
    name: "campsite-identifier-inquire-confirm___es",
    path: "/es/camping/:identifier()/preguntar/confirmar",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/inquire/confirm/index.vue")
  },
  {
    name: "campsite-identifier-inquire-confirm___bg",
    path: "/bg/%D0%BB%D0%B0%D0%B3%D0%B5%D1%80/:identifier()/%D0%B7%D0%B0%D0%BF%D0%B8%D1%82%D0%B2%D0%B0%D0%BD%D0%B5/%D0%BF%D0%BE%D1%82%D0%B2%D1%8A%D1%80%D0%B6%D0%B4%D0%B0%D0%B2%D0%B0%D0%BD%D0%B5",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/inquire/confirm/index.vue")
  },
  {
    name: "campsite-identifier-inquire-confirm___bs",
    path: "/bs/kamp-mjesto/:identifier()/raspitati-se/potvrditi",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/inquire/confirm/index.vue")
  },
  {
    name: "campsite-identifier-inquire-confirm___cs",
    path: "/cs/kemp/:identifier()/zeptat-se/potvrdit",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/inquire/confirm/index.vue")
  },
  {
    name: "campsite-identifier-inquire-confirm___da",
    path: "/da/campinggrund/:identifier()/forh%C3%B8re/bekr%C3%A6fte",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/inquire/confirm/index.vue")
  },
  {
    name: "campsite-identifier-inquire-confirm___el",
    path: "/el/%CE%B8%CE%B5%CF%83%CE%B7-%CE%BA%CE%B1%CE%BC%CF%80%CE%B9%CE%BD%CE%B3%CE%BA/:identifier()/%CF%81%CF%89%CF%84%CF%8E/%CE%B5%CF%80%CE%B9%CE%B2%CE%B5%CE%B2%CE%B1%CE%B9%CF%8E%CE%BD%CF%89",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/inquire/confirm/index.vue")
  },
  {
    name: "campsite-identifier-inquire-confirm___et",
    path: "/et/kamping/:identifier()/k%C3%BCsima/kinnitage",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/inquire/confirm/index.vue")
  },
  {
    name: "campsite-identifier-inquire-confirm___fi",
    path: "/fi/leirintaalue/:identifier()/tiedustella/vahvistaa",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/inquire/confirm/index.vue")
  },
  {
    name: "campsite-identifier-inquire-confirm___hr",
    path: "/hr/mjesto-za-kampiranje/:identifier()/raspitati/potvr%C4%91uju",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/inquire/confirm/index.vue")
  },
  {
    name: "campsite-identifier-inquire-confirm___hu",
    path: "/hu/taborhely/:identifier()/%C3%A9rdekl%C5%91dik/meger%C5%91s%C3%ADt",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/inquire/confirm/index.vue")
  },
  {
    name: "campsite-identifier-inquire-confirm___lt",
    path: "/lt/stovyklaviete/:identifier()/teirautis/patvirtinti",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/inquire/confirm/index.vue")
  },
  {
    name: "campsite-identifier-inquire-confirm___lv",
    path: "/lv/karavanu-vieta/:identifier()/jaut%C4%81t/apstiprin%C4%81t",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/inquire/confirm/index.vue")
  },
  {
    name: "campsite-identifier-inquire-confirm___no",
    path: "/no/campingplass/:identifier()/sp%C3%B8rre/bekrefte",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/inquire/confirm/index.vue")
  },
  {
    name: "campsite-identifier-inquire-confirm___pl",
    path: "/pl/miejsce-kempingowe/:identifier()/dowiadywa%C4%87-si%C4%99/potwierdza%C4%87",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/inquire/confirm/index.vue")
  },
  {
    name: "campsite-identifier-inquire-confirm___pt",
    path: "/pt/acampamento/:identifier()/investigar/confirme",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/inquire/confirm/index.vue")
  },
  {
    name: "campsite-identifier-inquire-confirm___ro",
    path: "/ro/loc-de-campare/:identifier()/%C3%AEntreba/a-confirma",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/inquire/confirm/index.vue")
  },
  {
    name: "campsite-identifier-inquire-confirm___ru",
    path: "/ru/%D0%BA%D0%B5%D0%BC%D0%BF%D0%B8%D0%BD%D0%B3-%D0%BB%D0%B0%D0%B3%D0%B5%D1%80%D1%8C/:identifier()/%D1%81%D0%BF%D1%80%D0%B0%D0%B2%D0%BA%D0%B8/%D0%BF%D0%BE%D0%B4%D1%82%D0%B2%D0%B5%D1%80%D0%B6%D0%B4%D0%B5%D0%BD%D0%B8%D1%8F",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/inquire/confirm/index.vue")
  },
  {
    name: "campsite-identifier-inquire-confirm___sk",
    path: "/sk/miesto-na-kempovanie/:identifier()/dotazovan%C3%ADm/potvrdit",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/inquire/confirm/index.vue")
  },
  {
    name: "campsite-identifier-inquire-confirm___sl",
    path: "/sl/kamp/:identifier()/poizvedovati/potrdite",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/inquire/confirm/index.vue")
  },
  {
    name: "campsite-identifier-inquire-confirm___sr",
    path: "/sr/kamp-lokacija/:identifier()/%D0%BF%D0%B8%D1%82%D0%B0%D1%82%D0%B8/%D0%9F%D0%BE%D1%82%D0%B2%D1%80%D0%B4%D0%B8",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/inquire/confirm/index.vue")
  },
  {
    name: "campsite-identifier-inquire-confirm___sv",
    path: "/sv/taltplats/:identifier()/fr%C3%A5ga/bekr%C3%A4fta",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/inquire/confirm/index.vue")
  },
  {
    name: "campsite-identifier-inquire-confirm___tr",
    path: "/tr/kamp-alani/:identifier()/sormak/onaylamak",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/inquire/confirm/index.vue")
  },
  {
    name: "campsite-identifier-rate-confirm-oauth___de",
    path: "/de/campingplatz/:identifier()/bewerten/best%C3%A4tigen/oauth",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/confirm/oauth/index.vue")
  },
  {
    name: "campsite-identifier-rate-confirm-oauth___en",
    path: "/en/campsite/:identifier()/rate/confirm/oauth",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/confirm/oauth/index.vue")
  },
  {
    name: "campsite-identifier-rate-confirm-oauth___nl",
    path: "/nl/kampeerplek/:identifier()/schatten/bevestigen/oauth",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/confirm/oauth/index.vue")
  },
  {
    name: "campsite-identifier-rate-confirm-oauth___fr",
    path: "/fr/emplacement-de-camping/:identifier()/%C3%A9valuer/confirmer/oauth",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/confirm/oauth/index.vue")
  },
  {
    name: "campsite-identifier-rate-confirm-oauth___it",
    path: "/it/campeggio/:identifier()/valutare/confermare/oauth",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/confirm/oauth/index.vue")
  },
  {
    name: "campsite-identifier-rate-confirm-oauth___es",
    path: "/es/camping/:identifier()/valorar/confirmar/oauth",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/confirm/oauth/index.vue")
  },
  {
    name: "campsite-identifier-rate-confirm-oauth___bg",
    path: "/bg/%D0%BB%D0%B0%D0%B3%D0%B5%D1%80/:identifier()/%D0%BE%D1%86%D0%B5%D0%BD%D0%B8/%D0%BF%D0%BE%D1%82%D0%B2%D1%8A%D1%80%D0%B6%D0%B4%D0%B0%D0%B2%D0%B0%D0%BD%D0%B5/oauth",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/confirm/oauth/index.vue")
  },
  {
    name: "campsite-identifier-rate-confirm-oauth___bs",
    path: "/bs/kamp-mjesto/:identifier()/procijeniti/potvrditi/oauth",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/confirm/oauth/index.vue")
  },
  {
    name: "campsite-identifier-rate-confirm-oauth___cs",
    path: "/cs/kemp/:identifier()/posoudit/potvrdit/oauth",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/confirm/oauth/index.vue")
  },
  {
    name: "campsite-identifier-rate-confirm-oauth___da",
    path: "/da/campinggrund/:identifier()/vurdere/bekr%C3%A6fte/oauth",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/confirm/oauth/index.vue")
  },
  {
    name: "campsite-identifier-rate-confirm-oauth___el",
    path: "/el/%CE%B8%CE%B5%CF%83%CE%B7-%CE%BA%CE%B1%CE%BC%CF%80%CE%B9%CE%BD%CE%B3%CE%BA/:identifier()/%CE%B1%CE%BE%CE%B9%CE%BF%CE%BB%CF%8C%CE%B3%CE%B7%CF%83%CE%B7/%CE%B5%CF%80%CE%B9%CE%B2%CE%B5%CE%B2%CE%B1%CE%B9%CF%8E%CE%BD%CF%89/oauth",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/confirm/oauth/index.vue")
  },
  {
    name: "campsite-identifier-rate-confirm-oauth___et",
    path: "/et/kamping/:identifier()/hindama/kinnitage/oauth",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/confirm/oauth/index.vue")
  },
  {
    name: "campsite-identifier-rate-confirm-oauth___fi",
    path: "/fi/leirintaalue/:identifier()/arvioida/vahvistaa/oauth",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/confirm/oauth/index.vue")
  },
  {
    name: "campsite-identifier-rate-confirm-oauth___hr",
    path: "/hr/mjesto-za-kampiranje/:identifier()/procijeniti/potvr%C4%91uju/oauth",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/confirm/oauth/index.vue")
  },
  {
    name: "campsite-identifier-rate-confirm-oauth___hu",
    path: "/hu/taborhely/:identifier()/%C3%A9rt%C3%A9keli/meger%C5%91s%C3%ADt/oauth",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/confirm/oauth/index.vue")
  },
  {
    name: "campsite-identifier-rate-confirm-oauth___lt",
    path: "/lt/stovyklaviete/:identifier()/%C4%AFvertinti/patvirtinti/oauth",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/confirm/oauth/index.vue")
  },
  {
    name: "campsite-identifier-rate-confirm-oauth___lv",
    path: "/lv/karavanu-vieta/:identifier()/noteikt/apstiprin%C4%81t/oauth",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/confirm/oauth/index.vue")
  },
  {
    name: "campsite-identifier-rate-confirm-oauth___no",
    path: "/no/campingplass/:identifier()/vurdere/bekrefte/oauth",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/confirm/oauth/index.vue")
  },
  {
    name: "campsite-identifier-rate-confirm-oauth___pl",
    path: "/pl/miejsce-kempingowe/:identifier()/oszacowa%C4%87/potwierdza%C4%87/oauth",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/confirm/oauth/index.vue")
  },
  {
    name: "campsite-identifier-rate-confirm-oauth___pt",
    path: "/pt/acampamento/:identifier()/avaliar/confirme/oauth",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/confirm/oauth/index.vue")
  },
  {
    name: "campsite-identifier-rate-confirm-oauth___ro",
    path: "/ro/loc-de-campare/:identifier()/evalua/a-confirma/oauth",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/confirm/oauth/index.vue")
  },
  {
    name: "campsite-identifier-rate-confirm-oauth___ru",
    path: "/ru/%D0%BA%D0%B5%D0%BC%D0%BF%D0%B8%D0%BD%D0%B3-%D0%BB%D0%B0%D0%B3%D0%B5%D1%80%D1%8C/:identifier()/%D0%BE%D1%86%D0%B5%D0%BD%D0%B8%D1%82%D1%8C/%D0%BF%D0%BE%D0%B4%D1%82%D0%B2%D0%B5%D1%80%D0%B6%D0%B4%D0%B5%D0%BD%D0%B8%D1%8F/oauth",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/confirm/oauth/index.vue")
  },
  {
    name: "campsite-identifier-rate-confirm-oauth___sk",
    path: "/sk/miesto-na-kempovanie/:identifier()/pos%C3%BAdi%C5%A5/potvrdit/oauth",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/confirm/oauth/index.vue")
  },
  {
    name: "campsite-identifier-rate-confirm-oauth___sl",
    path: "/sl/kamp/:identifier()/oceniti/potrdite/oauth",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/confirm/oauth/index.vue")
  },
  {
    name: "campsite-identifier-rate-confirm-oauth___sr",
    path: "/sr/kamp-lokacija/:identifier()/proceniti/%D0%9F%D0%BE%D1%82%D0%B2%D1%80%D0%B4%D0%B8/oauth",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/confirm/oauth/index.vue")
  },
  {
    name: "campsite-identifier-rate-confirm-oauth___sv",
    path: "/sv/taltplats/:identifier()/bed%C3%B6ma/bekr%C3%A4fta/oauth",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/confirm/oauth/index.vue")
  },
  {
    name: "campsite-identifier-rate-confirm-oauth___tr",
    path: "/tr/kamp-alani/:identifier()/belirlemek/onaylamak/oauth",
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/campsite/[identifier]/rate/confirm/oauth/index.vue")
  },
  {
    name: "country-countrySlug-federalStateSlug___de",
    path: "/de/land/:countrySlug()/:federalStateSlug()",
    meta: { ...(indexyJ8HlGWn1PMMReseE7aiA36_ER__KVh0D1lfQufjyaoMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/[countrySlug]/[federalStateSlug]/index.vue")
  },
  {
    name: "country-countrySlug-federalStateSlug___en",
    path: "/en/country/:countrySlug()/:federalStateSlug()",
    meta: { ...(indexyJ8HlGWn1PMMReseE7aiA36_ER__KVh0D1lfQufjyaoMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/[countrySlug]/[federalStateSlug]/index.vue")
  },
  {
    name: "country-countrySlug-federalStateSlug___nl",
    path: "/nl/land/:countrySlug()/:federalStateSlug()",
    meta: { ...(indexyJ8HlGWn1PMMReseE7aiA36_ER__KVh0D1lfQufjyaoMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/[countrySlug]/[federalStateSlug]/index.vue")
  },
  {
    name: "country-countrySlug-federalStateSlug___fr",
    path: "/fr/pays/:countrySlug()/:federalStateSlug()",
    meta: { ...(indexyJ8HlGWn1PMMReseE7aiA36_ER__KVh0D1lfQufjyaoMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/[countrySlug]/[federalStateSlug]/index.vue")
  },
  {
    name: "country-countrySlug-federalStateSlug___it",
    path: "/it/paese/:countrySlug()/:federalStateSlug()",
    meta: { ...(indexyJ8HlGWn1PMMReseE7aiA36_ER__KVh0D1lfQufjyaoMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/[countrySlug]/[federalStateSlug]/index.vue")
  },
  {
    name: "country-countrySlug-federalStateSlug___es",
    path: "/es/pa%C3%ADs/:countrySlug()/:federalStateSlug()",
    meta: { ...(indexyJ8HlGWn1PMMReseE7aiA36_ER__KVh0D1lfQufjyaoMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/[countrySlug]/[federalStateSlug]/index.vue")
  },
  {
    name: "country-countrySlug-federalStateSlug___bg",
    path: "/bg/%D0%B4%D1%8A%D1%80%D0%B6%D0%B0%D0%B2%D0%B0/:countrySlug()/:federalStateSlug()",
    meta: { ...(indexyJ8HlGWn1PMMReseE7aiA36_ER__KVh0D1lfQufjyaoMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/[countrySlug]/[federalStateSlug]/index.vue")
  },
  {
    name: "country-countrySlug-federalStateSlug___bs",
    path: "/bs/drzava/:countrySlug()/:federalStateSlug()",
    meta: { ...(indexyJ8HlGWn1PMMReseE7aiA36_ER__KVh0D1lfQufjyaoMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/[countrySlug]/[federalStateSlug]/index.vue")
  },
  {
    name: "country-countrySlug-federalStateSlug___cs",
    path: "/cs/zeme/:countrySlug()/:federalStateSlug()",
    meta: { ...(indexyJ8HlGWn1PMMReseE7aiA36_ER__KVh0D1lfQufjyaoMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/[countrySlug]/[federalStateSlug]/index.vue")
  },
  {
    name: "country-countrySlug-federalStateSlug___da",
    path: "/da/land/:countrySlug()/:federalStateSlug()",
    meta: { ...(indexyJ8HlGWn1PMMReseE7aiA36_ER__KVh0D1lfQufjyaoMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/[countrySlug]/[federalStateSlug]/index.vue")
  },
  {
    name: "country-countrySlug-federalStateSlug___el",
    path: "/el/%CF%87%CF%89%CF%81%CE%B1/:countrySlug()/:federalStateSlug()",
    meta: { ...(indexyJ8HlGWn1PMMReseE7aiA36_ER__KVh0D1lfQufjyaoMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/[countrySlug]/[federalStateSlug]/index.vue")
  },
  {
    name: "country-countrySlug-federalStateSlug___et",
    path: "/et/riik/:countrySlug()/:federalStateSlug()",
    meta: { ...(indexyJ8HlGWn1PMMReseE7aiA36_ER__KVh0D1lfQufjyaoMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/[countrySlug]/[federalStateSlug]/index.vue")
  },
  {
    name: "country-countrySlug-federalStateSlug___fi",
    path: "/fi/maa/:countrySlug()/:federalStateSlug()",
    meta: { ...(indexyJ8HlGWn1PMMReseE7aiA36_ER__KVh0D1lfQufjyaoMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/[countrySlug]/[federalStateSlug]/index.vue")
  },
  {
    name: "country-countrySlug-federalStateSlug___hr",
    path: "/hr/zemlja/:countrySlug()/:federalStateSlug()",
    meta: { ...(indexyJ8HlGWn1PMMReseE7aiA36_ER__KVh0D1lfQufjyaoMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/[countrySlug]/[federalStateSlug]/index.vue")
  },
  {
    name: "country-countrySlug-federalStateSlug___hu",
    path: "/hu/orszag/:countrySlug()/:federalStateSlug()",
    meta: { ...(indexyJ8HlGWn1PMMReseE7aiA36_ER__KVh0D1lfQufjyaoMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/[countrySlug]/[federalStateSlug]/index.vue")
  },
  {
    name: "country-countrySlug-federalStateSlug___lt",
    path: "/lt/salis/:countrySlug()/:federalStateSlug()",
    meta: { ...(indexyJ8HlGWn1PMMReseE7aiA36_ER__KVh0D1lfQufjyaoMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/[countrySlug]/[federalStateSlug]/index.vue")
  },
  {
    name: "country-countrySlug-federalStateSlug___lv",
    path: "/lv/valsts/:countrySlug()/:federalStateSlug()",
    meta: { ...(indexyJ8HlGWn1PMMReseE7aiA36_ER__KVh0D1lfQufjyaoMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/[countrySlug]/[federalStateSlug]/index.vue")
  },
  {
    name: "country-countrySlug-federalStateSlug___no",
    path: "/no/land/:countrySlug()/:federalStateSlug()",
    meta: { ...(indexyJ8HlGWn1PMMReseE7aiA36_ER__KVh0D1lfQufjyaoMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/[countrySlug]/[federalStateSlug]/index.vue")
  },
  {
    name: "country-countrySlug-federalStateSlug___pl",
    path: "/pl/kraj/:countrySlug()/:federalStateSlug()",
    meta: { ...(indexyJ8HlGWn1PMMReseE7aiA36_ER__KVh0D1lfQufjyaoMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/[countrySlug]/[federalStateSlug]/index.vue")
  },
  {
    name: "country-countrySlug-federalStateSlug___pt",
    path: "/pt/pais/:countrySlug()/:federalStateSlug()",
    meta: { ...(indexyJ8HlGWn1PMMReseE7aiA36_ER__KVh0D1lfQufjyaoMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/[countrySlug]/[federalStateSlug]/index.vue")
  },
  {
    name: "country-countrySlug-federalStateSlug___ro",
    path: "/ro/tara/:countrySlug()/:federalStateSlug()",
    meta: { ...(indexyJ8HlGWn1PMMReseE7aiA36_ER__KVh0D1lfQufjyaoMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/[countrySlug]/[federalStateSlug]/index.vue")
  },
  {
    name: "country-countrySlug-federalStateSlug___ru",
    path: "/ru/%D1%81%D1%82%D1%80%D0%B0%D0%BD%D0%B0/:countrySlug()/:federalStateSlug()",
    meta: { ...(indexyJ8HlGWn1PMMReseE7aiA36_ER__KVh0D1lfQufjyaoMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/[countrySlug]/[federalStateSlug]/index.vue")
  },
  {
    name: "country-countrySlug-federalStateSlug___sk",
    path: "/sk/krajina/:countrySlug()/:federalStateSlug()",
    meta: { ...(indexyJ8HlGWn1PMMReseE7aiA36_ER__KVh0D1lfQufjyaoMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/[countrySlug]/[federalStateSlug]/index.vue")
  },
  {
    name: "country-countrySlug-federalStateSlug___sl",
    path: "/sl/drzava/:countrySlug()/:federalStateSlug()",
    meta: { ...(indexyJ8HlGWn1PMMReseE7aiA36_ER__KVh0D1lfQufjyaoMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/[countrySlug]/[federalStateSlug]/index.vue")
  },
  {
    name: "country-countrySlug-federalStateSlug___sr",
    path: "/sr/zemlja/:countrySlug()/:federalStateSlug()",
    meta: { ...(indexyJ8HlGWn1PMMReseE7aiA36_ER__KVh0D1lfQufjyaoMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/[countrySlug]/[federalStateSlug]/index.vue")
  },
  {
    name: "country-countrySlug-federalStateSlug___sv",
    path: "/sv/land/:countrySlug()/:federalStateSlug()",
    meta: { ...(indexyJ8HlGWn1PMMReseE7aiA36_ER__KVh0D1lfQufjyaoMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/[countrySlug]/[federalStateSlug]/index.vue")
  },
  {
    name: "country-countrySlug-federalStateSlug___tr",
    path: "/tr/ulke/:countrySlug()/:federalStateSlug()",
    meta: { ...(indexyJ8HlGWn1PMMReseE7aiA36_ER__KVh0D1lfQufjyaoMeta || {}), ...{"middleware":["location-translations-redirect"]} },
    component: () => import("/builds/campinginfo/civ2-nuxt-3/app/pages/country/[countrySlug]/[federalStateSlug]/index.vue")
  }
]